// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AcquisitionSourcesReportData, AcquisitionSourcesReportErrors, AcquisitionSourcesReportResponses, ActivateConsumerData, ActivateConsumerErrors, ActivateConsumerInLoyaltyData, ActivateConsumerInLoyaltyErrors, ActivateConsumerInLoyaltyResponses, ActivateConsumerResponses, AnonymizeConsumerData, AnonymizeConsumerErrors, AnonymizeConsumerManuallyData, AnonymizeConsumerManuallyErrors, AnonymizeConsumerManuallyResponses, AnonymizeConsumerResponses, AnonymizeConsumersData, AnonymizeConsumersErrors, AnonymizeConsumersResponses, AssignCustomerToInventoryItemData, AssignCustomerToInventoryItemErrors, AssignCustomerToInventoryItemResponses, AssignReferrerData, AssignReferrerErrors, AssignReferrerResponses, AttachConsumerToInventoryItemData, AttachConsumerToInventoryItemErrors, AttachConsumerToInventoryItemResponses, AuthenticateData, AuthenticateErrors, AuthenticateResponses, CancelBusBatchData, CancelBusBatchErrors, CancelBusBatchResponses, CanceledWarrantyData, CanceledWarrantyErrors, CanceledWarrantyResponses, CancelLeadData, CancelLeadErrors, CancelLeadResponses, CancelLendingData, CancelLendingErrors, CancelLendingResponses, CancelOrderData, CancelOrderErrors, CancelOrderResponses, CancelSubscriptionData, CancelSubscriptionErrors, CancelSubscriptionResponses, CdpResyncData, CdpResyncErrors, CdpResyncResponses, ChangeConsumerEmailData, ChangeConsumerEmailErrors, ChangeConsumerEmailResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ChangePhoneData, ChangePhoneErrors, ChangePhoneResponses, CheckIfHasHiddenVerificationControllerData, CheckIfHasHiddenVerificationControllerErrors, CheckIfHasHiddenVerificationControllerResponses, CheckRewardEligibilityControllerData, CheckRewardEligibilityControllerErrors, CheckRewardEligibilityControllerResponses, ConnectAdapterData, ConnectAdapterErrors, ConnectAdapterResponses, ConsumerCanceledData, ConsumerCanceledErrors, ConsumerCanceledResponses, ConsumersReportData, ConsumersReportErrors, ConsumersReportResponses, ConsumerSubscribePushNotificationData, ConsumerSubscribePushNotificationErrors, ConsumerSubscribePushNotificationResponses, ConsumerUnsubscribeAllPushNotificationsData, ConsumerUnsubscribeAllPushNotificationsErrors, ConsumerUnsubscribeAllPushNotificationsResponses, ConsumerUnsubscribePushNotificationData, ConsumerUnsubscribePushNotificationErrors, ConsumerUnsubscribePushNotificationResponses, CreateActionData, CreateActionErrors, CreateActionResponses, CreateActionVerificationData, CreateActionVerificationErrors, CreateActionVerificationResponses, CreateAdapterData, CreateAdapterErrors, CreateAdapterResponses, CreateAuthorisationData, CreateAuthorisationErrors, CreateAuthorisationResponses, CreateBulkOneTimeLimitedTokenRequestData, CreateBulkOneTimeLimitedTokenRequestErrors, CreateBulkOneTimeLimitedTokenRequestResponses, CreateBulkShortUrlData, CreateBulkShortUrlErrors, CreateBulkShortUrlResponses, CreateCancellationRequestData, CreateCancellationRequestErrors, CreateCancellationRequestResponses, CreateConfigurationData, CreateConfigurationErrors, CreateConfigurationItemData, CreateConfigurationItemErrors, CreateConfigurationItemResponses, CreateConfigurationResponses, CreateConsumerOneTimeLimitedTokenData, CreateConsumerOneTimeLimitedTokenErrors, CreateConsumerOneTimeLimitedTokenResponses, CreateContestData, CreateContestErrors, CreateContestResponses, CreateCouponGenerationWebhookData, CreateCouponGenerationWebhookErrors, CreateCouponGenerationWebhookResponses, CreateDeliveryEventData, CreateDeliveryEventErrors, CreateDeliveryEventResponses, CreateDeviceRegistrationActionData, CreateDeviceRegistrationActionErrors, CreateDeviceRegistrationActionResponses, CreateEntraApplicationData, CreateEntraApplicationErrors, CreateEntraApplicationResponses, CreateFeedbackVoteData, CreateFeedbackVoteErrors, CreateFeedbackVoteResponses, CreateLeadData, CreateLeadErrors, CreateLeadResponses, CreateOfflineCampaignCouponData, CreateOfflineCampaignCouponErrors, CreateOfflineCampaignCouponResponses, CreateOfflineCampaignData, CreateOfflineCampaignErrors, CreateOfflineCampaignResponses, CreateOneTimeLimitedTokenRequestData, CreateOneTimeLimitedTokenRequestErrors, CreateOneTimeLimitedTokenRequestResponses, CreateOrderActionData, CreateOrderActionErrors, CreateOrderActionResponses, CreateOrderData, CreateOrderErrors, CreateOrderResponses, CreateOrUpdateMarketingCommunicationData, CreateOrUpdateMarketingCommunicationErrors, CreateOrUpdateMarketingCommunicationResponses, CreatePaymentData, CreatePaymentErrors, CreatePaymentMethodData, CreatePaymentMethodErrors, CreatePaymentMethodResponses, CreatePaymentResponses, CreatePaymentSessionData, CreatePaymentSessionErrors, CreatePaymentSessionResponses, CreatePlatformConfigurationData, CreatePlatformConfigurationErrors, CreatePlatformConfigurationResponses, CreateQuizzesUserSubmissionData, CreateQuizzesUserSubmissionErrors, CreateQuizzesUserSubmissionResponses, CreateRefundData, CreateRefundErrors, CreateRefundResponses, CreateReviewEventData, CreateReviewEventErrors, CreateReviewEventResponses, CreateRewardRedeemedWebhookData, CreateRewardRedeemedWebhookErrors, CreateRewardRedeemedWebhookResponses, CreateRewardWebhookData, CreateRewardWebhookErrors, CreateRewardWebhookResponses, CreateRoleData, CreateRoleErrors, CreateRoleResponses, CreateSearchableItemData, CreateSearchableItemErrors, CreateSearchableItemResponses, CreateShortUrlData, CreateShortUrlErrors, CreateShortUrlResponses, CreateSubscriptionData, CreateSubscriptionErrors, CreateSubscriptionResponses, CreateTenantData, CreateTenantErrors, CreateTenantResponses, CreateTradeInData, CreateTradeInErrors, CreateTradeInResponses, CreateTransferWebhookData, CreateTransferWebhookErrors, CreateTransferWebhookResponses, CreateWebhookData, CreateWebhookErrors, CreateWebhookResponses, CreateWithdrawData, CreateWithdrawErrors, CreateWithdrawResponses, CreateYggWebhookData, CreateYggWebhookErrors, CreateYggWebhookResponses, DataSubjectAccessRequestData, DataSubjectAccessRequestErrors, DataSubjectAccessRequestResponses, DeactivateConsumerData, DeactivateConsumerErrors, DeactivateConsumerInLoyaltyData, DeactivateConsumerInLoyaltyErrors, DeactivateConsumerInLoyaltyResponses, DeactivateConsumerResponses, DecreaseConsumerPointsData, DecreaseConsumerPointsErrors, DecreaseConsumerPointsResponses, DecryptDataData, DecryptDataErrors, DecryptDataResponses, DeleteAdapterData, DeleteAdapterErrors, DeleteAdapterResponses, DeleteAddressData, DeleteAddressErrors, DeleteAddressResponses, DeleteAllSearchableData, DeleteAllSearchableErrors, DeleteAllSearchableResponses, DeleteConfigurationData, DeleteConfigurationErrors, DeleteConfigurationItemData, DeleteConfigurationItemErrors, DeleteConfigurationItemResponses, DeleteConfigurationResponses, DeleteCustomAttributeData, DeleteCustomAttributeErrors, DeleteCustomAttributeResponses, DeleteDraftChangeSetsData, DeleteDraftChangeSetsErrors, DeleteDraftChangeSetsResponses, DeleteEntityControllerData, DeleteEntityControllerErrors, DeleteEntityControllerResponses, DeleteFieldControllerData, DeleteFieldControllerErrors, DeleteFieldControllerResponses, DeleteMarketingCommunicationData, DeleteMarketingCommunicationErrors, DeleteMarketingCommunicationResponses, DeleteOfflineCampaignCouponData, DeleteOfflineCampaignCouponErrors, DeleteOfflineCampaignCouponResponses, DeleteOfflineCampaignData, DeleteOfflineCampaignErrors, DeleteOfflineCampaignResponses, DeleteOneTimeLimitedTokenRequestData, DeleteOneTimeLimitedTokenRequestErrors, DeleteOneTimeLimitedTokenRequestResponses, DeletePaymentMethodData, DeletePaymentMethodErrors, DeletePaymentMethodResponses, DeletePlatformConfigurationData, DeletePlatformConfigurationErrors, DeletePlatformConfigurationResponses, DeletePrefixMappingData, DeletePrefixMappingErrors, DeletePrefixMappingResponses, DeleteProfileData, DeleteProfileErrors, DeleteProfileResponses, DeletePromotionData, DeletePromotionErrors, DeletePromotionResponses, DeleteRewardWebhookData, DeleteRewardWebhookErrors, DeleteRewardWebhookResponses, DeleteRoleData, DeleteRoleErrors, DeleteRoleResponses, DeleteSearchableData, DeleteSearchableErrors, DeleteSearchableResponses, DeleteShortUrlData, DeleteShortUrlErrors, DeleteShortUrlResponses, DeleteSpexClusterData, DeleteSpexClusterErrors, DeleteSpexClusterResponses, DeleteTenantData, DeleteTenantErrors, DeleteTenantResponses, DeleteWebhookData, DeleteWebhookErrors, DeleteWebhookResponses, DeleteWithdrawData, DeleteWithdrawErrors, DeleteWithdrawResponses, DeprecatedCreateCodeRouteData, DeprecatedCreateCodeRouteErrors, DeprecatedCreateCodeRouteResponses, DeprecatedDeleteCodeRouteData, DeprecatedDeleteCodeRouteErrors, DeprecatedDeleteCodeRouteResponses, DeprecatedGetCodeRouteData, DeprecatedGetCodeRouteErrors, DeprecatedGetCodeRouteResponses, DeprecatedListCodeRoutesData, DeprecatedListCodeRoutesErrors, DeprecatedListCodeRoutesResponses, DeprecatedUpdateCodeRouteData, DeprecatedUpdateCodeRouteErrors, DeprecatedUpdateCodeRouteResponses, DeprecatedUpdateConsentsData, DeprecatedUpdateConsentsErrors, DeprecatedUpdateConsentsResponses, DeprecatedUpdateFullProfileData, DeprecatedUpdateFullProfileErrors, DeprecatedUpdateFullProfileResponses, DiffSchemaData, DiffSchemaResponses, DisconnectAdapterData, DisconnectAdapterErrors, DisconnectAdapterResponses, DisInventoryItemCodeValidationData, DisInventoryItemCodeValidationErrors, DisInventoryItemCodeValidationResponses, DiSv1PayloadImportData, DiSv1PayloadImportErrors, DiSv1PayloadImportResponses, EncryptDataData, EncryptDataErrors, EncryptDataResponses, EntraAuthCallbackData, EntraAuthCallbackErrors, EntraAuthCallbackResponses, EntraAuthRedirectData, EntraAuthRedirectErrors, ExportInventoryItemsReportData, ExportInventoryItemsReportErrors, ExportInventoryItemsReportResponses, ExportLendingsData, ExportLendingsErrors, ExportLendingsResponses, ExportStartInventoryData, ExportStartInventoryErrors, ExportStartInventoryResponses, ExportTenantData, ExportTenantErrors, ExportTenantResponses, ExternalProviderRewardUpdatedData, ExternalProviderRewardUpdatedErrors, ExternalProviderRewardUpdatedResponses, FindActionVerificationItemData, FindActionVerificationItemErrors, FindActionVerificationItemResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GenerateBulkCouponsData, GenerateBulkCouponsErrors, GenerateBulkCouponsResponses, GenerateS2sTokenData, GenerateS2sTokenErrors, GenerateS2sTokenResponses, GenerateSingleCouponData, GenerateSingleCouponErrors, GenerateSingleCouponResponses, GenerateWalletPassData, GenerateWalletPassErrors, GenerateWalletPassResponses, GetAchievementsData, GetAchievementsErrors, GetAchievementsResponses, GetActionData, GetActionErrors, GetActionResponses, GetAdapterData, GetAdapterErrors, GetAdapterResponses, GetAgeVerificationDateControllerData, GetAgeVerificationDateControllerErrors, GetAgeVerificationDateControllerResponses, GetAgeVerificationResultControllerData, GetAgeVerificationResultControllerErrors, GetAgeVerificationResultControllerResponses, GetAvailableConsentsData, GetAvailableConsentsErrors, GetAvailableConsentsResponses, GetAvailableSurveysForConsumerData, GetAvailableSurveysForConsumerErrors, GetAvailableSurveysForConsumerResponses, GetAvailableVerificationMethodsControllerData, GetAvailableVerificationMethodsControllerErrors, GetAvailableVerificationMethodsControllerResponses, GetBulkCouponBatchData, GetBulkCouponBatchErrors, GetBulkCouponBatchResponses, GetBulkCouponBatchStatusData, GetBulkCouponBatchStatusErrors, GetBulkCouponBatchStatusResponses, GetBuyPrizeData, GetBuyPrizeErrors, GetBuyPrizeResponses, GetCampaignEventReportData, GetCampaignEventReportErrors, GetCampaignEventReportResponses, GetComplaintsData, GetComplaintsErrors, GetComplaintsResponses, GetConfigurationData, GetConfigurationErrors, GetConfigurationItemData, GetConfigurationItemErrors, GetConfigurationItemResponses, GetConfigurationResponses, GetConfigurationSchemasData, GetConfigurationSchemasErrors, GetConfigurationSchemasResponses, GetConsumerEligibleRewardsData, GetConsumerEligibleRewardsErrors, GetConsumerEligibleRewardsForServiceData, GetConsumerEligibleRewardsForServiceErrors, GetConsumerEligibleRewardsForServiceResponses, GetConsumerEligibleRewardsResponses, GetConsumerLoyaltyProfileData, GetConsumerLoyaltyProfileErrors, GetConsumerLoyaltyProfileResponses, GetConsumerLoyaltyProfileS2sData, GetConsumerLoyaltyProfileS2sErrors, GetConsumerLoyaltyProfileS2sResponses, GetConsumerNetworkPointsData, GetConsumerNetworkPointsErrors, GetConsumerNetworkPointsResponses, GetConsumerOrderData, GetConsumerOrderErrors, GetConsumerOrderResponses, GetConsumerPointsHistoryData, GetConsumerPointsHistoryErrors, GetConsumerPointsHistoryResponses, GetConsumerRewardData, GetConsumerRewardErrors, GetConsumerRewardResponses, GetConsumerRewardsCampaignsOrPrizesData, GetConsumerRewardsCampaignsOrPrizesErrors, GetConsumerRewardsCampaignsOrPrizesResponses, GetConsumerRewardsData, GetConsumerRewardsErrors, GetConsumerRewardsResponses, GetConsumerSubscriptionData, GetConsumerSubscriptionErrors, GetConsumerSubscriptionResponses, GetConsumerSurveyStatusData, GetConsumerSurveyStatusErrors, GetConsumerSurveyStatusResponses, GetConsumerTierData, GetConsumerTierErrors, GetConsumerTierResponses, GetConsumerTierS2sData, GetConsumerTierS2sErrors, GetConsumerTierS2sResponses, GetContestStatusData, GetContestStatusErrors, GetContestStatusResponses, GetCreditCardData, GetCreditCardErrors, GetCreditCardResponses, GetCreditCardsData, GetCreditCardsErrors, GetCreditCardsResponses, GetDisInventoryItemData, GetDisInventoryItemErrors, GetDisInventoryItemResponses, GetEarningRuleByNameData, GetEarningRuleByNameErrors, GetEarningRuleByNameResponses, GetEarningsForConsumerData, GetEarningsForConsumerErrors, GetEarningsForConsumerResponses, GetEligibleDevicesData, GetEligibleDevicesErrors, GetEligibleDevicesResponses, GetEntityAuditTrailData, GetEntityAuditTrailErrors, GetEntityAuditTrailResponses, GetErrorCodesData, GetErrorCodesResponses, GetExternalProvidersData, GetExternalProvidersErrors, GetExternalProvidersResponses, GetFeedbackVoteData, GetFeedbackVoteErrors, GetFeedbackVoteResponses, GetFeedbackVoteSummaryData, GetFeedbackVoteSummaryErrors, GetFeedbackVoteSummaryResponses, GetHealthCheckData, GetHealthCheckErrors, GetHealthCheckResponses, GetIncumbentProfilesData, GetIncumbentProfilesErrors, GetIncumbentProfilesResponses, GetIntegrationTestResultSummaryControllerData, GetIntegrationTestResultSummaryControllerErrors, GetIntegrationTestResultSummaryControllerResponses, GetInventoryExportData, GetInventoryExportErrors, GetInventoryExportResponses, GetInventoryItemData, GetInventoryItemErrors, GetInventoryItemResponses, GetInvoiceData, GetInvoiceErrors, GetInvoiceResponses, GetLeadData, GetLeadErrors, GetLeadResponses, GetLoyaltyPublicDomainConfigurationData, GetLoyaltyPublicDomainConfigurationErrors, GetLoyaltyPublicDomainConfigurationResponses, GetMarketingCommunicationsData, GetMarketingCommunicationsErrors, GetMarketingCommunicationsResponses, GetOfflineCampaignCouponData, GetOfflineCampaignCouponErrors, GetOfflineCampaignCouponResponses, GetOfflineCampaignData, GetOfflineCampaignErrors, GetOfflineCampaignResponses, GetOktaAuthCallbackData, GetOktaAuthCallbackErrors, GetOktaAuthCallbackResponses, GetOrderData, GetOrderErrors, GetOrderResponses, GetOrdersData, GetOrdersErrors, GetOrdersResponses, GetPaymentData, GetPaymentErrors, GetPaymentExternalDataData, GetPaymentExternalDataErrors, GetPaymentExternalDataResponses, GetPaymentMethodClientData, GetPaymentMethodClientErrors, GetPaymentMethodClientResponses, GetPaymentMethodData, GetPaymentMethodErrors, GetPaymentMethodResponses, GetPaymentMethodsData, GetPaymentMethodsErrors, GetPaymentMethodsResponses, GetPaymentResponses, GetPlatformConfigurationData, GetPlatformConfigurationErrors, GetPlatformConfigurationResponses, GetPlatformVersionData, GetPlatformVersionErrors, GetPlatformVersionResponses, GetPrefixMappingData, GetPrefixMappingErrors, GetPrefixMappingResponses, GetPrefixMappingsData, GetPrefixMappingsErrors, GetPrefixMappingsResponses, GetProductData, GetProductErrors, GetProductResponses, GetProfileData, GetProfileErrors, GetProfileForServiceData, GetProfileForServiceErrors, GetProfileForServiceResponses, GetProfileResponses, GetPromotionData, GetPromotionErrors, GetPromotionResponses, GetPurchaseData, GetPurchaseErrors, GetPurchaseResponses, GetPushSubscriptionStatusData, GetPushSubscriptionStatusErrors, GetPushSubscriptionStatusResponses, GetQrCodeDetailsData, GetQrCodeDetailsErrors, GetQrCodeDetailsResponses, GetQrCodeReadData, GetQrCodeReadErrors, GetQrCodeReadResponses, GetQuizzesUserSubmissionsData, GetQuizzesUserSubmissionsErrors, GetQuizzesUserSubmissionsResponses, GetRedeemRewardData, GetRedeemRewardErrors, GetRedeemRewardResponses, GetRefundData, GetRefundErrors, GetRefundResponses, GetRewardData, GetRewardErrors, GetRewardExtendedData, GetRewardExtendedErrors, GetRewardExtendedResponses, GetRewardResponses, GetScenarioCodesData, GetScenarioCodesErrors, GetScenarioCodesResponses, GetSearchableData, GetSearchableErrors, GetSearchableResponses, GetSessionsData, GetSessionsErrors, GetSessionsResponses, GetShortUrlData, GetShortUrlErrors, GetShortUrlResponses, GetSpexClusterData, GetSpexClusterErrors, GetSpexClusterResponses, GetSpexClustersData, GetSpexClustersErrors, GetSpexClustersResponses, GetSubscriptionConfigurationData, GetSubscriptionConfigurationErrors, GetSubscriptionConfigurationResponses, GetSubscriptionEventsData, GetSubscriptionEventsErrors, GetSubscriptionEventsResponses, GetTenantData, GetTenantErrors, GetTenantHealthCheckData, GetTenantHealthCheckErrors, GetTenantHealthCheckResponses, GetTenantMappingByAccessTokenData, GetTenantMappingByAccessTokenErrors, GetTenantMappingByAccessTokenResponses, GetTenantMappingByTenantCodeData, GetTenantMappingByTenantCodeErrors, GetTenantMappingByTenantCodeResponses, GetTenantMappingsByServiceData, GetTenantMappingsByServiceErrors, GetTenantMappingsByServiceForAccessTokenData, GetTenantMappingsByServiceForAccessTokenErrors, GetTenantMappingsByServiceForAccessTokenResponses, GetTenantMappingsByServiceResponses, GetTenantResponses, GetTiersData, GetTiersErrors, GetTiersResponses, GetTiersServiceData, GetTiersServiceErrors, GetTiersServiceResponses, GetTokenData, GetTokenErrors, GetTokenResponses, GetTradeInPublicDomainConfigurationData, GetTradeInPublicDomainConfigurationErrors, GetTradeInPublicDomainConfigurationResponses, GetTransactionData, GetTransactionErrors, GetTransactionResponses, GetUsersConsentsData, GetUsersConsentsErrors, GetUsersConsentsResponses, GetUsersPublicDomainConfigurationData, GetUsersPublicDomainConfigurationErrors, GetUsersPublicDomainConfigurationResponses, GetUserSubscriptionData, GetUserSubscriptionErrors, GetUserSubscriptionResponses, GetWarrantyData, GetWarrantyErrors, GetWarrantyResponses, GetWebhookData, GetWebhookErrors, GetWebhookResponses, GetWithdrawCandidatesData, GetWithdrawCandidatesErrors, GetWithdrawCandidatesResponses, GetWithdrawData, GetWithdrawErrors, GetWithdrawResponses, HoldOrderData, HoldOrderErrors, HoldOrderResponses, ImportDeleteProductData, ImportDeleteProductErrors, ImportDeleteProductResponses, ImportDiSv1StorageData, ImportDiSv1StorageErrors, ImportDiSv1StorageResponses, ImportInventoryErrorsData, ImportInventoryErrorsErrors, ImportInventoryErrorsResponses, ImportInventoryItemsData, ImportInventoryItemsErrors, ImportInventoryItemsResponses, ImportMagentoOrderData, ImportMagentoOrderErrors, ImportMagentoOrderResponses, ImportOfflineCampaignCouponsData, ImportOfflineCampaignCouponsErrors, ImportOfflineCampaignCouponsResponses, ImportPackCodesData, ImportPackCodesErrors, ImportPackCodesResponses, ImportProductData, ImportProductErrors, ImportProductResponses, ImportReviewsData, ImportReviewsErrors, ImportReviewsResponses, ImportTenantData, ImportTenantErrors, ImportTenantResponses, IncreaseConsumerPointsData, IncreaseConsumerPointsErrors, IncreaseConsumerPointsResponses, IncreaseCouponsToRewardData, IncreaseCouponsToRewardErrors, IncreaseCouponsToRewardResponses, IndexDraftSchemaEntitiesData, IndexDraftSchemaEntitiesErrors, IndexDraftSchemaEntitiesResponses, IndexSchemaEntitiesData, IndexSchemaEntitiesErrors, IndexSchemaEntitiesResponses, IndexTenantSchemaEntitiesData, IndexTenantSchemaEntitiesErrors, IndexTenantSchemaEntitiesResponses, IngestClickBatchData, IngestClickBatchErrors, IngestClickBatchResponses, InitAuthenticationData, InitAuthenticationErrors, InitAuthenticationResponses, InitializeAddingConsumerPointsByTypeData, InitializeAddingConsumerPointsByTypeErrors, InitializeAddingConsumerPointsByTypeResponses, InitializeAsynchronousAgeVerificationControllerData, InitializeAsynchronousAgeVerificationControllerErrors, InitializeAsynchronousAgeVerificationControllerResponses, InitializeAuthorisationData, InitializeAuthorisationErrors, InitializeAuthorisationResponses, InitializeBulkEventsData, InitializeBulkEventsErrors, InitializeBulkEventsResponses, InitializeConsumerSurveyStartedControllerData, InitializeConsumerSurveyStartedControllerErrors, InitializeConsumerSurveyStartedControllerResponses, InitializeIndexesData, InitializeIndexesErrors, InitializeIndexesResponses, InitializePaymentSessionData, InitializePaymentSessionErrors, InitializePaymentSessionResponses, InitRegistrationData, InitRegistrationErrors, InitRegistrationResponses, InternalGetActionVerificationCodeData, InternalGetActionVerificationCodeErrors, InternalGetActionVerificationCodeResponses, InternalStoreAgeVerificationItemData, InternalStoreAgeVerificationItemErrors, InternalStoreAgeVerificationItemResponses, InvalidateTranslationsCacheData, InvalidateTranslationsCacheErrors, InvalidateTranslationsCacheResponses, InventoryImportReportData, InventoryImportReportErrors, InventoryImportReportResponses, InventoryItemsReportData, InventoryItemsReportErrors, InventoryItemsReportResponses, IsAttachableToConsumerData, IsAttachableToConsumerErrors, IsAttachableToConsumerResponses, IsConsumerEligibleForSubscriptionsData, IsConsumerEligibleForSubscriptionsErrors, IsConsumerEligibleForSubscriptionsResponses, IsConsumerEligibleForTradeInData, IsConsumerEligibleForTradeInErrors, IsConsumerEligibleForTradeInResponses, IsEligibleForTrialData, IsEligibleForTrialErrors, IsEligibleForTrialResponses, IsShippingAddressEligibleForRemovalData, IsShippingAddressEligibleForRemovalErrors, IsShippingAddressEligibleForRemovalResponses, IsWithdrawEligibleData, IsWithdrawEligibleErrors, IsWithdrawEligibleResponses, ListActionsData, ListActionsErrors, ListActionsResponses, ListActivityLogsData, ListActivityLogsErrors, ListActivityLogsResponses, ListAdaptersData, ListAdaptersErrors, ListAdaptersResponses, ListAllTradeInsData, ListAllTradeInsErrors, ListAllTradeInsResponses, ListAnonymizationsData, ListAnonymizationsErrors, ListAnonymizationsResponses, ListAuditTrailData, ListAuditTrailErrors, ListAuditTrailResponses, ListBusinessMetricsData, ListBusinessMetricsErrors, ListBusinessMetricsResponses, ListClicksByCodeData, ListClicksByCodeErrors, ListClicksByCodeResponses, ListClicksData, ListClicksErrors, ListClicksResponses, ListConfigurationsData, ListConfigurationsErrors, ListConfigurationsResponses, ListConsumerDeactivationsData, ListConsumerDeactivationsErrors, ListConsumerDeactivationsResponses, ListConsumerSubscriptionsData, ListConsumerSubscriptionsErrors, ListConsumerSubscriptionsResponses, ListCouponUsersData, ListCouponUsersErrors, ListCouponUsersResponses, ListDeliveryLogsData, ListDeliveryLogsErrors, ListDeliveryLogsResponses, ListDeviceRegistrationHistoryData, ListDeviceRegistrationHistoryErrors, ListDeviceRegistrationHistoryResponses, ListDisInventoryItemForUserData, ListDisInventoryItemForUserErrors, ListDisInventoryItemForUserResponses, ListEarningsData, ListEarningsErrors, ListEarningsResponses, ListErrorCodesData, ListErrorCodesResponses, ListIntegrationTestResultData, ListIntegrationTestResultErrors, ListIntegrationTestResultResponses, ListInventoryExportsData, ListInventoryExportsErrors, ListInventoryExportsResponses, ListInventoryItemData, ListInventoryItemErrors, ListInventoryItemResponses, ListLeadsData, ListLeadsErrors, ListLeadsResponses, ListOfflineCampaignCuponsData, ListOfflineCampaignCuponsErrors, ListOfflineCampaignCuponsResponses, ListOfflineCampaignsData, ListOfflineCampaignsErrors, ListOfflineCampaignsResponses, ListPermissionsData, ListPermissionsErrors, ListPermissionsResponses, ListPlatformConfigurationData, ListPlatformConfigurationErrors, ListPlatformConfigurationResponses, ListPlatformVersionsData, ListPlatformVersionsErrors, ListPlatformVersionsResponses, ListProductData, ListProductErrors, ListProductResponses, ListPromotionsData, ListPromotionsErrors, ListPromotionsResponses, ListPublicPlatformConfigurationData, ListPublicPlatformConfigurationErrors, ListPublicPlatformConfigurationResponses, ListPurchasesData, ListPurchasesErrors, ListPurchasesResponses, ListReviewsData, ListReviewsErrors, ListReviewsResponses, ListRewardConsumersData, ListRewardConsumersErrors, ListRewardConsumersResponses, ListRewardFiltersData, ListRewardFiltersErrors, ListRewardFiltersResponses, ListRewardsData, ListRewardsErrors, ListRewardsExtendedData, ListRewardsExtendedErrors, ListRewardsExtendedResponses, ListRewardsResponses, ListRolesData, ListRolesErrors, ListRolesResponses, ListSearchablesData, ListSearchablesErrors, ListSearchablesResponses, ListSearchSearchableItemData, ListSearchSearchableItemErrors, ListSearchSearchableItemResponses, ListShortUrlData, ListShortUrlErrors, ListShortUrlResponses, ListsPromotionAttributesData, ListsPromotionAttributesErrors, ListsPromotionAttributesResponses, ListTenantMappingsData, ListTenantMappingsErrors, ListTenantMappingsResponses, ListTenantPublicConfigurationsData, ListTenantPublicConfigurationsErrors, ListTenantPublicConfigurationsResponses, ListTenantsData, ListTenantsErrors, ListTenantsResponses, ListTenantsVersionsData, ListTenantsVersionsErrors, ListTenantsVersionsResponses, ListTenantVersionHistoryData, ListTenantVersionHistoryErrors, ListTenantVersionHistoryResponses, ListTrialsData, ListTrialsErrors, ListTrialsResponses, ListUserInventoryItemData, ListUserInventoryItemErrors, ListUserInventoryItemResponses, ListValidationLogData, ListValidationLogErrors, ListValidationLogResponses, ListWebhookEventValuesData, ListWebhookEventValuesResponses, ListWebhooksData, ListWebhooksErrors, ListWebhooksResponses, ListWebhookTransformersData, ListWebhookTransformersErrors, ListWebhookTransformersResponses, ListWithdrawsData, ListWithdrawsErrors, ListWithdrawsResponses, LogoutData, LogoutErrors, LogoutResponses, MarkConsumersAsExternalAgeVerifiedData, MarkConsumersAsExternalAgeVerifiedErrors, MarkConsumersAsExternalAgeVerifiedResponses, MeProductRegisterData, MeProductRegisterErrors, MeProductRegisterResponses, MessagingEventCreateMessageData, MessagingEventCreateMessageErrors, MessagingEventCreateMessageResponses, MessagingFormCreateMessageData, MessagingFormCreateMessageErrors, MessagingFormCreateMessageResponses, MessagingLocalTemplateCreateData, MessagingLocalTemplateCreateErrors, MessagingLocalTemplateCreateResponses, MessagingLocalTemplateDeleteData, MessagingLocalTemplateDeleteErrors, MessagingLocalTemplateDeleteResponses, MessagingLocalTemplateDetailData, MessagingLocalTemplateDetailErrors, MessagingLocalTemplateDetailResponses, MessagingLocalTemplatesListData, MessagingLocalTemplatesListErrors, MessagingLocalTemplatesListResponses, MessagingLocalTemplatesUpdateData, MessagingLocalTemplatesUpdateErrors, MessagingLocalTemplatesUpdateResponses, MigrateOktaApplicationToEntraData, MigrateOktaApplicationToEntraErrors, MigrateOktaApplicationToEntraResponses, OktaAuthRedirectData, OktaAuthRedirectErrors, PaySessionData, PaySessionErrors, PaySessionResponses, PerformAgeVerificationControllerData, PerformAgeVerificationControllerErrors, PerformAgeVerificationControllerResponses, PlatformProfileAnonymizationData, PlatformProfileAnonymizationErrors, PlatformProfileAnonymizationResponses, PlatformSyncConsumerToCdpData, PlatformSyncConsumerToCdpErrors, PlatformSyncConsumerToCdpResponses, PrefixesReportData, PrefixesReportErrors, PrefixesReportResponses, PrefixMappingData, PrefixMappingErrors, PrefixMappingResponses, ProcessAnonymizedCdpProfilesData, ProcessAnonymizedCdpProfilesErrors, ProcessAnonymizedCdpProfilesResponses, ProcessKakaoUnlinkRequestData, ProcessKakaoUnlinkRequestErrors, ProcessKakaoUnlinkRequestResponses, ProductRegisterData, ProductRegisterErrors, ProductRegisterResponses, PublishSchemaControllerData, PublishSchemaControllerErrors, PublishSchemaControllerResponses, ReferralsRegisterOfflineActionData, ReferralsRegisterOfflineActionErrors, ReferralsRegisterOfflineActionResponses, RegisterCasConsumerWebhookData, RegisterCasConsumerWebhookErrors, RegisterCasConsumerWebhookResponses, RegisterData, RegisterDiSv1InventoryItemData, RegisterDiSv1InventoryItemErrors, RegisterDiSv1InventoryItemResponses, RegisterErrors, RegisterInventoryItemData, RegisterInventoryItemErrors, RegisterInventoryItemForGuestData, RegisterInventoryItemForGuestErrors, RegisterInventoryItemForGuestResponses, RegisterInventoryItemResponses, RegisterResponses, RegisterUserInventoryItemData, RegisterUserInventoryItemErrors, RegisterUserInventoryItemResponses, RejectOrderData, RejectOrderErrors, RejectOrderResponses, RequestExternalCouponData, RequestExternalCouponErrors, RequestExternalCouponResponses, RequestPromoCodeData, RequestPromoCodeErrors, RequestPromoCodeResponses, RestoreInventoryItemData, RestoreInventoryItemErrors, RestoreInventoryItemResponses, RollbackSchemaControllerData, RollbackSchemaControllerErrors, RollbackSchemaControllerResponses, SendPaymentLinkData, SendPaymentLinkErrors, SendPaymentLinkResponses, SendPushNotificationData, SendPushNotificationErrors, SendPushNotificationResponses, SendSinglePushNotificationData, SendSinglePushNotificationErrors, SendSinglePushNotificationResponses, ServiceRequestExternalCouponData, ServiceRequestExternalCouponErrors, ServiceRequestExternalCouponResponses, SetDefaultAddressData, SetDefaultAddressErrors, SetDefaultAddressResponses, SetPasswordData, SetPasswordErrors, SetPasswordResponses, ShowCampaignDeliveryLogsData, ShowCampaignDeliveryLogsErrors, ShowCampaignDeliveryLogsResponses, ShowLendingData, ShowLendingErrors, ShowLendingResponses, ShowSchemaDraftEntityData, ShowSchemaDraftEntityErrors, ShowSchemaDraftEntityResponses, ShowSchemaDraftFieldData, ShowSchemaDraftFieldErrors, ShowSchemaDraftFieldResponses, ShowSchemaEntityData, ShowSchemaEntityErrors, ShowSchemaEntityResponses, ShowSchemaFieldData, ShowSchemaFieldErrors, ShowSchemaFieldResponses, SpexClusterData, SpexClusterErrors, SpexClusterResponses, StoreAddressData, StoreAddressErrors, StoreAddressResponses, StoreEntityControllerData, StoreEntityControllerErrors, StoreEntityControllerResponses, StoreEntityOverrideControllerData, StoreEntityOverrideControllerErrors, StoreEntityOverrideControllerResponses, StoreFieldControllerData, StoreFieldControllerErrors, StoreFieldControllerResponses, StoreFieldOverrideControllerData, StoreFieldOverrideControllerErrors, StoreFieldOverrideControllerResponses, StoreGuidedTrialData, StoreGuidedTrialErrors, StoreGuidedTrialResponses, StoreLendingData, StoreLendingErrors, StoreLendingResponses, StoreOfflineOrderData, StoreOfflineOrderErrors, StoreOfflineOrderResponses, StorePromotionData, StorePromotionErrors, StorePromotionResponses, StoreSourceOfBusinessData, StoreSourceOfBusinessErrors, StoreSourceOfBusinessResponses, StreamedWalletPassData, StreamedWalletPassErrors, StreamedWalletPassResponses, SurveyMonkeyAssignWorkgroupToTenantData, SurveyMonkeyAssignWorkgroupToTenantErrors, SurveyMonkeyAssignWorkgroupToTenantResponses, SurveyMonkeyBackfillSurveyResponsesData, SurveyMonkeyBackfillSurveyResponsesErrors, SurveyMonkeyBackfillSurveyResponsesResponses, SurveyMonkeyCollectorCreatedWebhookData, SurveyMonkeyCollectorCreatedWebhookErrors, SurveyMonkeyCollectorCreatedWebhookResponses, SurveyMonkeyCollectorDeletedWebhookData, SurveyMonkeyCollectorDeletedWebhookErrors, SurveyMonkeyCollectorDeletedWebhookResponses, SurveyMonkeyCollectorUpdatedWebhookData, SurveyMonkeyCollectorUpdatedWebhookErrors, SurveyMonkeyCollectorUpdatedWebhookResponses, SurveyMonkeyFetchSurveyResponsesData, SurveyMonkeyFetchSurveyResponsesErrors, SurveyMonkeyFetchSurveyResponsesResponses, SurveyMonkeyGetTenantWorkgroupsData, SurveyMonkeyGetTenantWorkgroupsErrors, SurveyMonkeyGetTenantWorkgroupsResponses, SurveyMonkeyRemoveWorkgroupFromTenantData, SurveyMonkeyRemoveWorkgroupFromTenantErrors, SurveyMonkeyRemoveWorkgroupFromTenantResponses, SurveyMonkeyResponseCompletedWebhookData, SurveyMonkeyResponseCompletedWebhookErrors, SurveyMonkeyResponseCompletedWebhookResponses, SurveyMonkeySurveyDeletedWebhookData, SurveyMonkeySurveyDeletedWebhookErrors, SurveyMonkeySurveyDeletedWebhookResponses, SurveyMonkeySurveyUpdatedWebhookData, SurveyMonkeySurveyUpdatedWebhookErrors, SurveyMonkeySurveyUpdatedWebhookResponses, SyncExternalRewardsData, SyncExternalRewardsErrors, SyncExternalRewardsResponses, SynchronizeAddressesData, SynchronizeAddressesErrors, SynchronizeAddressesResponses, SyncOpenLoyaltyRewardsData, SyncOpenLoyaltyRewardsErrors, SyncOpenLoyaltyRewardsResponses, TriggerDoiData, TriggerDoiErrors, TriggerDoiResponses, UnholdOrderData, UnholdOrderErrors, UnholdOrderResponses, UnlockConsumerLoginData, UnlockConsumerLoginErrors, UnlockConsumerLoginResponses, UnregisterInventoryItemData, UnregisterInventoryItemErrors, UnregisterInventoryItemForConsumerData, UnregisterInventoryItemForConsumerErrors, UnregisterInventoryItemForConsumerResponses, UnregisterInventoryItemForGuestData, UnregisterInventoryItemForGuestErrors, UnregisterInventoryItemForGuestResponses, UnregisterInventoryItemResponses, UnsubscribeAllPushNotificationsData, UnsubscribeAllPushNotificationsErrors, UnsubscribeAllPushNotificationsResponses, UnsubscribeMarketingCommunicationData, UnsubscribeMarketingCommunicationErrors, UnsubscribeMarketingCommunicationResponses, UnsubscribePushNotificationData, UnsubscribePushNotificationErrors, UnsubscribePushNotificationResponses, UpdateActionData, UpdateActionErrors, UpdateActionResponses, UpdateAdapterData, UpdateAdapterErrors, UpdateAdapterResponses, UpdateAddressData, UpdateAddressErrors, UpdateAddressResponses, UpdateArticleReadData, UpdateArticleReadErrors, UpdateArticleReadResponses, UpdateBulkConfigurationItemsData, UpdateBulkConfigurationItemsErrors, UpdateBulkConfigurationItemsResponses, UpdateBurnOfflineCampaignCouponWebhookData, UpdateBurnOfflineCampaignCouponWebhookErrors, UpdateBurnOfflineCampaignCouponWebhookResponses, UpdateCmStatusWebhookData, UpdateCmStatusWebhookErrors, UpdateCmStatusWebhookResponses, UpdateConfigurationData, UpdateConfigurationErrors, UpdateConfigurationItemData, UpdateConfigurationItemErrors, UpdateConfigurationItemResponses, UpdateConfigurationResponses, UpdateConsentsData, UpdateConsentsErrors, UpdateConsentsResponses, UpdateConsumerUuidControllerData, UpdateConsumerUuidControllerErrors, UpdateConsumerUuidControllerResponses, UpdateCustomAttributeData, UpdateCustomAttributeErrors, UpdateCustomAttributeResponses, UpdateCustomAttributesData, UpdateCustomAttributesErrors, UpdateCustomAttributesResponses, UpdateEmailOfMarketingCommunicationsData, UpdateEmailOfMarketingCommunicationsErrors, UpdateEmailOfMarketingCommunicationsResponses, UpdateEmailRequestData, UpdateEmailRequestErrors, UpdateEmailRequestResponses, UpdateEntityControllerData, UpdateEntityControllerErrors, UpdateEntityControllerResponses, UpdateFieldControllerData, UpdateFieldControllerErrors, UpdateFieldControllerResponses, UpdateFullProfileData, UpdateFullProfileErrors, UpdateFullProfileResponses, UpdateIntegrationTestResultData, UpdateIntegrationTestResultErrors, UpdateIntegrationTestResultResponses, UpdateLeadData, UpdateLeadErrors, UpdateLeadResponses, UpdateLendingData, UpdateLendingErrors, UpdateLendingResponses, UpdateLevelChangedWebhookData, UpdateLevelChangedWebhookErrors, UpdateLevelChangedWebhookResponses, UpdateOfflineCampaignCouponData, UpdateOfflineCampaignCouponErrors, UpdateOfflineCampaignCouponResponses, UpdateOfflineCampaignData, UpdateOfflineCampaignErrors, UpdateOfflineCampaignResponses, UpdateOneTrustPreferenceWebhookData, UpdateOneTrustPreferenceWebhookErrors, UpdateOneTrustPreferenceWebhookResponses, UpdateOneTrustPurposesData, UpdateOneTrustPurposesErrors, UpdateOneTrustPurposesResponses, UpdateOrderInvoiceData, UpdateOrderInvoiceErrors, UpdateOrderInvoiceResponses, UpdateOrderStatusData, UpdateOrderStatusErrors, UpdateOrderStatusResponses, UpdatePaymentData, UpdatePaymentErrors, UpdatePaymentExternalDataData, UpdatePaymentExternalDataErrors, UpdatePaymentExternalDataResponses, UpdatePaymentMethodData, UpdatePaymentMethodErrors, UpdatePaymentMethodResponses, UpdatePaymentResponses, UpdatePlatformConfigurationData, UpdatePlatformConfigurationErrors, UpdatePlatformConfigurationResponses, UpdatePointsChangedWebhookData, UpdatePointsChangedWebhookErrors, UpdatePointsChangedWebhookResponses, UpdatePreferredLanguageOfMarketingCommunicationsData, UpdatePreferredLanguageOfMarketingCommunicationsErrors, UpdatePreferredLanguageOfMarketingCommunicationsResponses, UpdatePrefixMappingData, UpdatePrefixMappingErrors, UpdatePrefixMappingResponses, UpdateProfileData, UpdateProfileErrors, UpdateProfileResponses, UpdatePromotionData, UpdatePromotionErrors, UpdatePromotionResponses, UpdatePromotionSyncStatusData, UpdatePromotionSyncStatusErrors, UpdatePromotionSyncStatusResponses, UpdateQuizCompletedData, UpdateQuizCompletedErrors, UpdateQuizCompletedResponses, UpdateRefundData, UpdateRefundErrors, UpdateRefundResponses, UpdateRegistrabilityInventoryItemData, UpdateRegistrabilityInventoryItemErrors, UpdateRegistrabilityInventoryItemResponses, UpdateRewardRedemptionsStatusData, UpdateRewardRedemptionsStatusErrors, UpdateRewardRedemptionsStatusResponses, UpdateRewardRedemptionStatusChangedWebhookData, UpdateRewardRedemptionStatusChangedWebhookErrors, UpdateRewardRedemptionStatusChangedWebhookResponses, UpdateRewardWebhookData, UpdateRewardWebhookErrors, UpdateRewardWebhookResponses, UpdateRoleData, UpdateRoleErrors, UpdateRoleResponses, UpdateShippingData, UpdateShippingErrors, UpdateShippingResponses, UpdateShortUrlData, UpdateShortUrlErrors, UpdateShortUrlResponses, UpdateSingleTenantMappingData, UpdateSingleTenantMappingErrors, UpdateSingleTenantMappingResponses, UpdateSpexClusterData, UpdateSpexClusterErrors, UpdateSpexClusterResponses, UpdateSubscriptionChargeData, UpdateSubscriptionChargeErrors, UpdateSubscriptionChargeResponses, UpdateSubscriptionData, UpdateSubscriptionErrors, UpdateSubscriptionResponses, UpdateSubscriptionStatusData, UpdateSubscriptionStatusErrors, UpdateSubscriptionStatusResponses, UpdateSubscriptionToPauseData, UpdateSubscriptionToPauseErrors, UpdateSubscriptionToPauseResponses, UpdateSubscriptionToResumeData, UpdateSubscriptionToResumeErrors, UpdateSubscriptionToResumeResponses, UpdateTenantContactPersonData, UpdateTenantContactPersonErrors, UpdateTenantContactPersonResponses, UpdateTenantData, UpdateTenantErrors, UpdateTenantMappingData, UpdateTenantMappingErrors, UpdateTenantMappingResponses, UpdateTenantResponses, UpdateTenantSemVersionData, UpdateTenantSemVersionErrors, UpdateTenantSemVersionResponses, UpdateTrialData, UpdateTrialErrors, UpdateTrialResponses, UpdateVideoWatchedData, UpdateVideoWatchedErrors, UpdateVideoWatchedResponses, UpdateWarrantyData, UpdateWarrantyErrors, UpdateWarrantyResponses, UpdateWebhookData, UpdateWebhookErrors, UpdateWebhookResponses, UserDetailsData, UserDetailsErrors, UserDetailsResponses, UserIsAttachableInventoryItemData, UserIsAttachableInventoryItemErrors, UserIsAttachableInventoryItemResponses, UserPairInventoryItemData, UserPairInventoryItemErrors, UserPairInventoryItemResponses, UserUnpairInventoryItemData, UserUnpairInventoryItemErrors, UserUnpairInventoryItemResponses, UserUnregisterInventoryItemData, UserUnregisterInventoryItemErrors, UserUnregisterInventoryItemResponses, ValidateAddressData, ValidateAddressErrors, ValidateAddressResponses, ValidateConsumerCanStartSurveyControllerData, ValidateConsumerCanStartSurveyControllerErrors, ValidateConsumerCanStartSurveyControllerResponses, ValidateInventoryItemData, ValidateInventoryItemErrors, ValidateInventoryItemResponses, ValidateSessionData, ValidateSessionErrors, ValidateSessionResponses, VerifyActionVerificationData, VerifyActionVerificationErrors, VerifyActionVerificationResponses, VerifyAgeData, VerifyAgeErrors, VerifyAgeResponses, VerifyConsentData, VerifyConsentErrors, VerifyConsentResponses, VerifyEmailData, VerifyEmailErrors, VerifyEmailResponses, VerifyPhoneData, VerifyPhoneErrors, VerifyPhoneOrEmailData, VerifyPhoneOrEmailErrors, VerifyPhoneOrEmailResponses, VerifyPhoneResponses, VerifyReferralCodeData, VerifyReferralCodeErrors, VerifyReferralCodeResponses, VerifyTestScenarioData, VerifyTestScenarioErrors, VerifyTestScenarioResponses, WebhooksResyncData, WebhooksResyncErrors, WebhooksResyncResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * [DEPRECATED] Device id validation.
 *
 * @deprecated
 */
export const disInventoryItemCodeValidation = <ThrowOnError extends boolean = false>(options: Options<DisInventoryItemCodeValidationData, ThrowOnError>) => (options.client ?? client).get<DisInventoryItemCodeValidationResponses, DisInventoryItemCodeValidationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/devices/validation/{code}',
    ...options
});

/**
 * [DEPRECATED] Processes event 'consumer_canceled' event sent from CAS.
 *
 * @deprecated
 */
export const consumerCanceled = <ThrowOnError extends boolean = false>(options?: Options<ConsumerCanceledData, ThrowOnError>) => (options?.client ?? client).post<ConsumerCanceledResponses, ConsumerCanceledErrors, ThrowOnError>({
    security: [{ name: 'X-DES-SIGNATURE', type: 'apiKey' }],
    url: '/api/webhooks/consumer_canceled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * [DEPRECATED] Gets the Device
 *
 * @deprecated
 */
export const getDisInventoryItem = <ThrowOnError extends boolean = false>(options: Options<GetDisInventoryItemData, ThrowOnError>) => (options.client ?? client).get<GetDisInventoryItemResponses, GetDisInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/devices/{code}',
    ...options
});

/**
 * [DEPRECATED] Gets all Devices of the user
 *
 * @deprecated
 */
export const listDisInventoryItemForUser = <ThrowOnError extends boolean = false>(options?: Options<ListDisInventoryItemForUserData, ThrowOnError>) => (options?.client ?? client).get<ListDisInventoryItemForUserResponses, ListDisInventoryItemForUserErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/devices',
    ...options
});

/**
 * [DEPRECATED] Registers the Device
 *
 * @deprecated
 */
export const registerDiSv1InventoryItem = <ThrowOnError extends boolean = false>(options?: Options<RegisterDiSv1InventoryItemData, ThrowOnError>) => (options?.client ?? client).post<RegisterDiSv1InventoryItemResponses, RegisterDiSv1InventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/devices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * [DEPRECATED] Removes consumer device registration.
 *
 * @deprecated
 */
export const unregisterInventoryItemForConsumer = <ThrowOnError extends boolean = false>(options: Options<UnregisterInventoryItemForConsumerData, ThrowOnError>) => (options.client ?? client).put<UnregisterInventoryItemForConsumerResponses, UnregisterInventoryItemForConsumerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/devices/{code}/unassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [DEPRECATED] Registers the Device in guest registration mode
 *
 * @deprecated
 */
export const registerInventoryItemForGuest = <ThrowOnError extends boolean = false>(options?: Options<RegisterInventoryItemForGuestData, ThrowOnError>) => (options?.client ?? client).post<RegisterInventoryItemForGuestResponses, RegisterInventoryItemForGuestErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/devices/guest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * [DEPRECATED] Removes guest device registration.
 *
 * @deprecated
 */
export const unregisterInventoryItemForGuest = <ThrowOnError extends boolean = false>(options: Options<UnregisterInventoryItemForGuestData, ThrowOnError>) => (options.client ?? client).patch<UnregisterInventoryItemForGuestResponses, UnregisterInventoryItemForGuestErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/devices/guest/{code}/unassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [DEPRECATED] Assign the consumer to the Device
 *
 * @deprecated
 */
export const assignCustomerToInventoryItem = <ThrowOnError extends boolean = false>(options: Options<AssignCustomerToInventoryItemData, ThrowOnError>) => (options.client ?? client).patch<AssignCustomerToInventoryItemResponses, AssignCustomerToInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/devices/{code}/consumer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [DEPRECATED] Gets the Device's registration history
 *
 * Use GET `/inventory/items/{code}` instead.
 *
 * @deprecated
 */
export const listDeviceRegistrationHistory = <ThrowOnError extends boolean = false>(options: Options<ListDeviceRegistrationHistoryData, ThrowOnError>) => (options.client ?? client).get<ListDeviceRegistrationHistoryResponses, ListDeviceRegistrationHistoryErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/devices/{code}/history',
    ...options
});

/**
 * [DEPRECATED] Register Product to set up inventory and get warranty
 *
 * @deprecated
 */
export const productRegister = <ThrowOnError extends boolean = false>(options?: Options<ProductRegisterData, ThrowOnError>) => (options?.client ?? client).post<ProductRegisterResponses, ProductRegisterErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/products/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * [DEPRECATED] Get details of limits per product type for logged user
 *
 * @deprecated
 */
export const userDetails = <ThrowOnError extends boolean = false>(options?: Options<UserDetailsData, ThrowOnError>) => (options?.client ?? client).get<UserDetailsResponses, UserDetailsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/me',
    ...options
});

/**
 * [DEPRECATED] Register Product for logged User / Customer
 *
 * @deprecated
 */
export const meProductRegister = <ThrowOnError extends boolean = false>(options?: Options<MeProductRegisterData, ThrowOnError>) => (options?.client ?? client).post<MeProductRegisterResponses, MeProductRegisterErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/me/products/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get list of all prefixes from storage.
 *
 * Permissions for S2S authorization: inventory
 */
export const getPrefixMappings = <ThrowOnError extends boolean = false>(options?: Options<GetPrefixMappingsData, ThrowOnError>) => (options?.client ?? client).get<GetPrefixMappingsResponses, GetPrefixMappingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/prefix-mappings',
    ...options
});

/**
 * Store a newly created prefix mapping in storage.
 *
 * Permissions for S2S authorization: inventory
 */
export const prefixMapping = <ThrowOnError extends boolean = false>(options?: Options<PrefixMappingData, ThrowOnError>) => (options?.client ?? client).post<PrefixMappingResponses, PrefixMappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/prefix-mappings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete an existing prefix mapping from storage.
 *
 * Permissions for S2S authorization: inventory
 */
export const deletePrefixMapping = <ThrowOnError extends boolean = false>(options: Options<DeletePrefixMappingData, ThrowOnError>) => (options.client ?? client).delete<DeletePrefixMappingResponses, DeletePrefixMappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/prefix-mappings/{prefix}',
    ...options
});

/**
 * Show a single prefix mapping from storage.
 *
 * Permissions for S2S authorization: inventory
 */
export const getPrefixMapping = <ThrowOnError extends boolean = false>(options: Options<GetPrefixMappingData, ThrowOnError>) => (options.client ?? client).get<GetPrefixMappingResponses, GetPrefixMappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/prefix-mappings/{prefix}',
    ...options
});

/**
 * Update an existing prefix mapping in storage.
 *
 * Permissions for S2S authorization: inventory
 */
export const updatePrefixMapping = <ThrowOnError extends boolean = false>(options: Options<UpdatePrefixMappingData, ThrowOnError>) => (options.client ?? client).put<UpdatePrefixMappingResponses, UpdatePrefixMappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/prefix-mappings/{prefix}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the Configuration Schemas
 *
 * Permissions for S2S authorization: tenant-configuration.read
 */
export const getConfigurationSchemas = <ThrowOnError extends boolean = false>(options?: Options<GetConfigurationSchemasData, ThrowOnError>) => (options?.client ?? client).get<GetConfigurationSchemasResponses, GetConfigurationSchemasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations/schemas',
    ...options
});

/**
 * Update bulk or create the Configuration Items
 *
 * Permissions for S2S authorization: tenant-configuration.write
 */
export const updateBulkConfigurationItems = <ThrowOnError extends boolean = false>(options: Options<UpdateBulkConfigurationItemsData, ThrowOnError>) => (options.client ?? client).put<UpdateBulkConfigurationItemsResponses, UpdateBulkConfigurationItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations/{id}/items/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete the Configuration Item
 *
 * Permissions for S2S authorization: tenant-configuration.critical
 */
export const deleteConfigurationItem = <ThrowOnError extends boolean = false>(options: Options<DeleteConfigurationItemData, ThrowOnError>) => (options.client ?? client).delete<DeleteConfigurationItemResponses, DeleteConfigurationItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations/{id}/items/{type}',
    ...options
});

/**
 * Get the Configuration Item
 *
 * Permissions for S2S authorization: tenant-configuration.read
 */
export const getConfigurationItem = <ThrowOnError extends boolean = false>(options: Options<GetConfigurationItemData, ThrowOnError>) => (options.client ?? client).get<GetConfigurationItemResponses, GetConfigurationItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations/{id}/items/{type}',
    ...options
});

/**
 * Update the Configuration Item
 *
 * Permissions for S2S authorization: tenant-configuration.write
 */
export const updateConfigurationItem = <ThrowOnError extends boolean = false>(options: Options<UpdateConfigurationItemData, ThrowOnError>) => (options.client ?? client).put<UpdateConfigurationItemResponses, UpdateConfigurationItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations/{id}/items/{type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create the Configuration Item
 *
 * Permissions for S2S authorization: tenant-configuration.write
 */
export const createConfigurationItem = <ThrowOnError extends boolean = false>(options: Options<CreateConfigurationItemData, ThrowOnError>) => (options.client ?? client).post<CreateConfigurationItemResponses, CreateConfigurationItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations/{id}/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Configurations
 *
 * Permissions for S2S authorization: tenant-configuration.read
 */
export const listConfigurations = <ThrowOnError extends boolean = false>(options?: Options<ListConfigurationsData, ThrowOnError>) => (options?.client ?? client).get<ListConfigurationsResponses, ListConfigurationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations',
    ...options
});

/**
 * Create the Configuration
 *
 * Permissions for S2S authorization: tenant-configuration.write
 */
export const createConfiguration = <ThrowOnError extends boolean = false>(options?: Options<CreateConfigurationData, ThrowOnError>) => (options?.client ?? client).post<CreateConfigurationResponses, CreateConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete the Configuration
 *
 * Permissions for S2S authorization: tenant-configuration.critical
 */
export const deleteConfiguration = <ThrowOnError extends boolean = false>(options: Options<DeleteConfigurationData, ThrowOnError>) => (options.client ?? client).delete<DeleteConfigurationResponses, DeleteConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations/{id}',
    ...options
});

/**
 * Get the Configuration
 *
 * Permissions for S2S authorization: tenant-configuration.read
 */
export const getConfiguration = <ThrowOnError extends boolean = false>(options: Options<GetConfigurationData, ThrowOnError>) => (options.client ?? client).get<GetConfigurationResponses, GetConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations/{id}',
    ...options
});

/**
 * Update the Configuration
 *
 * Permissions for S2S authorization: tenant-configuration.write
 */
export const updateConfiguration = <ThrowOnError extends boolean = false>(options: Options<UpdateConfigurationData, ThrowOnError>) => (options.client ?? client).put<UpdateConfigurationResponses, UpdateConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/configurations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List tenants versions
 */
export const listTenantsVersions = <ThrowOnError extends boolean = false>(options?: Options<ListTenantsVersionsData, ThrowOnError>) => (options?.client ?? client).get<ListTenantsVersionsResponses, ListTenantsVersionsErrors, ThrowOnError>({ url: '/api/tenants-versions', ...options });

/**
 * List tenant public configurations
 *
 * Permissions for S2S authorization: tenant-configuration.public.read
 */
export const listTenantPublicConfigurations = <ThrowOnError extends boolean = false>(options?: Options<ListTenantPublicConfigurationsData, ThrowOnError>) => (options?.client ?? client).get<ListTenantPublicConfigurationsResponses, ListTenantPublicConfigurationsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/tenants/public-configurations',
    ...options
});

/**
 * List tenant's business metrics.
 *
 * Permissions for S2S authorization: tenant.read
 */
export const listBusinessMetrics = <ThrowOnError extends boolean = false>(options?: Options<ListBusinessMetricsData, ThrowOnError>) => (options?.client ?? client).get<ListBusinessMetricsResponses, ListBusinessMetricsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/tenants/business-metrics',
    ...options
});

/**
 * List Tenants
 *
 * Permissions for S2S authorization: tenant.read
 */
export const listTenants = <ThrowOnError extends boolean = false>(options?: Options<ListTenantsData, ThrowOnError>) => (options?.client ?? client).get<ListTenantsResponses, ListTenantsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants',
    ...options
});

/**
 * Create the Tenant
 *
 * Permissions for S2S authorization: tenant.write
 */
export const createTenant = <ThrowOnError extends boolean = false>(options?: Options<CreateTenantData, ThrowOnError>) => (options?.client ?? client).post<CreateTenantResponses, CreateTenantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete the Tenant
 *
 * Only for tenants with a flag: is_production: false
 * Permissions for S2S authorization: tenant.critical
 */
export const deleteTenant = <ThrowOnError extends boolean = false>(options: Options<DeleteTenantData, ThrowOnError>) => (options.client ?? client).delete<DeleteTenantResponses, DeleteTenantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/{code}',
    ...options
});

/**
 * Get the Tenant
 *
 * Permissions for S2S authorization: tenant.read
 */
export const getTenant = <ThrowOnError extends boolean = false>(options: Options<GetTenantData, ThrowOnError>) => (options.client ?? client).get<GetTenantResponses, GetTenantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/{code}',
    ...options
});

/**
 * Update the Tenant
 *
 * Permissions for S2S authorization: tenant.write
 */
export const updateTenant = <ThrowOnError extends boolean = false>(options: Options<UpdateTenantData, ThrowOnError>) => (options.client ?? client).put<UpdateTenantResponses, UpdateTenantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/{code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List a tenant's version history
 *
 * Permissions for S2S authorization: tenant.read
 */
export const listTenantVersionHistory = <ThrowOnError extends boolean = false>(options: Options<ListTenantVersionHistoryData, ThrowOnError>) => (options.client ?? client).get<ListTenantVersionHistoryResponses, ListTenantVersionHistoryErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/{code}/versions',
    ...options
});

/**
 * Update the Tenant contact person
 *
 * Permissions for S2S authorization: tenant.write
 */
export const updateTenantContactPerson = <ThrowOnError extends boolean = false>(options: Options<UpdateTenantContactPersonData, ThrowOnError>) => (options.client ?? client).put<UpdateTenantContactPersonResponses, UpdateTenantContactPersonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/{code}/contact-person',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export the encrypted data of the tenant with configuration and items
 *
 * Permissions for S2S authorization: tenant.export
 */
export const exportTenant = <ThrowOnError extends boolean = false>(options: Options<ExportTenantData, ThrowOnError>) => (options.client ?? client).get<ExportTenantResponses, ExportTenantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/{code}/export',
    ...options
});

/**
 * Import the tenant with configuration and items from encrypted data
 *
 * Permissions for S2S authorization: tenant.import
 */
export const importTenant = <ThrowOnError extends boolean = false>(options?: Options<ImportTenantData, ThrowOnError>) => (options?.client ?? client).post<ImportTenantResponses, ImportTenantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Migrate the Tenant
 *
 * Permissions for S2S authorization: tenant.write
 */
export const updateTenantSemVersion = <ThrowOnError extends boolean = false>(options: Options<UpdateTenantSemVersionData, ThrowOnError>) => (options.client ?? client).put<UpdateTenantSemVersionResponses, UpdateTenantSemVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/tenants/{code}/sem-version',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists all the error codes of every existing domain.
 *
 * Permissions for S2S authorization: platform.error-codes
 */
export const listErrorCodes = <ThrowOnError extends boolean = false>(options?: Options<ListErrorCodesData, ThrowOnError>) => (options?.client ?? client).get<ListErrorCodesResponses, unknown, ThrowOnError>({ url: '/api/platform/error-codes', ...options });

/**
 * List all the error codes for a given domain.
 *
 * Permissions for S2S authorization: platform.error-codes
 */
export const getErrorCodes = <ThrowOnError extends boolean = false>(options: Options<GetErrorCodesData, ThrowOnError>) => (options.client ?? client).get<GetErrorCodesResponses, unknown, ThrowOnError>({ url: '/api/platform/error-codes/{domain}', ...options });

/**
 * Get the Platform(Tenant) Version
 */
export const getPlatformVersion = <ThrowOnError extends boolean = false>(options?: Options<GetPlatformVersionData, ThrowOnError>) => (options?.client ?? client).get<GetPlatformVersionResponses, GetPlatformVersionErrors, ThrowOnError>({ url: '/api/platform/version', ...options });

/**
 * Get a list of all available versions, optionally with configuration schema.
 */
export const listPlatformVersions = <ThrowOnError extends boolean = false>(options?: Options<ListPlatformVersionsData, ThrowOnError>) => (options?.client ?? client).get<ListPlatformVersionsResponses, ListPlatformVersionsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    url: '/api/platform/versions',
    ...options
});

/**
 * List integration test results
 *
 * Permissions for S2S authorization: integration-tests.results
 */
export const listIntegrationTestResult = <ThrowOnError extends boolean = false>(options?: Options<ListIntegrationTestResultData, ThrowOnError>) => (options?.client ?? client).get<ListIntegrationTestResultResponses, ListIntegrationTestResultErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-STATIC-TOKEN', type: 'apiKey' }],
    url: '/api/platform/integration-tests/results',
    ...options
});

/**
 * Update integration test results
 *
 * Permissions for S2S authorization: integration-tests.results
 */
export const updateIntegrationTestResult = <ThrowOnError extends boolean = false>(options?: Options<UpdateIntegrationTestResultData, ThrowOnError>) => (options?.client ?? client).post<UpdateIntegrationTestResultResponses, UpdateIntegrationTestResultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/integration-tests/results',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get integration test result summary
 *
 * Permissions for S2S authorization: integration-tests.results
 */
export const getIntegrationTestResultSummaryController = <ThrowOnError extends boolean = false>(options: Options<GetIntegrationTestResultSummaryControllerData, ThrowOnError>) => (options.client ?? client).get<GetIntegrationTestResultSummaryControllerResponses, GetIntegrationTestResultSummaryControllerErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-STATIC-TOKEN', type: 'apiKey' }],
    url: '/api/platform/integration-tests/results/summary/{version}',
    ...options
});

/**
 * Get scenario codes grouped by feature code
 *
 * Returns distinct scenario codes grouped by their feature code for a given version.
 *
 * Permissions for S2S authorization: integration-tests.results
 */
export const getScenarioCodes = <ThrowOnError extends boolean = false>(options: Options<GetScenarioCodesData, ThrowOnError>) => (options.client ?? client).get<GetScenarioCodesResponses, GetScenarioCodesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-STATIC-TOKEN', type: 'apiKey' }],
    url: '/api/platform/integration-tests/results/scenarios/{version}',
    ...options
});

/**
 * Verify test scenario
 *
 * Permissions for S2S authorization: platform
 */
export const verifyTestScenario = <ThrowOnError extends boolean = false>(options?: Options<VerifyTestScenarioData, ThrowOnError>) => (options?.client ?? client).post<VerifyTestScenarioResponses, VerifyTestScenarioErrors, ThrowOnError>({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/integration-tests/validate',
    ...options,
    headers: {
        'Content-Type': 'text/plain',
        ...options?.headers
    }
});

/**
 * Gets action verification code
 *
 * Permissions for S2S authorization: integration-tests.get-action-verification-code
 */
export const internalGetActionVerificationCode = <ThrowOnError extends boolean = false>(options?: Options<InternalGetActionVerificationCodeData, ThrowOnError>) => (options?.client ?? client).post<InternalGetActionVerificationCodeResponses, InternalGetActionVerificationCodeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-IP-WHITELISTED', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/integration-tests/__e2e-tests__/get-ac-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create age verification item
 *
 * Permissions for S2S authorization: integration-tests.store-age-verification-item
 */
export const internalStoreAgeVerificationItem = <ThrowOnError extends boolean = false>(options?: Options<InternalStoreAgeVerificationItemData, ThrowOnError>) => (options?.client ?? client).post<InternalStoreAgeVerificationItemResponses, InternalStoreAgeVerificationItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-IP-WHITELISTED', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/integration-tests/__e2e-tests__/store-av-item',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Public List of Platform Configurations
 *
 * Public List of Platform Configurations for given codes
 */
export const listPublicPlatformConfiguration = <ThrowOnError extends boolean = false>(options: Options<ListPublicPlatformConfigurationData, ThrowOnError>) => (options.client ?? client).get<ListPublicPlatformConfigurationResponses, ListPublicPlatformConfigurationErrors, ThrowOnError>({ url: '/api/platform/configuration/public', ...options });

/**
 * List the Platform Configuration
 *
 * Permissions for S2S authorization: platform.configuration
 */
export const listPlatformConfiguration = <ThrowOnError extends boolean = false>(options?: Options<ListPlatformConfigurationData, ThrowOnError>) => (options?.client ?? client).get<ListPlatformConfigurationResponses, ListPlatformConfigurationErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/configuration',
    ...options
});

/**
 * Create the Platform Configuration
 *
 * Permissions for S2S authorization: platform.configuration
 */
export const createPlatformConfiguration = <ThrowOnError extends boolean = false>(options?: Options<CreatePlatformConfigurationData, ThrowOnError>) => (options?.client ?? client).post<CreatePlatformConfigurationResponses, CreatePlatformConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/configuration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete the Platform Configuration
 *
 * Permissions for S2S authorization: platform.configuration
 */
export const deletePlatformConfiguration = <ThrowOnError extends boolean = false>(options: Options<DeletePlatformConfigurationData, ThrowOnError>) => (options.client ?? client).delete<DeletePlatformConfigurationResponses, DeletePlatformConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/configuration/{code}',
    ...options
});

/**
 * Get the Platform Configuration
 *
 * Permissions for S2S authorization: platform.configuration
 */
export const getPlatformConfiguration = <ThrowOnError extends boolean = false>(options: Options<GetPlatformConfigurationData, ThrowOnError>) => (options.client ?? client).get<GetPlatformConfigurationResponses, GetPlatformConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/configuration/{code}',
    ...options
});

/**
 * Update the Platform Configuration
 *
 * Permissions for S2S authorization: platform.configuration
 */
export const updatePlatformConfiguration = <ThrowOnError extends boolean = false>(options: Options<UpdatePlatformConfigurationData, ThrowOnError>) => (options.client ?? client).put<UpdatePlatformConfigurationResponses, UpdatePlatformConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/configuration/{code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all tenant mappings.
 *
 * Permissions for S2S authorization: platform.proxy-read
 */
export const listTenantMappings = <ThrowOnError extends boolean = false>(options?: Options<ListTenantMappingsData, ThrowOnError>) => (options?.client ?? client).get<ListTenantMappingsResponses, ListTenantMappingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/proxy/tenants',
    ...options
});

/**
 * Write tenant mappings.
 *
 * Permissions for S2S authorization: platform.proxy-write
 */
export const updateTenantMapping = <ThrowOnError extends boolean = false>(options?: Options<UpdateTenantMappingData, ThrowOnError>) => (options?.client ?? client).put<UpdateTenantMappingResponses, UpdateTenantMappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/proxy/tenants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get the list of tenant codes that the provided access token maps to.
 *
 * Permissions for S2S authorization: platform.proxy-read
 */
export const getTenantMappingByAccessToken = <ThrowOnError extends boolean = false>(options: Options<GetTenantMappingByAccessTokenData, ThrowOnError>) => (options.client ?? client).get<GetTenantMappingByAccessTokenResponses, GetTenantMappingByAccessTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/proxy/tenants/by-access-token/{accessToken}',
    ...options
});

/**
 * Get the list of tenant codes per-service that the access token maps to.
 *
 * Permissions for S2S authorization: platform.proxy-read
 */
export const getTenantMappingByTenantCode = <ThrowOnError extends boolean = false>(options: Options<GetTenantMappingByTenantCodeData, ThrowOnError>) => (options.client ?? client).get<GetTenantMappingByTenantCodeResponses, GetTenantMappingByTenantCodeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/proxy/tenants/by-tenant-code/{tenantCode}',
    ...options
});

/**
 * Get all tenant mappings for a specific service.
 *
 * Permissions for S2S authorization: platform.proxy-read
 */
export const getTenantMappingsByService = <ThrowOnError extends boolean = false>(options: Options<GetTenantMappingsByServiceData, ThrowOnError>) => (options.client ?? client).get<GetTenantMappingsByServiceResponses, GetTenantMappingsByServiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/proxy/tenants/by-service/{service}',
    ...options
});

/**
 * Write a single tenant mapping with optional options for a specific service.
 *
 * Permissions for S2S authorization: platform.proxy-write
 */
export const updateSingleTenantMapping = <ThrowOnError extends boolean = false>(options: Options<UpdateSingleTenantMappingData, ThrowOnError>) => (options.client ?? client).put<UpdateSingleTenantMappingResponses, UpdateSingleTenantMappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/proxy/tenants/by-service/{service}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get tenant mapping for a specific service for a specific access token.
 *
 * Permissions for S2S authorization: platform.proxy-read
 */
export const getTenantMappingsByServiceForAccessToken = <ThrowOnError extends boolean = false>(options: Options<GetTenantMappingsByServiceForAccessTokenData, ThrowOnError>) => (options.client ?? client).get<GetTenantMappingsByServiceForAccessTokenResponses, GetTenantMappingsByServiceForAccessTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/proxy/tenants/by-service/{service}/{accessToken}',
    ...options
});

/**
 * Get schema diff between draft and published
 *
 * Permissions for S2S authorization: platform.schema.read
 */
export const diffSchema = <ThrowOnError extends boolean = false>(options?: Options<DiffSchemaData, ThrowOnError>) => (options?.client ?? client).get<DiffSchemaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/diff',
    ...options
});

/**
 * Get schema for all entities
 *
 * Permissions for S2S authorization: platform.schema.read
 */
export const indexSchemaEntities = <ThrowOnError extends boolean = false>(options?: Options<IndexSchemaEntitiesData, ThrowOnError>) => (options?.client ?? client).get<IndexSchemaEntitiesResponses, IndexSchemaEntitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/entities',
    ...options
});

/**
 * Store entity
 *
 * Permissions for S2S authorization: platform.schema.write
 */
export const storeEntityController = <ThrowOnError extends boolean = false>(options?: Options<StoreEntityControllerData, ThrowOnError>) => (options?.client ?? client).post<StoreEntityControllerResponses, StoreEntityControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/entities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete entity
 *
 * Permissions for S2S authorization: platform.schema.write
 */
export const deleteEntityController = <ThrowOnError extends boolean = false>(options: Options<DeleteEntityControllerData, ThrowOnError>) => (options.client ?? client).delete<DeleteEntityControllerResponses, DeleteEntityControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/entities/{entityCode}',
    ...options
});

/**
 * Get schema for a specific entity
 *
 * Permissions for S2S authorization: platform.schema.read
 */
export const showSchemaEntity = <ThrowOnError extends boolean = false>(options: Options<ShowSchemaEntityData, ThrowOnError>) => (options.client ?? client).get<ShowSchemaEntityResponses, ShowSchemaEntityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/entities/{entityCode}',
    ...options
});

/**
 * Update entity
 *
 * Permissions for S2S authorization: platform.schema.write
 */
export const updateEntityController = <ThrowOnError extends boolean = false>(options: Options<UpdateEntityControllerData, ThrowOnError>) => (options.client ?? client).put<UpdateEntityControllerResponses, UpdateEntityControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/entities/{entityCode}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete field
 *
 * Permissions for S2S authorization: platform.schema.write
 */
export const deleteFieldController = <ThrowOnError extends boolean = false>(options: Options<DeleteFieldControllerData, ThrowOnError>) => (options.client ?? client).delete<DeleteFieldControllerResponses, DeleteFieldControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/fields/{fieldCode}',
    ...options
});

/**
 * Get schema for a specific field
 *
 * Permissions for S2S authorization: platform.schema.read
 */
export const showSchemaField = <ThrowOnError extends boolean = false>(options: Options<ShowSchemaFieldData, ThrowOnError>) => (options.client ?? client).get<ShowSchemaFieldResponses, ShowSchemaFieldErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/fields/{fieldCode}',
    ...options
});

/**
 * Update field
 *
 * Permissions for S2S authorization: platform.schema.write
 */
export const updateFieldController = <ThrowOnError extends boolean = false>(options: Options<UpdateFieldControllerData, ThrowOnError>) => (options.client ?? client).put<UpdateFieldControllerResponses, UpdateFieldControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/fields/{fieldCode}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Store entity override
 *
 * Permissions for S2S authorization: platform.schema.override
 */
export const storeEntityOverrideController = <ThrowOnError extends boolean = false>(options?: Options<StoreEntityOverrideControllerData, ThrowOnError>) => (options?.client ?? client).post<StoreEntityOverrideControllerResponses, StoreEntityOverrideControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/entities/override',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Store field override
 *
 * Permissions for S2S authorization: platform.schema.override
 */
export const storeFieldOverrideController = <ThrowOnError extends boolean = false>(options?: Options<StoreFieldOverrideControllerData, ThrowOnError>) => (options?.client ?? client).post<StoreFieldOverrideControllerResponses, StoreFieldOverrideControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/fields/override',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Store field
 *
 * Permissions for S2S authorization: platform.schema.write
 */
export const storeFieldController = <ThrowOnError extends boolean = false>(options?: Options<StoreFieldControllerData, ThrowOnError>) => (options?.client ?? client).post<StoreFieldControllerResponses, StoreFieldControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/fields',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Publishes the current draft schema
 *
 * Permissions for S2S authorization: platform.schema.publish
 */
export const publishSchemaController = <ThrowOnError extends boolean = false>(options?: Options<PublishSchemaControllerData, ThrowOnError>) => (options?.client ?? client).post<PublishSchemaControllerResponses, PublishSchemaControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/publish',
    ...options
});

/**
 * Rolls back the current published schema to draft
 *
 * Permissions for S2S authorization: platform.schema.publish
 */
export const rollbackSchemaController = <ThrowOnError extends boolean = false>(options?: Options<RollbackSchemaControllerData, ThrowOnError>) => (options?.client ?? client).post<RollbackSchemaControllerResponses, RollbackSchemaControllerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/rollback',
    ...options
});

/**
 * Delete draft changesets for current draft schema
 *
 * Permissions for S2S authorization: platform.schema.write
 */
export const deleteDraftChangeSets = <ThrowOnError extends boolean = false>(options?: Options<DeleteDraftChangeSetsData, ThrowOnError>) => (options?.client ?? client).delete<DeleteDraftChangeSetsResponses, DeleteDraftChangeSetsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/draft/changesets',
    ...options
});

/**
 * Get schema for all entities
 *
 * Permissions for S2S authorization: platform.schema.read
 */
export const indexDraftSchemaEntities = <ThrowOnError extends boolean = false>(options?: Options<IndexDraftSchemaEntitiesData, ThrowOnError>) => (options?.client ?? client).get<IndexDraftSchemaEntitiesResponses, IndexDraftSchemaEntitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/draft/entities',
    ...options
});

/**
 * Get schema for a specific entity
 *
 * Permissions for S2S authorization: platform.schema.read
 */
export const showSchemaDraftEntity = <ThrowOnError extends boolean = false>(options: Options<ShowSchemaDraftEntityData, ThrowOnError>) => (options.client ?? client).get<ShowSchemaDraftEntityResponses, ShowSchemaDraftEntityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/draft/entities/{entityCode}',
    ...options
});

/**
 * Get schema for a specific field in draft schema
 *
 * Permissions for S2S authorization: platform.schema.read
 */
export const showSchemaDraftField = <ThrowOnError extends boolean = false>(options: Options<ShowSchemaDraftFieldData, ThrowOnError>) => (options.client ?? client).get<ShowSchemaDraftFieldResponses, ShowSchemaDraftFieldErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/schema/draft/fields/{fieldCode}',
    ...options
});

/**
 * Get schema for all entities for tenant based on configuration
 *
 * Permissions for S2S authorization: platform.schema.read
 */
export const indexTenantSchemaEntities = <ThrowOnError extends boolean = false>(options?: Options<IndexTenantSchemaEntitiesData, ThrowOnError>) => (options?.client ?? client).get<IndexTenantSchemaEntitiesResponses, IndexTenantSchemaEntitiesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/schema/tenant/entities',
    ...options
});

/**
 * Cancel a bus batch
 *
 * Permissions for S2S authorization: platform.batch-cancel
 */
export const cancelBusBatch = <ThrowOnError extends boolean = false>(options?: Options<CancelBusBatchData, ThrowOnError>) => (options?.client ?? client).post<CancelBusBatchResponses, CancelBusBatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/batches/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get available permissions list
 *
 * Permissions for S2S authorization: permissions.read
 */
export const listPermissions = <ThrowOnError extends boolean = false>(options?: Options<ListPermissionsData, ThrowOnError>) => (options?.client ?? client).get<ListPermissionsResponses, ListPermissionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/permissions',
    ...options
});

/**
 * Get filtered and sorted roles list
 *
 * Permissions for S2S authorization: roles.read
 */
export const listRoles = <ThrowOnError extends boolean = false>(options?: Options<ListRolesData, ThrowOnError>) => (options?.client ?? client).get<ListRolesResponses, ListRolesErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/roles',
    ...options
});

/**
 * Create a new role
 *
 * Permissions for S2S authorization: roles.write
 */
export const createRole = <ThrowOnError extends boolean = false>(options?: Options<CreateRoleData, ThrowOnError>) => (options?.client ?? client).post<CreateRoleResponses, CreateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete an existing role
 *
 * Permissions for S2S authorization: roles.write
 */
export const deleteRole = <ThrowOnError extends boolean = false>(options: Options<DeleteRoleData, ThrowOnError>) => (options.client ?? client).delete<DeleteRoleResponses, DeleteRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/roles/{key}',
    ...options
});

/**
 * Update an existing role
 *
 * Permissions for S2S authorization: roles.write
 */
export const updateRole = <ThrowOnError extends boolean = false>(options: Options<UpdateRoleData, ThrowOnError>) => (options.client ?? client).put<UpdateRoleResponses, UpdateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/roles/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Migrate an Okta application to Entra
 *
 * Reads the source Okta application (name, group assignments and scopes) by its OIDC client id,
 * creates a matching EVO role and provisions a new Entra application registration with two client secrets.
 *
 * Permissions for S2S authorization: platform.okta-to-entra-migration
 */
export const migrateOktaApplicationToEntra = <ThrowOnError extends boolean = false>(options?: Options<MigrateOktaApplicationToEntraData, ThrowOnError>) => (options?.client ?? client).post<MigrateOktaApplicationToEntraResponses, MigrateOktaApplicationToEntraErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/okta-to-entra-migration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create a new Entra application
 *
 * Creates a dedicated EVO role with the given permissions and provisions a brand new Entra application
 * registration with two client secrets. Any app roles listed in `assign_existing_roles` must already exist
 * in Entra and are granted to the new application.
 *
 * Permissions for S2S authorization: platform.entra.manage-application
 */
export const createEntraApplication = <ThrowOnError extends boolean = false>(options?: Options<CreateEntraApplicationData, ThrowOnError>) => (options?.client ?? client).post<CreateEntraApplicationResponses, CreateEntraApplicationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/entra/applications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Generate the Service To Service token (S2S).
 */
export const generateS2sToken = <ThrowOnError extends boolean = false>(options?: Options<GenerateS2sTokenData, ThrowOnError>) => (options?.client ?? client).post<GenerateS2sTokenResponses, GenerateS2sTokenErrors, ThrowOnError>({
    url: '/api/platform/oauth2/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Resync CDP entities
 *
 * Permissions for S2S authorization: platform
 */
export const cdpResync = <ThrowOnError extends boolean = false>(options?: Options<CdpResyncData, ThrowOnError>) => (options?.client ?? client).post<CdpResyncResponses, CdpResyncErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/cdp-resync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Resync webhooks
 *
 * Permissions for S2S authorization: platform
 */
export const webhooksResync = <ThrowOnError extends boolean = false>(options?: Options<WebhooksResyncData, ThrowOnError>) => (options?.client ?? client).post<WebhooksResyncResponses, WebhooksResyncErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/webhooks-resync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Verify email address
 *
 * Permissions for S2S authorization: platform
 */
export const verifyEmail = <ThrowOnError extends boolean = false>(options?: Options<VerifyEmailData, ThrowOnError>) => (options?.client ?? client).post<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/email-validation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Verify phone number
 *
 * Permissions for S2S authorization: platform, platform.phone_validation
 */
export const verifyPhone = <ThrowOnError extends boolean = false>(options?: Options<VerifyPhoneData, ThrowOnError>) => (options?.client ?? client).post<VerifyPhoneResponses, VerifyPhoneErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/phone-validation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Anonymize single profile
 *
 * Permissions for S2S authorization: leads.anonymize, profiles.anonymize
 */
export const platformProfileAnonymization = <ThrowOnError extends boolean = false>(options?: Options<PlatformProfileAnonymizationData, ThrowOnError>) => (options?.client ?? client).delete<PlatformProfileAnonymizationResponses, PlatformProfileAnonymizationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List anonymization request statuses
 *
 * Permissions for S2S authorization: leads.anonymize.read, profiles.anonymize.read
 */
export const listAnonymizations = <ThrowOnError extends boolean = false>(options?: Options<ListAnonymizationsData, ThrowOnError>) => (options?.client ?? client).get<ListAnonymizationsResponses, ListAnonymizationsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/anonymizations/status',
    ...options
});

/**
 * Sync profile to CDP by UUID
 *
 * Triggers syncing of consumer-related entities (lead, actions, quizzes,
 * marketing communications) to CDP.
 *
 * Permissions for S2S authorization: users.cdp-sync
 */
export const platformSyncConsumerToCdp = <ThrowOnError extends boolean = false>(options: Options<PlatformSyncConsumerToCdpData, ThrowOnError>) => (options.client ?? client).post<PlatformSyncConsumerToCdpResponses, PlatformSyncConsumerToCdpErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/data-sync/consumers/{uuid}',
    ...options
});

/**
 * Get filtered and sorted short URLs list
 *
 * Permissions for S2S authorization: url-shortener.list-codes
 */
export const listShortUrl = <ThrowOnError extends boolean = false>(options?: Options<ListShortUrlData, ThrowOnError>) => (options?.client ?? client).get<ListShortUrlResponses, ListShortUrlErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/url-shortener/codes',
    ...options
});

/**
 * Create short URL
 *
 * Permissions for S2S authorization: url-shortener.create-code
 */
export const createShortUrl = <ThrowOnError extends boolean = false>(options?: Options<CreateShortUrlData, ThrowOnError>) => (options?.client ?? client).post<CreateShortUrlResponses, CreateShortUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/url-shortener/codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Bulk create short URLs
 *
 * Permissions for S2S authorization: url-shortener.create-code
 */
export const createBulkShortUrl = <ThrowOnError extends boolean = false>(options?: Options<CreateBulkShortUrlData, ThrowOnError>) => (options?.client ?? client).post<CreateBulkShortUrlResponses, CreateBulkShortUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/url-shortener/codes/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete short URL by code
 *
 * Permissions for S2S authorization: url-shortener.delete-code
 */
export const deleteShortUrl = <ThrowOnError extends boolean = false>(options: Options<DeleteShortUrlData, ThrowOnError>) => (options.client ?? client).delete<DeleteShortUrlResponses, DeleteShortUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/url-shortener/codes/{code}',
    ...options
});

/**
 * Get short URL by code
 *
 * Permissions for S2S authorization: url-shortener.read-code
 */
export const getShortUrl = <ThrowOnError extends boolean = false>(options: Options<GetShortUrlData, ThrowOnError>) => (options.client ?? client).get<GetShortUrlResponses, GetShortUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/url-shortener/codes/{code}',
    ...options
});

/**
 * Update short URL
 *
 * Permissions for S2S authorization: url-shortener.update-code
 */
export const updateShortUrl = <ThrowOnError extends boolean = false>(options: Options<UpdateShortUrlData, ThrowOnError>) => (options.client ?? client).put<UpdateShortUrlResponses, UpdateShortUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/url-shortener/codes/{code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all clicks (filterable by external_id, campaign_id)
 *
 * Permissions for S2S authorization: url-shortener.read-clicks
 */
export const listClicks = <ThrowOnError extends boolean = false>(options?: Options<ListClicksData, ThrowOnError>) => (options?.client ?? client).get<ListClicksResponses, ListClicksErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/url-shortener/clicks',
    ...options
});

/**
 * Ingest a batch of click events
 *
 * Permissions for S2S authorization: url-shortener.write-clicks
 */
export const ingestClickBatch = <ThrowOnError extends boolean = false>(options?: Options<IngestClickBatchData, ThrowOnError>) => (options?.client ?? client).post<IngestClickBatchResponses, IngestClickBatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/url-shortener/clicks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List clicks for a specific short URL code
 *
 * Permissions for S2S authorization: url-shortener.read-clicks
 */
export const listClicksByCode = <ThrowOnError extends boolean = false>(options: Options<ListClicksByCodeData, ThrowOnError>) => (options.client ?? client).get<ListClicksByCodeResponses, ListClicksByCodeErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/platform/url-shortener/codes/{code}/clicks',
    ...options
});

/**
 * List audit trail records (filterable, sortable, paginated).
 *
 * Permissions for S2S authorization: audit-trail.list
 */
export const listAuditTrail = <ThrowOnError extends boolean = false>(options?: Options<ListAuditTrailData, ThrowOnError>) => (options?.client ?? client).get<ListAuditTrailResponses, ListAuditTrailErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/audit-trail',
    ...options
});

/**
 * Get the full audit trail history for a single entity.
 *
 * Permissions for S2S authorization: audit-trail.read
 */
export const getEntityAuditTrail = <ThrowOnError extends boolean = false>(options: Options<GetEntityAuditTrailData, ThrowOnError>) => (options.client ?? client).get<GetEntityAuditTrailResponses, GetEntityAuditTrailErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/audit-trail/{entityType}/{entityId}',
    ...options
});

/**
 * List request-validation logs (filterable, sortable, paginated).
 *
 * Permissions for S2S authorization: validation-logs.list
 */
export const listValidationLog = <ThrowOnError extends boolean = false>(options?: Options<ListValidationLogData, ThrowOnError>) => (options?.client ?? client).get<ListValidationLogResponses, ListValidationLogErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/platform/validation-logs',
    ...options
});

/**
 * Okta oAuth2 redirect
 *
 * Redirect to Okta oAuth2 to get an access token
 */
export const oktaAuthRedirect = <ThrowOnError extends boolean = false>(options: Options<OktaAuthRedirectData, ThrowOnError>) => (options.client ?? client).get<unknown, OktaAuthRedirectErrors, ThrowOnError>({ url: '/platform/auth/okta/redirect', ...options });

/**
 * Okta oAuth2 callback
 *
 * Callback from Okta oAuth2 to get an access token
 */
export const getOktaAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<GetOktaAuthCallbackData, ThrowOnError>) => (options?.client ?? client).get<GetOktaAuthCallbackResponses, GetOktaAuthCallbackErrors, ThrowOnError>({ url: '/platform/auth/okta/callback', ...options });

/**
 * Entra OAuth2 redirect to get authorization code.
 */
export const entraAuthRedirect = <ThrowOnError extends boolean = false>(options?: Options<EntraAuthRedirectData, ThrowOnError>) => (options?.client ?? client).get<unknown, EntraAuthRedirectErrors, ThrowOnError>({ url: '/platform/auth/entra/redirect', ...options });

/**
 * Entra OAuth2 callback to get access token.
 */
export const entraAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<EntraAuthCallbackData, ThrowOnError>) => (options?.client ?? client).get<EntraAuthCallbackResponses, EntraAuthCallbackErrors, ThrowOnError>({ url: '/platform/auth/entra/callback', ...options });

/**
 * Decrypt the Data
 *
 * Permissions for S2S authorization: cryptography.decrypt
 */
export const decryptData = <ThrowOnError extends boolean = false>(options?: Options<DecryptDataData, ThrowOnError>) => (options?.client ?? client).post<DecryptDataResponses, DecryptDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/cryptography/decrypt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Encrypt the Data
 *
 * Permissions for S2S authorization: cryptography.encrypt
 */
export const encryptData = <ThrowOnError extends boolean = false>(options?: Options<EncryptDataData, ThrowOnError>) => (options?.client ?? client).post<EncryptDataResponses, EncryptDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/cryptography/encrypt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete an existing code route from storage.
 *
 * Permissions for S2S authorization: code_route
 *
 * @deprecated
 */
export const deprecatedDeleteCodeRoute = <ThrowOnError extends boolean = false>(options: Options<DeprecatedDeleteCodeRouteData, ThrowOnError>) => (options.client ?? client).delete<DeprecatedDeleteCodeRouteResponses, DeprecatedDeleteCodeRouteErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/code-routes/{code}',
    ...options
});

/**
 * Get a single code route from storage
 *
 * Permissions for S2S authorization: code_route
 *
 * @deprecated
 */
export const deprecatedGetCodeRoute = <ThrowOnError extends boolean = false>(options: Options<DeprecatedGetCodeRouteData, ThrowOnError>) => (options.client ?? client).get<DeprecatedGetCodeRouteResponses, DeprecatedGetCodeRouteErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/code-routes/{code}',
    ...options
});

/**
 * Update an existing code route in storage.
 *
 * Permissions for S2S authorization: code_route
 *
 * @deprecated
 */
export const deprecatedUpdateCodeRoute = <ThrowOnError extends boolean = false>(options: Options<DeprecatedUpdateCodeRouteData, ThrowOnError>) => (options.client ?? client).put<DeprecatedUpdateCodeRouteResponses, DeprecatedUpdateCodeRouteErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/code-routes/{code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of all codes from storage
 *
 * Permissions for S2S authorization: code_route
 *
 * @deprecated
 */
export const deprecatedListCodeRoutes = <ThrowOnError extends boolean = false>(options?: Options<DeprecatedListCodeRoutesData, ThrowOnError>) => (options?.client ?? client).get<DeprecatedListCodeRoutesResponses, DeprecatedListCodeRoutesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/code-routes',
    ...options
});

/**
 * Create a newly created code route in storage.
 *
 * Permissions for S2S authorization: code_route
 *
 * @deprecated
 */
export const deprecatedCreateCodeRoute = <ThrowOnError extends boolean = false>(options?: Options<DeprecatedCreateCodeRouteData, ThrowOnError>) => (options?.client ?? client).post<DeprecatedCreateCodeRouteResponses, DeprecatedCreateCodeRouteErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/code-routes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get an Action Verification Item
 */
export const findActionVerificationItem = <ThrowOnError extends boolean = false>(options: Options<FindActionVerificationItemData, ThrowOnError>) => (options.client ?? client).get<FindActionVerificationItemResponses, FindActionVerificationItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/action-verifications/items/{uuid}',
    ...options
});

/**
 * Create an Action Verification Item
 *
 * Permissions for S2S authorization: action_verification.write
 */
export const createActionVerification = <ThrowOnError extends boolean = false>(options?: Options<CreateActionVerificationData, ThrowOnError>) => (options?.client ?? client).post<CreateActionVerificationResponses, CreateActionVerificationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-STATIC-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/action-verifications/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Verify an Action Verification Item
 *
 * Permissions for S2S authorization: action_verification.write
 */
export const verifyActionVerification = <ThrowOnError extends boolean = false>(options: Options<VerifyActionVerificationData, ThrowOnError>) => (options.client ?? client).patch<VerifyActionVerificationResponses, VerifyActionVerificationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-STATIC-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/action-verifications/items/{uuid}/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete existing marketing communication from storage
 *
 * Please note that no matter the identifier provided, a search will be
 * performed based on the email address attached to that identifier. This
 * means that if you provide a subscriber UUID and it has `email@example.com`
 * attached to it, and there is another subscriber UUID that is also
 * connected to this email address, it will delete this marketing
 * communication as well.
 */
export const unsubscribeMarketingCommunication = <ThrowOnError extends boolean = false>(options: Options<UnsubscribeMarketingCommunicationData, ThrowOnError>) => (options.client ?? client).post<UnsubscribeMarketingCommunicationResponses, UnsubscribeMarketingCommunicationErrors, ThrowOnError>({ url: '/api/messaging/marketing-communications/{identifier}/unsubscribe', ...options });

/**
 * Store a newly created / Update existing marketing communication in storage
 *
 * Permissions for S2S authorization: marketing_communication.create_or_update
 */
export const createOrUpdateMarketingCommunication = <ThrowOnError extends boolean = false>(options?: Options<CreateOrUpdateMarketingCommunicationData, ThrowOnError>) => (options?.client ?? client).post<CreateOrUpdateMarketingCommunicationResponses, CreateOrUpdateMarketingCommunicationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/marketing-communications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete existing marketing communication from storage
 *
 * Please note that no matter the identifier provided, a search will be
 * performed based on the email address attached to that identifier. This
 * means that if you provide a subscriber UUID and it has `email@example.com`
 * attached to it, and there is another subscriber UUID that is also
 * connected to this email address, it will delete this marketing
 * communication as well.
 *
 * Permissions for S2S authorization: marketing_communication.delete
 */
export const deleteMarketingCommunication = <ThrowOnError extends boolean = false>(options: Options<DeleteMarketingCommunicationData, ThrowOnError>) => (options.client ?? client).delete<DeleteMarketingCommunicationResponses, DeleteMarketingCommunicationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/marketing-communications/{identifier}',
    ...options
});

/**
 * Get list of all matching marketing communications from storage
 *
 * Please note that no matter the identifier provided, a search will be
 * performed based on the email address attached to that identifier. This
 * means that if you provide a subscriber UUID and it has `email@example.com`
 * attached to it, and there is another subscriber UUID that is also
 * connected to this email address, it will return this marketing
 * communication as well.
 *
 * Permissions for S2S authorization: marketing_communication.find
 */
export const getMarketingCommunications = <ThrowOnError extends boolean = false>(options: Options<GetMarketingCommunicationsData, ThrowOnError>) => (options.client ?? client).get<GetMarketingCommunicationsResponses, GetMarketingCommunicationsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/marketing-communications/{identifier}',
    ...options
});

/**
 * Update email of existing marketing communications in storage.
 *
 * Permissions for S2S authorization: marketing_communication.update_email
 */
export const updateEmailOfMarketingCommunications = <ThrowOnError extends boolean = false>(options: Options<UpdateEmailOfMarketingCommunicationsData, ThrowOnError>) => (options.client ?? client).patch<UpdateEmailOfMarketingCommunicationsResponses, UpdateEmailOfMarketingCommunicationsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/marketing-communications/{oldEmail}/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update preferred language of existing marketing communications in storage.
 *
 * Permissions for S2S authorization: marketing_communication.update_language
 */
export const updatePreferredLanguageOfMarketingCommunications = <ThrowOnError extends boolean = false>(options: Options<UpdatePreferredLanguageOfMarketingCommunicationsData, ThrowOnError>) => (options.client ?? client).patch<UpdatePreferredLanguageOfMarketingCommunicationsResponses, UpdatePreferredLanguageOfMarketingCommunicationsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/marketing-communications/{identifier}/language',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unsubscribe from all push notifications for the authenticated consumer.
 */
export const consumerUnsubscribeAllPushNotifications = <ThrowOnError extends boolean = false>(options?: Options<ConsumerUnsubscribeAllPushNotificationsData, ThrowOnError>) => (options?.client ?? client).delete<ConsumerUnsubscribeAllPushNotificationsResponses, ConsumerUnsubscribeAllPushNotificationsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/push',
    ...options
});

/**
 * Subscribe to push notifications
 */
export const consumerSubscribePushNotification = <ThrowOnError extends boolean = false>(options?: Options<ConsumerSubscribePushNotificationData, ThrowOnError>) => (options?.client ?? client).post<ConsumerSubscribePushNotificationResponses, ConsumerSubscribePushNotificationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/push',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Unsubscribe from a push notification for the authenticated consumer.
 */
export const consumerUnsubscribePushNotification = <ThrowOnError extends boolean = false>(options: Options<ConsumerUnsubscribePushNotificationData, ThrowOnError>) => (options.client ?? client).delete<ConsumerUnsubscribePushNotificationResponses, ConsumerUnsubscribePushNotificationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/push/{subscriptionUuid}',
    ...options
});

/**
 * Get push notification subscriptions for a consumer.
 *
 * Permissions for S2S authorization: messaging.push.subscriptions
 */
export const getPushSubscriptionStatus = <ThrowOnError extends boolean = false>(options: Options<GetPushSubscriptionStatusData, ThrowOnError>) => (options.client ?? client).get<GetPushSubscriptionStatusResponses, GetPushSubscriptionStatusErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/push/status/{uuid}',
    ...options
});

/**
 * Unsubscribe from a specific push notification.
 *
 * Permissions for S2S authorization: messaging.push.unsubscribe
 */
export const unsubscribePushNotification = <ThrowOnError extends boolean = false>(options: Options<UnsubscribePushNotificationData, ThrowOnError>) => (options.client ?? client).post<UnsubscribePushNotificationResponses, UnsubscribePushNotificationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/push/{consumerUuid}/{subscriptionUuid}/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unsubscribe from all push notifications for the consumer
 *
 * Permissions for S2S authorization: messaging.push.unsubscribe_all
 */
export const unsubscribeAllPushNotifications = <ThrowOnError extends boolean = false>(options: Options<UnsubscribeAllPushNotificationsData, ThrowOnError>) => (options.client ?? client).post<UnsubscribeAllPushNotificationsResponses, UnsubscribeAllPushNotificationsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/push/{consumerUuid}/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send push notification to single subscription of a consumer.
 *
 * Permissions for S2S authorization: messaging.push.subscriptions
 */
export const sendSinglePushNotification = <ThrowOnError extends boolean = false>(options: Options<SendSinglePushNotificationData, ThrowOnError>) => (options.client ?? client).post<SendSinglePushNotificationResponses, SendSinglePushNotificationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/push/{consumerUuid}/send/{subscriptionUuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send push notification to all active subscriptions of a consumer.
 *
 * Permissions for S2S authorization: messaging.push.subscriptions
 */
export const sendPushNotification = <ThrowOnError extends boolean = false>(options: Options<SendPushNotificationData, ThrowOnError>) => (options.client ?? client).post<SendPushNotificationResponses, SendPushNotificationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/push/{consumerUuid}/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the campaign event report by campaign ID.
 *
 * Permissions for S2S authorization: messaging.reporting.read
 */
export const getCampaignEventReport = <ThrowOnError extends boolean = false>(options: Options<GetCampaignEventReportData, ThrowOnError>) => (options.client ?? client).get<GetCampaignEventReportResponses, GetCampaignEventReportErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/campaigns/{campaignId}/report',
    ...options
});

/**
 * Get paginated delivery logs for a campaign.
 *
 * Returns individual delivery event logs with provider responses.
 * Supports filtering by channel, provider_status, and driver.
 *
 * Permissions for S2S authorization: messaging.reporting.read
 */
export const showCampaignDeliveryLogs = <ThrowOnError extends boolean = false>(options: Options<ShowCampaignDeliveryLogsData, ThrowOnError>) => (options.client ?? client).get<ShowCampaignDeliveryLogsResponses, ShowCampaignDeliveryLogsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/campaigns/{campaignId}/delivery-logs',
    ...options
});

/**
 * Get paginated delivery logs across all drivers.
 *
 * Returns a unified view of delivery events from all drivers.
 *
 * Permissions for S2S authorization: messaging.reporting.read
 */
export const listDeliveryLogs = <ThrowOnError extends boolean = false>(options?: Options<ListDeliveryLogsData, ThrowOnError>) => (options?.client ?? client).get<ListDeliveryLogsResponses, ListDeliveryLogsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/reporting',
    ...options
});

/**
 * Report a client-side message delivery event.
 *
 * Stores a client-side delivery event (e.g. push notification received, opened, clicked).
 */
export const createDeliveryEvent = <ThrowOnError extends boolean = false>(options?: Options<CreateDeliveryEventData, ThrowOnError>) => (options?.client ?? client).post<CreateDeliveryEventResponses, CreateDeliveryEventErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/reporting',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create a new message event
 *
 * Permissions for S2S authorization: messaging.events.create_message_action, messaging
 */
export const messagingEventCreateMessage = <ThrowOnError extends boolean = false>(options?: Options<MessagingEventCreateMessageData, ThrowOnError>) => (options?.client ?? client).post<MessagingEventCreateMessageResponses, MessagingEventCreateMessageErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create a new message from submitted form data with consents, recaptcha etc
 */
export const messagingFormCreateMessage = <ThrowOnError extends boolean = false>(options?: Options<MessagingFormCreateMessageData, ThrowOnError>) => (options?.client ?? client).post<MessagingFormCreateMessageResponses, MessagingFormCreateMessageErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/forms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get a list of existing messaging templates
 *
 * Permissions for S2S authorization: messaging, messaging.templates.list_templates_action
 */
export const messagingLocalTemplatesList = <ThrowOnError extends boolean = false>(options?: Options<MessagingLocalTemplatesListData, ThrowOnError>) => (options?.client ?? client).get<MessagingLocalTemplatesListResponses, MessagingLocalTemplatesListErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/local-templates',
    ...options
});

/**
 * Create a new Messaging template
 *
 * Permissions for S2S authorization: messaging, messaging.templates.create_template_action
 */
export const messagingLocalTemplateCreate = <ThrowOnError extends boolean = false>(options?: Options<MessagingLocalTemplateCreateData, ThrowOnError>) => (options?.client ?? client).post<MessagingLocalTemplateCreateResponses, MessagingLocalTemplateCreateErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/local-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Remove existing Messaging template
 *
 * Permissions for S2S authorization: messaging, messaging.templates.delete_template_action
 */
export const messagingLocalTemplateDelete = <ThrowOnError extends boolean = false>(options: Options<MessagingLocalTemplateDeleteData, ThrowOnError>) => (options.client ?? client).delete<MessagingLocalTemplateDeleteResponses, MessagingLocalTemplateDeleteErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/local-templates/{uuid}',
    ...options
});

/**
 * Get detail of chosen messaging local template
 *
 * Permissions for S2S authorization: messaging, messaging.templates.get_template_action
 */
export const messagingLocalTemplateDetail = <ThrowOnError extends boolean = false>(options: Options<MessagingLocalTemplateDetailData, ThrowOnError>) => (options.client ?? client).get<MessagingLocalTemplateDetailResponses, MessagingLocalTemplateDetailErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/local-templates/{uuid}',
    ...options
});

/**
 * Update existing template
 *
 * Permissions for S2S authorization: messaging, messaging.templates.update_template_action
 */
export const messagingLocalTemplatesUpdate = <ThrowOnError extends boolean = false>(options: Options<MessagingLocalTemplatesUpdateData, ThrowOnError>) => (options.client ?? client).put<MessagingLocalTemplatesUpdateResponses, MessagingLocalTemplatesUpdateErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/messaging/local-templates/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webhook to update the status of a messaging campaign event for a CM provider.
 */
export const updateCmStatusWebhook = <ThrowOnError extends boolean = false>(options?: Options<UpdateCmStatusWebhookData, ThrowOnError>) => (options?.client ?? client).post<UpdateCmStatusWebhookResponses, UpdateCmStatusWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-CM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/messaging/campaigns/cm/update-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Update consumer consents
 *
 * Update consents for authenticated consumer
 *
 * Permissions for S2S authorization: consents
 * Personal access token scopes: users.consents.update
 */
export const updateConsents = <ThrowOnError extends boolean = false>(options: Options<UpdateConsentsData, ThrowOnError>) => (options.client ?? client).patch<UpdateConsentsResponses, UpdateConsentsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/consents/users/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webhook to accept changes coming from OneTrust.
 */
export const updateOneTrustPreferenceWebhook = <ThrowOnError extends boolean = false>(options?: Options<UpdateOneTrustPreferenceWebhookData, ThrowOnError>) => (options?.client ?? client).post<UpdateOneTrustPreferenceWebhookResponses, UpdateOneTrustPreferenceWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-ONE-TRUST-WEBHOOK-TOKEN', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/one-trust/update-consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Endpoint to synchronize OneTrust purposes with local data.
 */
export const updateOneTrustPurposes = <ThrowOnError extends boolean = false>(options?: Options<UpdateOneTrustPurposesData, ThrowOnError>) => (options?.client ?? client).post<UpdateOneTrustPurposesResponses, UpdateOneTrustPurposesErrors, ThrowOnError>({
    security: [{ name: 'X-DES-SIGNATURE', type: 'apiKey' }],
    url: '/webhooks/one-trust/sync-purposes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get feedback vote for website content.
 */
export const getFeedbackVote = <ThrowOnError extends boolean = false>(options: Options<GetFeedbackVoteData, ThrowOnError>) => (options.client ?? client).get<GetFeedbackVoteResponses, GetFeedbackVoteErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/content/feedback-votes',
    ...options
});

/**
 * Create feedback vote for website content.
 */
export const createFeedbackVote = <ThrowOnError extends boolean = false>(options?: Options<CreateFeedbackVoteData, ThrowOnError>) => (options?.client ?? client).post<CreateFeedbackVoteResponses, CreateFeedbackVoteErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/content/feedback-votes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get aggregated feedback vote summary by URL.
 */
export const getFeedbackVoteSummary = <ThrowOnError extends boolean = false>(options: Options<GetFeedbackVoteSummaryData, ThrowOnError>) => (options.client ?? client).get<GetFeedbackVoteSummaryResponses, GetFeedbackVoteSummaryErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/content/feedback-votes/summary',
    ...options
});

/**
 * List available webhook transformers
 *
 * Permissions for S2S authorization: webhooks
 */
export const listWebhookTransformers = <ThrowOnError extends boolean = false>(options?: Options<ListWebhookTransformersData, ThrowOnError>) => (options?.client ?? client).get<ListWebhookTransformersResponses, ListWebhookTransformersErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/transformers',
    ...options
});

/**
 * List of webhooks for tenant.
 *
 * Permissions for S2S authorization: webhooks
 */
export const listWebhookEventValues = <ThrowOnError extends boolean = false>(options?: Options<ListWebhookEventValuesData, ThrowOnError>) => (options?.client ?? client).get<ListWebhookEventValuesResponses, unknown, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/event-values',
    ...options
});

/**
 * List of webhooks for tenant.
 *
 * Permissions for S2S authorization: webhooks
 */
export const listWebhooks = <ThrowOnError extends boolean = false>(options?: Options<ListWebhooksData, ThrowOnError>) => (options?.client ?? client).get<ListWebhooksResponses, ListWebhooksErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks',
    ...options
});

/**
 * Create new tenant webhook
 *
 * Permissions for S2S authorization: webhooks
 */
export const createWebhook = <ThrowOnError extends boolean = false>(options?: Options<CreateWebhookData, ThrowOnError>) => (options?.client ?? client).post<CreateWebhookResponses, CreateWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Remove specific webhook
 *
 * Permissions for S2S authorization: webhooks
 */
export const deleteWebhook = <ThrowOnError extends boolean = false>(options: Options<DeleteWebhookData, ThrowOnError>) => (options.client ?? client).delete<DeleteWebhookResponses, DeleteWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/{webhook_id}',
    ...options
});

/**
 * Get specific webhook
 *
 * Permissions for S2S authorization: webhooks
 */
export const getWebhook = <ThrowOnError extends boolean = false>(options: Options<GetWebhookData, ThrowOnError>) => (options.client ?? client).get<GetWebhookResponses, GetWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/{webhook_id}',
    ...options
});

/**
 * Update specific webhook
 *
 * Permissions for S2S authorization: webhooks
 */
export const updateWebhook = <ThrowOnError extends boolean = false>(options: Options<UpdateWebhookData, ThrowOnError>) => (options.client ?? client).put<UpdateWebhookResponses, UpdateWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/webhooks/{webhook_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Make search request
 */
export const listSearchSearchableItem = <ThrowOnError extends boolean = false>(options?: Options<ListSearchSearchableItemData, ThrowOnError>) => (options?.client ?? client).get<ListSearchSearchableItemResponses, ListSearchSearchableItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/search',
    ...options
});

/**
 * Get the list of searchable items
 *
 * Permissions for S2S authorization: search.indexing
 */
export const listSearchables = <ThrowOnError extends boolean = false>(options?: Options<ListSearchablesData, ThrowOnError>) => (options?.client ?? client).get<ListSearchablesResponses, ListSearchablesErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/search/index',
    ...options
});

/**
 * Create or update searchable item
 *
 * Permissions for S2S authorization: search.indexing
 */
export const createSearchableItem = <ThrowOnError extends boolean = false>(options?: Options<CreateSearchableItemData, ThrowOnError>) => (options?.client ?? client).put<CreateSearchableItemResponses, CreateSearchableItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/search/index',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get specific searchable item
 *
 * Permissions for S2S authorization: search.indexing
 */
export const getSearchable = <ThrowOnError extends boolean = false>(options: Options<GetSearchableData, ThrowOnError>) => (options.client ?? client).get<GetSearchableResponses, GetSearchableErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/search/index/{item_id}/{type}',
    ...options
});

/**
 * Delete all searchable items from the index
 *
 * Permissions for S2S authorization: search.purge-critical
 */
export const deleteAllSearchable = <ThrowOnError extends boolean = false>(options?: Options<DeleteAllSearchableData, ThrowOnError>) => (options?.client ?? client).post<DeleteAllSearchableResponses, DeleteAllSearchableErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/search/index/purge',
    ...options
});

/**
 * Delete searchable item
 *
 * Permissions for S2S authorization: search.indexing
 */
export const deleteSearchable = <ThrowOnError extends boolean = false>(options: Options<DeleteSearchableData, ThrowOnError>) => (options.client ?? client).delete<DeleteSearchableResponses, DeleteSearchableErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/search/index/{item_id}',
    ...options
});

/**
 * Sync indexes
 *
 * Permissions for S2S authorization: search.sync
 * This endpoint can be queried in 3 ways
 * - with Okta Auth
 * - with the X-DES-STATIC-TOKEN header (configured as DES_EVO_STATIC_TOKEN, also if DES_EVO_ALLOWED_IPS is set, the request must originate from one of the allowed IPs
 */
export const initializeIndexes = <ThrowOnError extends boolean = false>(options?: Options<InitializeIndexesData, ThrowOnError>) => (options?.client ?? client).post<InitializeIndexesResponses, InitializeIndexesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-STATIC-TOKEN', type: 'apiKey' }],
    url: '/api/search/index/sync',
    ...options
});

/**
 * Validate inventory item code
 *
 * The inventory item must exist and not be registered to any other User at the time of request.<br>
 *
 * Permissions for S2S authorization: inventory
 */
export const validateInventoryItem = <ThrowOnError extends boolean = false>(options: Options<ValidateInventoryItemData, ThrowOnError>) => (options.client ?? client).get<ValidateInventoryItemResponses, ValidateInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}/validate',
    ...options
});

/**
 * Get items registered by specified user
 *
 * Permissions for S2S authorization: inventory
 */
export const listInventoryItem = <ThrowOnError extends boolean = false>(options?: Options<ListInventoryItemData, ThrowOnError>) => (options?.client ?? client).get<ListInventoryItemResponses, ListInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items',
    ...options
});

/**
 * Restore item registration state
 *
 * Removes all registrations, warranties, and other data associated with the inventory item.<br>
 * Does not remove the inventory item from the system.
 *
 * Permissions for S2S authorization: inventory, inventory.items-critical
 */
export const restoreInventoryItem = <ThrowOnError extends boolean = false>(options: Options<RestoreInventoryItemData, ThrowOnError>) => (options.client ?? client).delete<RestoreInventoryItemResponses, RestoreInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}',
    ...options
});

/**
 * Get inventory item by code
 *
 * Permissions for S2S authorization: inventory
 */
export const getInventoryItem = <ThrowOnError extends boolean = false>(options: Options<GetInventoryItemData, ThrowOnError>) => (options.client ?? client).get<GetInventoryItemResponses, GetInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}',
    ...options
});

/**
 * Update inventory item registrability
 *
 * Affects any feature related to device registration.<br>
 * Block or allow registration of the inventory item for users.
 *
 * Permissions for S2S authorization: inventory
 */
export const updateRegistrabilityInventoryItem = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrabilityInventoryItemData, ThrowOnError>) => (options.client ?? client).post<UpdateRegistrabilityInventoryItemResponses, UpdateRegistrabilityInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}/set-registrability',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register item for user by code
 *
 * The item must exist and not be registered to another user
 *
 * Permissions for S2S authorization: inventory
 */
export const registerInventoryItem = <ThrowOnError extends boolean = false>(options: Options<RegisterInventoryItemData, ThrowOnError>) => (options.client ?? client).post<RegisterInventoryItemResponses, RegisterInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unregister item for user by code
 *
 * The item must be registered to the user and be eligible for unregistration.
 *
 * Permissions for S2S authorization: inventory
 */
export const unregisterInventoryItem = <ThrowOnError extends boolean = false>(options: Options<UnregisterInventoryItemData, ThrowOnError>) => (options.client ?? client).post<UnregisterInventoryItemResponses, UnregisterInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}/unregister',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach item to consumer
 *
 * To complete the inventory item registration flow.<br>
 * The inventory item must be registered by the External DES ID or Personal Identifier.<br>
 *
 * Permissions for S2S authorization: inventory
 */
export const attachConsumerToInventoryItem = <ThrowOnError extends boolean = false>(options: Options<AttachConsumerToInventoryItemData, ThrowOnError>) => (options.client ?? client).post<AttachConsumerToInventoryItemResponses, AttachConsumerToInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}/attach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if item is attachable to consumer
 *
 * The inventory item must exist and be registered to an owner.
 *
 * Permissions for S2S authorization: inventory
 */
export const isAttachableToConsumer = <ThrowOnError extends boolean = false>(options: Options<IsAttachableToConsumerData, ThrowOnError>) => (options.client ?? client).get<IsAttachableToConsumerResponses, IsAttachableToConsumerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}/is-attachable',
    ...options
});

/**
 * Get warranty by item code
 *
 * Permissions for S2S authorization: inventory, inventory.show
 */
export const getWarranty = <ThrowOnError extends boolean = false>(options: Options<GetWarrantyData, ThrowOnError>) => (options.client ?? client).get<GetWarrantyResponses, GetWarrantyErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}/warranty',
    ...options
});

/**
 * Update warranty by item code
 *
 * Permissions for S2S authorization: inventory, inventory.warranties.update
 */
export const updateWarranty = <ThrowOnError extends boolean = false>(options: Options<UpdateWarrantyData, ThrowOnError>) => (options.client ?? client).put<UpdateWarrantyResponses, UpdateWarrantyErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}/warranty',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel warranty by item code
 *
 * Permissions for S2S authorization: inventory, inventory.cancel
 */
export const canceledWarranty = <ThrowOnError extends boolean = false>(options: Options<CanceledWarrantyData, ThrowOnError>) => (options.client ?? client).post<CanceledWarrantyResponses, CanceledWarrantyErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/inventory/items/{inventory_item_code}/warranty/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [User] Get registered inventory items
 */
export const listUserInventoryItem = <ThrowOnError extends boolean = false>(options?: Options<ListUserInventoryItemData, ThrowOnError>) => (options?.client ?? client).get<ListUserInventoryItemResponses, ListUserInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/inventory/items',
    ...options
});

/**
 * [User] Pair item with code
 *
 * The inventory item must be a real Gen4 device registered to the current User at the time of request.<br>
 */
export const userPairInventoryItem = <ThrowOnError extends boolean = false>(options: Options<UserPairInventoryItemData, ThrowOnError>) => (options.client ?? client).post<UserPairInventoryItemResponses, UserPairInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/inventory/items/{inventory_item_code}/pair',
    ...options
});

/**
 * [User] Unpair item with code
 *
 * The inventory item must be a real Gen4 device paired to the current User at the time of request.<br>
 */
export const userUnpairInventoryItem = <ThrowOnError extends boolean = false>(options: Options<UserUnpairInventoryItemData, ThrowOnError>) => (options.client ?? client).post<UserUnpairInventoryItemResponses, UserUnpairInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/inventory/items/{inventory_item_code}/unpair',
    ...options
});

/**
 * [User] Register item with code
 *
 * The inventory item must exist and not be registered to any other User at the time of request.<br>
 *
 * Permissions for S2S authorization: inventory, inventory.items.register
 */
export const registerUserInventoryItem = <ThrowOnError extends boolean = false>(options: Options<RegisterUserInventoryItemData, ThrowOnError>) => (options.client ?? client).post<RegisterUserInventoryItemResponses, RegisterUserInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/inventory/items/{inventory_item_code}/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [User] Unregister item with code
 *
 * The item must be registered to the user and be eligible for unregistration.
 */
export const userUnregisterInventoryItem = <ThrowOnError extends boolean = false>(options: Options<UserUnregisterInventoryItemData, ThrowOnError>) => (options.client ?? client).post<UserUnregisterInventoryItemResponses, UserUnregisterInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/inventory/items/{inventory_item_code}/unregister',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [User] Check if item is attachable
 *
 * The inventory item must exist and be registered to an owner.
 */
export const userIsAttachableInventoryItem = <ThrowOnError extends boolean = false>(options: Options<UserIsAttachableInventoryItemData, ThrowOnError>) => (options.client ?? client).get<UserIsAttachableInventoryItemResponses, UserIsAttachableInventoryItemErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-CONSUMER-IAM-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/inventory/items/{inventory_item_code}/is-attachable',
    ...options
});

/**
 * List inventory items for reporting
 *
 * Permissions for S2S authorization: inventory, inventory-reporting.read
 */
export const inventoryItemsReport = <ThrowOnError extends boolean = false>(options?: Options<InventoryItemsReportData, ThrowOnError>) => (options?.client ?? client).get<InventoryItemsReportResponses, InventoryItemsReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/reporting/items',
    ...options
});

/**
 * Export inventory items for reporting
 *
 * Permissions for S2S authorization: inventory, inventory-reporting.read
 *
 * @deprecated
 */
export const exportInventoryItemsReport = <ThrowOnError extends boolean = false>(options?: Options<ExportInventoryItemsReportData, ThrowOnError>) => (options?.client ?? client).get<ExportInventoryItemsReportResponses, ExportInventoryItemsReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/reporting/items/export',
    ...options
});

/**
 * Get inventory import statistics
 *
 * Permissions for S2S authorization: inventory, inventory-reporting.read
 */
export const inventoryImportReport = <ThrowOnError extends boolean = false>(options?: Options<InventoryImportReportData, ThrowOnError>) => (options?.client ?? client).get<InventoryImportReportResponses, InventoryImportReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/reporting/imports',
    ...options
});

/**
 * Get inventory import errors
 *
 * Permissions for S2S authorization: inventory, inventory-reporting.read
 */
export const importInventoryErrors = <ThrowOnError extends boolean = false>(options: Options<ImportInventoryErrorsData, ThrowOnError>) => (options.client ?? client).get<ImportInventoryErrorsResponses, ImportInventoryErrorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/reporting/imports/{id}/errors',
    ...options
});

/**
 * Get prefixes with product info
 *
 * Permissions for S2S authorization: inventory, inventory-reporting.read
 */
export const prefixesReport = <ThrowOnError extends boolean = false>(options?: Options<PrefixesReportData, ThrowOnError>) => (options?.client ?? client).get<PrefixesReportResponses, PrefixesReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/reporting/prefixes',
    ...options
});

/**
 * List Inventory Exports
 *
 * Permissions for S2S authorization: inventory, inventory-export.read
 */
export const listInventoryExports = <ThrowOnError extends boolean = false>(options?: Options<ListInventoryExportsData, ThrowOnError>) => (options?.client ?? client).get<ListInventoryExportsResponses, ListInventoryExportsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/export',
    ...options
});

/**
 * Get Inventory Export
 *
 * Permissions for S2S authorization: inventory, inventory-export.read
 */
export const getInventoryExport = <ThrowOnError extends boolean = false>(options: Options<GetInventoryExportData, ThrowOnError>) => (options.client ?? client).get<GetInventoryExportResponses, GetInventoryExportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/export/{export_id}',
    ...options
});

/**
 * Start Inventory Export
 *
 * Permissions for S2S authorization: inventory, inventory-export.write
 */
export const exportStartInventory = <ThrowOnError extends boolean = false>(options?: Options<ExportStartInventoryData, ThrowOnError>) => (options?.client ?? client).post<ExportStartInventoryResponses, ExportStartInventoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/export/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Trigger inventory items import
 *
 * If the filename is provided, the import will be triggered only for that file as a background job<br>
 * Otherwise, the import will be triggered for all the files in the source directory<br>
 * Permissions for S2S authorization: inventory, inventory-import.write
 */
export const importInventoryItems = <ThrowOnError extends boolean = false>(options?: Options<ImportInventoryItemsData, ThrowOnError>) => (options?.client ?? client).post<ImportInventoryItemsResponses, ImportInventoryItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/import/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Trigger legacy device inventory import from storage
 *
 * The import will be triggered only for that file as a background job<br>
 * Permissions for S2S authorization: inventory, inventory-import.write
 *
 * @deprecated
 */
export const importDiSv1Storage = <ThrowOnError extends boolean = false>(options?: Options<ImportDiSv1StorageData, ThrowOnError>) => (options?.client ?? client).post<ImportDiSv1StorageResponses, ImportDiSv1StorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/import/device-inventory/storage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Trigger legacy device inventory import from payload
 *
 * The import will be triggered only for that payload as a background job<br>
 * Permissions for S2S authorization: inventory, inventory-import.write
 *
 * @deprecated
 */
export const diSv1PayloadImport = <ThrowOnError extends boolean = false>(options?: Options<DiSv1PayloadImportData, ThrowOnError>) => (options?.client ?? client).post<DiSv1PayloadImportResponses, DiSv1PayloadImportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/import/device-inventory/payload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Trigger pack codes import
 *
 * Permissions for S2S authorization: inventory, inventory-import.write
 */
export const importPackCodes = <ThrowOnError extends boolean = false>(options?: Options<ImportPackCodesData, ThrowOnError>) => (options?.client ?? client).post<ImportPackCodesResponses, ImportPackCodesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/import/pack-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get list of all spex clusters
 *
 * Permissions for S2S authorization: inventory
 */
export const getSpexClusters = <ThrowOnError extends boolean = false>(options?: Options<GetSpexClustersData, ThrowOnError>) => (options?.client ?? client).get<GetSpexClustersResponses, GetSpexClustersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/spex-clusters',
    ...options
});

/**
 * Store a new spex cluster
 *
 * Permissions for S2S authorization: inventory
 */
export const spexCluster = <ThrowOnError extends boolean = false>(options?: Options<SpexClusterData, ThrowOnError>) => (options?.client ?? client).post<SpexClusterResponses, SpexClusterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/spex-clusters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete an existing spex cluster
 *
 * Permissions for S2S authorization: inventory
 */
export const deleteSpexCluster = <ThrowOnError extends boolean = false>(options: Options<DeleteSpexClusterData, ThrowOnError>) => (options.client ?? client).delete<DeleteSpexClusterResponses, DeleteSpexClusterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/spex-clusters/{name}',
    ...options
});

/**
 * Get a single spex cluster
 *
 * Permissions for S2S authorization: inventory
 */
export const getSpexCluster = <ThrowOnError extends boolean = false>(options: Options<GetSpexClusterData, ThrowOnError>) => (options.client ?? client).get<GetSpexClusterResponses, GetSpexClusterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/spex-clusters/{name}',
    ...options
});

/**
 * Update an existing spex cluster country codes.
 *
 * Permissions for S2S authorization: inventory
 */
export const updateSpexCluster = <ThrowOnError extends boolean = false>(options: Options<UpdateSpexClusterData, ThrowOnError>) => (options.client ?? client).put<UpdateSpexClusterResponses, UpdateSpexClusterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/inventory/spex-clusters/{name}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Persist reviews from Trustpilot
 *
 * When new review is being published on Trustpilot by user, Trustpilot notifies RPS,
 * RPS fetch the new reviews from it and store in DB
 */
export const createReviewEvent = <ThrowOnError extends boolean = false>(options?: Options<CreateReviewEventData, ThrowOnError>) => (options?.client ?? client).post<CreateReviewEventResponses, CreateReviewEventErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/products/reviews/event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get product reviews list with pagination.
 *
 * Permissions for S2S authorization: product.reviews
 */
export const listReviews = <ThrowOnError extends boolean = false>(options?: Options<ListReviewsData, ThrowOnError>) => (options?.client ?? client).get<ListReviewsResponses, ListReviewsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/products/reviews',
    ...options
});

/**
 * Trigger fetching all reviews from Trustpilot, for purpose when Trustpilot credential being updated
 *
 * Permissions for S2S authorization: products.reviews
 */
export const importReviews = <ThrowOnError extends boolean = false>(options?: Options<ImportReviewsData, ThrowOnError>) => (options?.client ?? client).post<ImportReviewsResponses, ImportReviewsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/products/reviews/sync',
    ...options
});

/**
 * Get products list with pagination.
 *
 * Permissions for S2S authorization: products.index
 */
export const listProduct = <ThrowOnError extends boolean = false>(options?: Options<ListProductData, ThrowOnError>) => (options?.client ?? client).get<ListProductResponses, ListProductErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/products',
    ...options
});

/**
 * Get single product.
 *
 * Permissions for S2S authorization: products.show
 */
export const getProduct = <ThrowOnError extends boolean = false>(options: Options<GetProductData, ThrowOnError>) => (options.client ?? client).get<GetProductResponses, GetProductErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/products/{sku}',
    ...options
});

/**
 * Import a product base one Magento.
 *
 * Permissions for S2S authorization: products.import
 */
export const importProduct = <ThrowOnError extends boolean = false>(options?: Options<ImportProductData, ThrowOnError>) => (options?.client ?? client).post<ImportProductResponses, ImportProductErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/products/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete a product base one Magento.
 *
 * Permissions for S2S authorization: products.import
 */
export const importDeleteProduct = <ThrowOnError extends boolean = false>(options: Options<ImportDeleteProductData, ThrowOnError>) => (options.client ?? client).delete<ImportDeleteProductResponses, ImportDeleteProductErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/products/import/{sku}',
    ...options
});

/**
 * Initialize authorisation
 */
export const initializeAuthorisation = <ThrowOnError extends boolean = false>(options?: Options<InitializeAuthorisationData, ThrowOnError>) => (options?.client ?? client).post<InitializeAuthorisationResponses, InitializeAuthorisationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/authorisations/init',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Show available credit cards
 */
export const getCreditCards = <ThrowOnError extends boolean = false>(options?: Options<GetCreditCardsData, ThrowOnError>) => (options?.client ?? client).get<GetCreditCardsResponses, GetCreditCardsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/cards',
    ...options
});

/**
 * Get credit card by uuid
 */
export const getCreditCard = <ThrowOnError extends boolean = false>(options: Options<GetCreditCardData, ThrowOnError>) => (options.client ?? client).get<GetCreditCardResponses, GetCreditCardErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/cards/{uuid}',
    ...options
});

/**
 * Generate a payment token and store affected order in the database
 */
export const createPayment = <ThrowOnError extends boolean = false>(options?: Options<CreatePaymentData, ThrowOnError>) => (options?.client ?? client).put<CreatePaymentResponses, CreatePaymentErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/generate-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Show available payment methods
 */
export const getPaymentMethods = <ThrowOnError extends boolean = false>(options?: Options<GetPaymentMethodsData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentMethodsResponses, GetPaymentMethodsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/methods',
    ...options
});

/**
 * Create new payment method
 *
 * Permissions for S2S authorization: payments.methods
 */
export const createPaymentMethod = <ThrowOnError extends boolean = false>(options?: Options<CreatePaymentMethodData, ThrowOnError>) => (options?.client ?? client).post<CreatePaymentMethodResponses, CreatePaymentMethodErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/methods',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Return JS client for given payment method
 */
export const getPaymentMethodClient = <ThrowOnError extends boolean = false>(options: Options<GetPaymentMethodClientData, ThrowOnError>) => (options.client ?? client).get<GetPaymentMethodClientResponses, GetPaymentMethodClientErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/methods/{code}/client',
    ...options
});

/**
 * Get payment by UUID
 */
export const getPayment = <ThrowOnError extends boolean = false>(options: Options<GetPaymentData, ThrowOnError>) => (options.client ?? client).get<GetPaymentResponses, GetPaymentErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/{uuid}',
    ...options
});

/**
 * Update payment by UUID
 *
 * Permissions for S2S authorization: payments.update
 */
export const updatePayment = <ThrowOnError extends boolean = false>(options: Options<UpdatePaymentData, ThrowOnError>) => (options.client ?? client).put<UpdatePaymentResponses, UpdatePaymentErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get token by order id
 */
export const getToken = <ThrowOnError extends boolean = false>(options: Options<GetTokenData, ThrowOnError>) => (options.client ?? client).get<GetTokenResponses, GetTokenErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/tokens/{order_id}',
    ...options
});

/**
 * Create a payment session for secured fields flow
 */
export const createPaymentSession = <ThrowOnError extends boolean = false>(options?: Options<CreatePaymentSessionData, ThrowOnError>) => (options?.client ?? client).post<CreatePaymentSessionResponses, CreatePaymentSessionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Initialize payment session
 */
export const initializePaymentSession = <ThrowOnError extends boolean = false>(options?: Options<InitializePaymentSessionData, ThrowOnError>) => (options?.client ?? client).post<InitializePaymentSessionResponses, InitializePaymentSessionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/sessions/init',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Pay for an order using a secured fields payment session
 */
export const paySession = <ThrowOnError extends boolean = false>(options?: Options<PaySessionData, ThrowOnError>) => (options?.client ?? client).post<PaySessionResponses, PaySessionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/sessions/pay',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get refund by UUID
 *
 * Permissions for S2S authorization: payments.update
 */
export const getRefund = <ThrowOnError extends boolean = false>(options: Options<GetRefundData, ThrowOnError>) => (options.client ?? client).get<GetRefundResponses, GetRefundErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/refunds/{uuid}',
    ...options
});

/**
 * Update refund by UUID
 *
 * Permissions for S2S authorization: payments.update
 */
export const updateRefund = <ThrowOnError extends boolean = false>(options: Options<UpdateRefundData, ThrowOnError>) => (options.client ?? client).put<UpdateRefundResponses, UpdateRefundErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/refunds/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get transaction by external id
 *
 * Permissions for S2S authorization: payments.update
 */
export const getTransaction = <ThrowOnError extends boolean = false>(options: Options<GetTransactionData, ThrowOnError>) => (options.client ?? client).get<GetTransactionResponses, GetTransactionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/transactions/{external_id}',
    ...options
});

/**
 * Get payment external data
 *
 * Permissions for S2S authorization: payments.update
 */
export const getPaymentExternalData = <ThrowOnError extends boolean = false>(options: Options<GetPaymentExternalDataData, ThrowOnError>) => (options.client ?? client).get<GetPaymentExternalDataResponses, GetPaymentExternalDataErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/data/{uuid}',
    ...options
});

/**
 * Update payment external data
 *
 * Permissions for S2S authorization: payments.update
 */
export const updatePaymentExternalData = <ThrowOnError extends boolean = false>(options: Options<UpdatePaymentExternalDataData, ThrowOnError>) => (options.client ?? client).put<UpdatePaymentExternalDataResponses, UpdatePaymentExternalDataErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/data/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create authorisation
 *
 * Permissions for S2S authorization: payments.update
 */
export const createAuthorisation = <ThrowOnError extends boolean = false>(options?: Options<CreateAuthorisationData, ThrowOnError>) => (options?.client ?? client).post<CreateAuthorisationResponses, CreateAuthorisationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/authorisations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create new refund
 *
 * Permissions for S2S authorization: payments
 */
export const createRefund = <ThrowOnError extends boolean = false>(options?: Options<CreateRefundData, ThrowOnError>) => (options?.client ?? client).post<CreateRefundResponses, CreateRefundErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/refunds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete payment method by code
 *
 * Permissions for S2S authorization: payments.methods
 */
export const deletePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<DeletePaymentMethodData, ThrowOnError>) => (options.client ?? client).delete<DeletePaymentMethodResponses, DeletePaymentMethodErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/methods/{code}',
    ...options
});

/**
 * Get payment method by code
 *
 * Permissions for S2S authorization: payments.methods
 */
export const getPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<GetPaymentMethodData, ThrowOnError>) => (options.client ?? client).get<GetPaymentMethodResponses, GetPaymentMethodErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/methods/{code}',
    ...options
});

/**
 * Update payment method by code
 *
 * Permissions for S2S authorization: payments.methods
 */
export const updatePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<UpdatePaymentMethodData, ThrowOnError>) => (options.client ?? client).put<UpdatePaymentMethodResponses, UpdatePaymentMethodErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/methods/{code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sends the consumer a link to pay an order.
 *
 * Permissions for S2S authorization: payments
 */
export const sendPaymentLink = <ThrowOnError extends boolean = false>(options?: Options<SendPaymentLinkData, ThrowOnError>) => (options?.client ?? client).post<SendPaymentLinkResponses, SendPaymentLinkErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/payments/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get the list of adapters.
 *
 * Permissions for S2S authorization: adapters
 */
export const listAdapters = <ThrowOnError extends boolean = false>(options?: Options<ListAdaptersData, ThrowOnError>) => (options?.client ?? client).get<ListAdaptersResponses, ListAdaptersErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/adapters',
    ...options
});

/**
 * Create new adapter
 *
 * Permissions for S2S authorization: adapters
 */
export const createAdapter = <ThrowOnError extends boolean = false>(options?: Options<CreateAdapterData, ThrowOnError>) => (options?.client ?? client).post<CreateAdapterResponses, CreateAdapterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/adapters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete specific adapter
 *
 * Permissions for S2S authorization: adapters
 */
export const deleteAdapter = <ThrowOnError extends boolean = false>(options: Options<DeleteAdapterData, ThrowOnError>) => (options.client ?? client).delete<DeleteAdapterResponses, DeleteAdapterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/adapters/{adapter_code}',
    ...options
});

/**
 * Get specific adapter
 *
 * Permissions for S2S authorization: adapters
 */
export const getAdapter = <ThrowOnError extends boolean = false>(options: Options<GetAdapterData, ThrowOnError>) => (options.client ?? client).get<GetAdapterResponses, GetAdapterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/adapters/{adapter_code}',
    ...options
});

/**
 * Update specific adapter
 *
 * Permissions for S2S authorization: adapters
 */
export const updateAdapter = <ThrowOnError extends boolean = false>(options: Options<UpdateAdapterData, ThrowOnError>) => (options.client ?? client).put<UpdateAdapterResponses, UpdateAdapterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/adapters/{adapter_code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Connect adapter to tenant
 *
 * Permissions for S2S authorization: adapters
 */
export const connectAdapter = <ThrowOnError extends boolean = false>(options?: Options<ConnectAdapterData, ThrowOnError>) => (options?.client ?? client).post<ConnectAdapterResponses, ConnectAdapterErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/adapters/connect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Disconnect adapter
 *
 * Permissions for S2S authorization: adapters
 */
export const disconnectAdapter = <ThrowOnError extends boolean = false>(options?: Options<DisconnectAdapterData, ThrowOnError>) => (options?.client ?? client).post<DisconnectAdapterResponses, DisconnectAdapterErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/adapters/disconnect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Returns all available verification methods
 */
export const getAvailableVerificationMethodsController = <ThrowOnError extends boolean = false>(options?: Options<GetAvailableVerificationMethodsControllerData, ThrowOnError>) => (options?.client ?? client).get<GetAvailableVerificationMethodsControllerResponses, GetAvailableVerificationMethodsControllerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/age-verification/methods',
    ...options
});

/**
 * Returns if tenant has hidden verification
 */
export const checkIfHasHiddenVerificationController = <ThrowOnError extends boolean = false>(options?: Options<CheckIfHasHiddenVerificationControllerData, ThrowOnError>) => (options?.client ?? client).get<CheckIfHasHiddenVerificationControllerResponses, CheckIfHasHiddenVerificationControllerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/age-verification/methods/has-hidden-verification',
    ...options
});

/**
 * Performs age verification for synchronous method and verify already initialized verification for asynchronous method
 */
export const performAgeVerificationController = <ThrowOnError extends boolean = false>(options?: Options<PerformAgeVerificationControllerData, ThrowOnError>) => (options?.client ?? client).post<PerformAgeVerificationControllerResponses, PerformAgeVerificationControllerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/age-verification/verify/init',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Initializes asynchronous age verification
 */
export const initializeAsynchronousAgeVerificationController = <ThrowOnError extends boolean = false>(options?: Options<InitializeAsynchronousAgeVerificationControllerData, ThrowOnError>) => (options?.client ?? client).post<InitializeAsynchronousAgeVerificationControllerResponses, InitializeAsynchronousAgeVerificationControllerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/age-verification/verify/init-async',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets age verification result
 */
export const getAgeVerificationResultController = <ThrowOnError extends boolean = false>(options: Options<GetAgeVerificationResultControllerData, ThrowOnError>) => (options.client ?? client).get<GetAgeVerificationResultControllerResponses, GetAgeVerificationResultControllerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/age-verification/verify/verification-result/{uuid}/{token}',
    ...options
});

/**
 * Gets date of performing age verification for given token
 */
export const getAgeVerificationDateController = <ThrowOnError extends boolean = false>(options: Options<GetAgeVerificationDateControllerData, ThrowOnError>) => (options.client ?? client).get<GetAgeVerificationDateControllerResponses, GetAgeVerificationDateControllerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/age-verification/verify/{token}/date',
    ...options
});

/**
 * Updates consumer uuid in age verification item hash
 */
export const updateConsumerUuidController = <ThrowOnError extends boolean = false>(options?: Options<UpdateConsumerUuidControllerData, ThrowOnError>) => (options?.client ?? client).post<UpdateConsumerUuidControllerResponses, UpdateConsumerUuidControllerErrors, ThrowOnError>({
    security: [{ name: 'X-DES-SIGNATURE', type: 'apiKey' }],
    url: '/api/age-verification/webhooks/update-consumer-uuid',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets users public domain configuration
 */
export const getUsersPublicDomainConfiguration = <ThrowOnError extends boolean = false>(options?: Options<GetUsersPublicDomainConfigurationData, ThrowOnError>) => (options?.client ?? client).get<GetUsersPublicDomainConfigurationResponses, GetUsersPublicDomainConfigurationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/configuration',
    ...options
});

/**
 * Initialize authentication
 *
 * Authenticate a user based on their credentials and related strategy. Returning an initialization details
 *
 * Permissions for S2S authorization: users-authentication
 */
export const initAuthentication = <ThrowOnError extends boolean = false>(options?: Options<InitAuthenticationData, ThrowOnError>) => (options?.client ?? client).post<InitAuthenticationResponses, InitAuthenticationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-STATIC-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/initialize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Logouts user and deletes given user token
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => (options?.client ?? client).delete<LogoutResponses, LogoutErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/sessions',
    ...options
});

/**
 * Authenticate a User
 *
 * Authenticate a user based on their credentials and related strategy. Returning an auth token upon success.
 *
 * Permissions for S2S authorization: users-authentication
 */
export const authenticate = <ThrowOnError extends boolean = false>(options?: Options<AuthenticateData, ThrowOnError>) => (options?.client ?? client).post<AuthenticateResponses, AuthenticateErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-STATIC-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Validates given user token
 */
export const validateSession = <ThrowOnError extends boolean = false>(options?: Options<ValidateSessionData, ThrowOnError>) => (options?.client ?? client).post<ValidateSessionResponses, ValidateSessionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/sessions/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Issue and send forgot password token for a user
 * It creates and sends forgot password token for existing user (by email)
 *
 * Permissions for S2S authorization: users-authentication
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options?: Options<ForgotPasswordData, ThrowOnError>) => (options?.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-STATIC-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/password/forget',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Change password for a user
 * It sets new password for authenticated user
 */
export const changePassword = <ThrowOnError extends boolean = false>(options?: Options<ChangePasswordData, ThrowOnError>) => (options?.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/password/change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Set new password for a user
 * It sets new password for a user identified by provided forgot password token
 *
 * Permissions for S2S authorization: users-authentication
 */
export const setPassword = <ThrowOnError extends boolean = false>(options: Options<SetPasswordData, ThrowOnError>) => (options.client ?? client).post<SetPasswordResponses, SetPasswordErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/password/change/{token}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create bulk one time limited tokens for multiple users
 *
 * Permissions for S2S authorization: platform.one-time-limited-token
 */
export const createBulkOneTimeLimitedTokenRequest = <ThrowOnError extends boolean = false>(options?: Options<CreateBulkOneTimeLimitedTokenRequestData, ThrowOnError>) => (options?.client ?? client).post<CreateBulkOneTimeLimitedTokenRequestResponses, CreateBulkOneTimeLimitedTokenRequestErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/one-time-limited-token/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create a one time limited token request for user
 *
 * Permissions for S2S authorization: platform.one-time-limited-token
 */
export const createOneTimeLimitedTokenRequest = <ThrowOnError extends boolean = false>(options: Options<CreateOneTimeLimitedTokenRequestData, ThrowOnError>) => (options.client ?? client).post<CreateOneTimeLimitedTokenRequestResponses, CreateOneTimeLimitedTokenRequestErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/one-time-limited-token/{uuid}/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete specified one time limited token request with all related authentication sessions
 *
 * Permissions for S2S authorization: platform.one-time-limited-token
 */
export const deleteOneTimeLimitedTokenRequest = <ThrowOnError extends boolean = false>(options: Options<DeleteOneTimeLimitedTokenRequestData, ThrowOnError>) => (options.client ?? client).delete<DeleteOneTimeLimitedTokenRequestResponses, DeleteOneTimeLimitedTokenRequestErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/one-time-limited-token/{token}/token',
    ...options
});

/**
 * Create a one time limited token for the authenticated user
 *
 * Creates a short-lived (30 seconds), single-use, unscoped one time limited token
 */
export const createConsumerOneTimeLimitedToken = <ThrowOnError extends boolean = false>(options?: Options<CreateConsumerOneTimeLimitedTokenData, ThrowOnError>) => (options?.client ?? client).post<CreateConsumerOneTimeLimitedTokenResponses, CreateConsumerOneTimeLimitedTokenErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/authentication/one-time-limited-token',
    ...options
});

/**
 * Verify referral code
 *
 * Permissions for S2S authorization: users.referrals
 */
export const verifyReferralCode = <ThrowOnError extends boolean = false>(options: Options<VerifyReferralCodeData, ThrowOnError>) => (options.client ?? client).get<VerifyReferralCodeResponses, VerifyReferralCodeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/referrals/{code}/verify',
    ...options
});

/**
 * Initialize registration
 *
 * Initialize registration process by sending OTP code.
 *
 * Permissions for S2S authorization: users-registration
 */
export const initRegistration = <ThrowOnError extends boolean = false>(options?: Options<InitRegistrationData, ThrowOnError>) => (options?.client ?? client).post<InitRegistrationResponses, InitRegistrationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/initialize-registration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Register a consumer
 *
 * Permissions for S2S authorization: users-registration
 */
export const register = <ThrowOnError extends boolean = false>(options?: Options<RegisterData, ThrowOnError>) => (options?.client ?? client).post<RegisterResponses, RegisterErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Synchronize consumer addresses
 *
 * Synchronize all addresses for consumer
 *
 * Permissions for S2S authorization: users.addresses-sync
 */
export const synchronizeAddresses = <ThrowOnError extends boolean = false>(options: Options<SynchronizeAddressesData, ThrowOnError>) => (options.client ?? client).put<SynchronizeAddressesResponses, SynchronizeAddressesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{identifier}/addresses/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Store consumer address
 *
 * Store new address for authenticated consumer
 *
 * Permissions for S2S authorization: users.write.addresses
 */
export const storeAddress = <ThrowOnError extends boolean = false>(options: Options<StoreAddressData, ThrowOnError>) => (options.client ?? client).post<StoreAddressResponses, StoreAddressErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/addresses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete consumer address
 *
 * Delete existing address for authenticated consumer
 *
 * Permissions for S2S authorization: users.write.addresses
 */
export const deleteAddress = <ThrowOnError extends boolean = false>(options: Options<DeleteAddressData, ThrowOnError>) => (options.client ?? client).delete<DeleteAddressResponses, DeleteAddressErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/addresses/{addressId}',
    ...options
});

/**
 * Update consumer address
 *
 * Update existing address for authenticated consumer
 *
 * Permissions for S2S authorization: users.write.addresses
 */
export const updateAddress = <ThrowOnError extends boolean = false>(options: Options<UpdateAddressData, ThrowOnError>) => (options.client ?? client).put<UpdateAddressResponses, UpdateAddressErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/addresses/{addressId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set default address
 *
 * Set existing address as default shipping or billing for authenticated consumer
 *
 * Permissions for S2S authorization: users.write.addresses
 */
export const setDefaultAddress = <ThrowOnError extends boolean = false>(options: Options<SetDefaultAddressData, ThrowOnError>) => (options.client ?? client).put<SetDefaultAddressResponses, SetDefaultAddressErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/addresses/{addressType}/{addressId}',
    ...options
});

/**
 * Create the update email request
 *
 * Permissions for S2S authorization: users.write
 *
 * Personal access token scopes: users.email.update
 */
export const updateEmailRequest = <ThrowOnError extends boolean = false>(options: Options<UpdateEmailRequestData, ThrowOnError>) => (options.client ?? client).post<UpdateEmailRequestResponses, UpdateEmailRequestErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/profile/email/request-update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change consumer phone
 *
 * Permissions for S2S authorization: users.write
 *
 * Personal access token scopes: users.phone.update
 */
export const changePhone = <ThrowOnError extends boolean = false>(options: Options<ChangePhoneData, ThrowOnError>) => (options.client ?? client).patch<ChangePhoneResponses, ChangePhoneErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/profile/phone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate consumer address
 *
 * Permissions for S2S authorization: users.write.addresses
 */
export const validateAddress = <ThrowOnError extends boolean = false>(options?: Options<ValidateAddressData, ThrowOnError>) => (options?.client ?? client).post<ValidateAddressResponses, ValidateAddressErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/addresses/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Verify consumer age.
 */
export const verifyAge = <ThrowOnError extends boolean = false>(options: Options<VerifyAgeData, ThrowOnError>) => (options.client ?? client).post<VerifyAgeResponses, VerifyAgeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/av',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request promo code for authenticated consumer
 */
export const requestPromoCode = <ThrowOnError extends boolean = false>(options: Options<RequestPromoCodeData, ThrowOnError>) => (options.client ?? client).post<RequestPromoCodeResponses, RequestPromoCodeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/coupons',
    ...options
});

/**
 * Check whether the user has any complaints with `special_complaint` flag stored in the CDP
 */
export const getComplaints = <ThrowOnError extends boolean = false>(options: Options<GetComplaintsData, ThrowOnError>) => (options.client ?? client).get<GetComplaintsResponses, GetComplaintsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/complaints',
    ...options
});

/**
 * Get a list of active sessions from user
 */
export const getSessions = <ThrowOnError extends boolean = false>(options: Options<GetSessionsData, ThrowOnError>) => (options.client ?? client).get<GetSessionsResponses, GetSessionsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/sessions',
    ...options
});

/**
 * Get user profile
 *
 * Personal access token scopes: users.profile.get
 */
export const getProfile = <ThrowOnError extends boolean = false>(options: Options<GetProfileData, ThrowOnError>) => (options.client ?? client).get<GetProfileResponses, GetProfileErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/profile',
    ...options
});

/**
 * Update user profile
 *
 * Permissions for S2S authorization: users.write
 * Personal access token scopes: users.profile.update
 */
export const updateProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateProfileData, ThrowOnError>) => (options.client ?? client).post<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generates a wallet pass
 *
 * Permissions for S2S authorization: users-wallets
 */
export const generateWalletPass = <ThrowOnError extends boolean = false>(options: Options<GenerateWalletPassData, ThrowOnError>) => (options.client ?? client).post<GenerateWalletPassResponses, GenerateWalletPassErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/profile/wallet',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Anonymize a single consumer.
 *
 * @deprecated
 */
export const anonymizeConsumer = <ThrowOnError extends boolean = false>(options: Options<AnonymizeConsumerData, ThrowOnError>) => (options.client ?? client).post<AnonymizeConsumerResponses, AnonymizeConsumerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/cancel',
    ...options
});

/**
 * Delete (anonymize) user's profile
 */
export const deleteProfile = <ThrowOnError extends boolean = false>(options?: Options<DeleteProfileData, ThrowOnError>) => (options?.client ?? client).delete<DeleteProfileResponses, DeleteProfileErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users',
    ...options
});

/**
 * List of consumers for reporting purposes.
 *
 * Permissions for S2S authorization: users-reporting.read
 */
export const consumersReport = <ThrowOnError extends boolean = false>(options?: Options<ConsumersReportData, ThrowOnError>) => (options?.client ?? client).get<ConsumersReportResponses, ConsumersReportErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users',
    ...options
});

/**
 * Verify phone or email.
 *
 * Personal access token scopes: users.phone_or_email.verify
 */
export const verifyPhoneOrEmail = <ThrowOnError extends boolean = false>(options: Options<VerifyPhoneOrEmailData, ThrowOnError>) => (options.client ?? client).get<VerifyPhoneOrEmailResponses, VerifyPhoneOrEmailErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/verify/{phone_or_email}',
    ...options
});

/**
 * Change consumer email
 *
 * Permissions for S2S authorization: users.write
 *
 * Personal access token scopes: users.email.update
 */
export const changeConsumerEmail = <ThrowOnError extends boolean = false>(options?: Options<ChangeConsumerEmailData, ThrowOnError>) => (options?.client ?? client).patch<ChangeConsumerEmailResponses, ChangeConsumerEmailErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/profile/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Request the user's data.
 */
export const dataSubjectAccessRequest = <ThrowOnError extends boolean = false>(options?: Options<DataSubjectAccessRequestData, ThrowOnError>) => (options?.client ?? client).post<DataSubjectAccessRequestResponses, DataSubjectAccessRequestErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/privacy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Update consumer custom attributes
 *
 * Update custom attributes for authenticated consumer
 *
 * Permissions for S2S authorization: users.write
 * Personal access token scopes: users.custom_attributes.update
 */
export const updateCustomAttributes = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomAttributesData, ThrowOnError>) => (options.client ?? client).patch<UpdateCustomAttributesResponses, UpdateCustomAttributesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/custom-attributes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete consumer custom attribute
 *
 * Delete custom attribute for authenticated consumer
 *
 * Permissions for S2S authorization: users.write
 */
export const deleteCustomAttribute = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomAttributeData, ThrowOnError>) => (options.client ?? client).delete<DeleteCustomAttributeResponses, DeleteCustomAttributeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/custom-attributes/{customAttribute}',
    ...options
});

/**
 * Update consumer custom attribute
 *
 * Update custom attribute for authenticated consumer
 *
 * Permissions for S2S authorization: users.write
 * Personal access token scopes: users.custom_attributes.update
 */
export const updateCustomAttribute = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomAttributeData, ThrowOnError>) => (options.client ?? client).put<UpdateCustomAttributeResponses, UpdateCustomAttributeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/custom-attributes/{customAttribute}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the purposes for the requested context including if the user confirmed
 * or rejected them.
 *
 * Permissions for S2S authorization: users.consents
 * Personal access token scopes: users.consents.get
 */
export const getUsersConsents = <ThrowOnError extends boolean = false>(options: Options<GetUsersConsentsData, ThrowOnError>) => (options.client ?? client).get<GetUsersConsentsResponses, GetUsersConsentsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/consents',
    ...options
});

/**
 * Update consumer consents
 *
 * Update consents for authenticated consumer
 *
 * Permissions for S2S authorization: users.consents
 * Personal access token scopes: users.consents.update
 *
 * @deprecated
 */
export const deprecatedUpdateConsents = <ThrowOnError extends boolean = false>(options: Options<DeprecatedUpdateConsentsData, ThrowOnError>) => (options.client ?? client).patch<DeprecatedUpdateConsentsResponses, DeprecatedUpdateConsentsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/consents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign consumer referrer
 *
 * Permissions for S2S authorization: users.referrals
 */
export const assignReferrer = <ThrowOnError extends boolean = false>(options: Options<AssignReferrerData, ThrowOnError>) => (options.client ?? client).patch<AssignReferrerResponses, AssignReferrerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/profile/referrer-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of incumbent profiles for reporting
 *
 * Permissions for S2S authorization: users.read
 */
export const getIncumbentProfiles = <ThrowOnError extends boolean = false>(options?: Options<GetIncumbentProfilesData, ThrowOnError>) => (options?.client ?? client).get<GetIncumbentProfilesResponses, GetIncumbentProfilesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/incumbent-profiles',
    ...options
});

/**
 * Streams a wallet pass for download
 */
export const streamedWalletPass = <ThrowOnError extends boolean = false>(options: Options<StreamedWalletPassData, ThrowOnError>) => (options.client ?? client).get<StreamedWalletPassResponses, StreamedWalletPassErrors, ThrowOnError>({
    security: [{ name: 'X-DES-TENANT', type: 'apiKey' }, {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }],
    url: '/api/users/{uuid}/wallets/{walletProvider}/stream',
    ...options
});

/**
 * Process a list of profiles that come from CDP.
 */
export const processAnonymizedCdpProfiles = <ThrowOnError extends boolean = false>(options?: Options<ProcessAnonymizedCdpProfilesData, ThrowOnError>) => (options?.client ?? client).post<ProcessAnonymizedCdpProfilesResponses, ProcessAnonymizedCdpProfilesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Register offline action and set has_first_referrer_purchase flag to user if applicable
 *
 * Permissions for S2S authorization: users.referrals
 */
export const referralsRegisterOfflineAction = <ThrowOnError extends boolean = false>(options?: Options<ReferralsRegisterOfflineActionData, ThrowOnError>) => (options?.client ?? client).post<ReferralsRegisterOfflineActionResponses, ReferralsRegisterOfflineActionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/referrals/register-offline-action',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Endpoint to get available purposes to be viewed in the frontend.
 */
export const getAvailableConsents = <ThrowOnError extends boolean = false>(options: Options<GetAvailableConsentsData, ThrowOnError>) => (options.client ?? client).get<GetAvailableConsentsResponses, GetAvailableConsentsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/consents',
    ...options
});

/**
 * Deactivate a single consumer.
 *
 * Permissions for S2S authorization: users.deactivate
 */
export const deactivateConsumer = <ThrowOnError extends boolean = false>(options: Options<DeactivateConsumerData, ThrowOnError>) => (options.client ?? client).post<DeactivateConsumerResponses, DeactivateConsumerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/deactivate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List of acquisition sources for reporting purposes.
 *
 * Permissions for S2S authorization: users-reporting.read
 */
export const acquisitionSourcesReport = <ThrowOnError extends boolean = false>(options?: Options<AcquisitionSourcesReportData, ThrowOnError>) => (options?.client ?? client).get<AcquisitionSourcesReportResponses, AcquisitionSourcesReportErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/acquisition-sources',
    ...options
});

/**
 * Update user full profile
 *
 * Permissions for S2S authorization: users.write
 */
export const updateFullProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateFullProfileData, ThrowOnError>) => (options.client ?? client).patch<UpdateFullProfileResponses, UpdateFullProfileErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/full-profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update user full profile
 *
 * @deprecated
 */
export const deprecatedUpdateFullProfile = <ThrowOnError extends boolean = false>(options: Options<DeprecatedUpdateFullProfileData, ThrowOnError>) => (options.client ?? client).put<DeprecatedUpdateFullProfileResponses, DeprecatedUpdateFullProfileErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/full-profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Anonymize batch of consumers.
 *
 * Permissions for S2S authorization: users.anonymize
 */
export const anonymizeConsumers = <ThrowOnError extends boolean = false>(options?: Options<AnonymizeConsumersData, ThrowOnError>) => (options?.client ?? client).post<AnonymizeConsumersResponses, AnonymizeConsumersErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/consumers/anonymize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Anonymize a single consumer manually.
 *
 * Permissions for S2S authorization: users.anonymize
 *
 * @deprecated
 */
export const anonymizeConsumerManually = <ThrowOnError extends boolean = false>(options: Options<AnonymizeConsumerManuallyData, ThrowOnError>) => (options.client ?? client).post<AnonymizeConsumerManuallyResponses, AnonymizeConsumerManuallyErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/anonymize',
    ...options
});

/**
 * Unlocks consumer's login if it is locked out due to reaching failed login attempts
 *
 * Permissions for S2S authorization: users.unlock
 */
export const unlockConsumerLogin = <ThrowOnError extends boolean = false>(options: Options<UnlockConsumerLoginData, ThrowOnError>) => (options.client ?? client).post<UnlockConsumerLoginResponses, UnlockConsumerLoginErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/unlock',
    ...options
});

/**
 * [S2S] List consumer deactivations
 *
 * Returns consumer deactivations (permanent and temporary, active and expired).
 *
 * Permissions for S2S authorization: users.read
 */
export const listConsumerDeactivations = <ThrowOnError extends boolean = false>(options?: Options<ListConsumerDeactivationsData, ThrowOnError>) => (options?.client ?? client).get<ListConsumerDeactivationsResponses, ListConsumerDeactivationsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/s2s/users/deactivations',
    ...options
});

/**
 * [S2S] Get user profile
 *
 * Permissions for S2S authorization: unreachable.because.legacy, users.read
 */
export const getProfileForService = <ThrowOnError extends boolean = false>(options: Options<GetProfileForServiceData, ThrowOnError>) => (options.client ?? client).get<GetProfileForServiceResponses, GetProfileForServiceErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/s2s/users/{uuid}',
    ...options
});

/**
 * Activate a single consumer.
 *
 * Permissions for S2S authorization: users.activate
 */
export const activateConsumer = <ThrowOnError extends boolean = false>(options: Options<ActivateConsumerData, ThrowOnError>) => (options.client ?? client).post<ActivateConsumerResponses, ActivateConsumerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark batch of consumers as external age-verified.
 *
 * Permissions for S2S authorization: users.write
 */
export const markConsumersAsExternalAgeVerified = <ThrowOnError extends boolean = false>(options?: Options<MarkConsumersAsExternalAgeVerifiedData, ThrowOnError>) => (options?.client ?? client).post<MarkConsumersAsExternalAgeVerifiedResponses, MarkConsumersAsExternalAgeVerifiedErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/mark-external-age-verified',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Process a kakao unlink request.
 */
export const processKakaoUnlinkRequest = <ThrowOnError extends boolean = false>(options?: Options<ProcessKakaoUnlinkRequestData, ThrowOnError>) => (options?.client ?? client).post<ProcessKakaoUnlinkRequestResponses, ProcessKakaoUnlinkRequestErrors, ThrowOnError>({
    url: '/webhooks/users/authentication/kakao/callback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Generate new coupons in a bulk way and create a new batch
 */
export const generateBulkCoupons = <ThrowOnError extends boolean = false>(options?: Options<GenerateBulkCouponsData, ThrowOnError>) => (options?.client ?? client).post<GenerateBulkCouponsResponses, GenerateBulkCouponsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/coupons/bulk/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retrieve generated coupons for existing batch (one-time operation per batch)
 */
export const getBulkCouponBatch = <ThrowOnError extends boolean = false>(options: Options<GetBulkCouponBatchData, ThrowOnError>) => (options.client ?? client).get<GetBulkCouponBatchResponses, GetBulkCouponBatchErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/coupons/bulk/generate/{batch_id}',
    ...options
});

/**
 * Retrieve batch status of previously generated coupons
 */
export const getBulkCouponBatchStatus = <ThrowOnError extends boolean = false>(options: Options<GetBulkCouponBatchStatusData, ThrowOnError>) => (options.client ?? client).get<GetBulkCouponBatchStatusResponses, GetBulkCouponBatchStatusErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/coupons/bulk/generate/{batch_id}/status',
    ...options
});

/**
 * Get a list of available external providers.
 */
export const getExternalProviders = <ThrowOnError extends boolean = false>(options: Options<GetExternalProvidersData, ThrowOnError>) => (options.client ?? client).get<GetExternalProvidersResponses, GetExternalProvidersErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/coupons/external/providers/{country}',
    ...options
});

/**
 * Generate a single coupon
 *
 * Permissions for S2S authorization: coupons
 */
export const generateSingleCoupon = <ThrowOnError extends boolean = false>(options?: Options<GenerateSingleCouponData, ThrowOnError>) => (options?.client ?? client).post<GenerateSingleCouponResponses, GenerateSingleCouponErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/coupons/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retrieve all users assigned to a coupon
 *
 * Permissions for S2S authorization: coupons
 */
export const listCouponUsers = <ThrowOnError extends boolean = false>(options: Options<ListCouponUsersData, ThrowOnError>) => (options.client ?? client).get<ListCouponUsersResponses, ListCouponUsersErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/coupons/{code}/users',
    ...options
});

/**
 * Global Webhook to generate a new coupon
 */
export const createCouponGenerationWebhook = <ThrowOnError extends boolean = false>(options?: Options<CreateCouponGenerationWebhookData, ThrowOnError>) => (options?.client ?? client).post<CreateCouponGenerationWebhookResponses, CreateCouponGenerationWebhookErrors, ThrowOnError>({
    security: [{ name: 'X-DES-SIGNATURE', type: 'apiKey' }],
    url: '/api/coupons/global-webhooks/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get an external coupon.
 */
export const requestExternalCoupon = <ThrowOnError extends boolean = false>(options: Options<RequestExternalCouponData, ThrowOnError>) => (options.client ?? client).post<RequestExternalCouponResponses, RequestExternalCouponErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/coupons/external/providers/{provider}/request',
    ...options
});

/**
 * Request an external coupon.
 *
 * Permissions for S2S authorization: coupons.external.request
 */
export const serviceRequestExternalCoupon = <ThrowOnError extends boolean = false>(options: Options<ServiceRequestExternalCouponData, ThrowOnError>) => (options.client ?? client).post<ServiceRequestExternalCouponResponses, ServiceRequestExternalCouponErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/services/coupons/external/providers/{provider}/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register and activate a YGG brand-change webhook.
 *
 * Permissions for S2S authorization: coupons.external.webhook.create
 */
export const createYggWebhook = <ThrowOnError extends boolean = false>(options?: Options<CreateYggWebhookData, ThrowOnError>) => (options?.client ?? client).post<CreateYggWebhookResponses, CreateYggWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/services/coupons/external/providers/ygg/webhook',
    ...options
});

/**
 * Force a resync of external provider rewards into Open Loyalty.
 *
 * Permissions for S2S authorization: coupons.external.rewards.write
 */
export const syncExternalRewards = <ThrowOnError extends boolean = false>(options?: Options<SyncExternalRewardsData, ThrowOnError>) => (options?.client ?? client).post<SyncExternalRewardsResponses, SyncExternalRewardsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/services/coupons/external/providers/ygg/sync-rewards',
    ...options
});

/**
 * Receive a reward-updated webhook from any external provider.
 */
export const externalProviderRewardUpdated = <ThrowOnError extends boolean = false>(options: Options<ExternalProviderRewardUpdatedData, ThrowOnError>) => (options.client ?? client).post<ExternalProviderRewardUpdatedResponses, ExternalProviderRewardUpdatedErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'YGAG-Webhook-Signature', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/external-providers/{provider}/reward-updated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the Activity Logs
 *
 * Permissions for S2S authorization: monitoring.activity_log
 */
export const listActivityLogs = <ThrowOnError extends boolean = false>(options?: Options<ListActivityLogsData, ThrowOnError>) => (options?.client ?? client).get<ListActivityLogsResponses, ListActivityLogsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' }],
    url: '/api/monitoring/activity-log',
    ...options
});

/**
 * View the health check results.
 *
 * Permissions for S2S authorization: monitoring.health-checks.index
 */
export const getHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<GetHealthCheckData, ThrowOnError>) => (options?.client ?? client).get<GetHealthCheckResponses, GetHealthCheckErrors, ThrowOnError>({
    security: [{ name: 'X-DES-STATIC-TOKEN', type: 'apiKey' }],
    url: '/api/healthcheck',
    ...options
});

/**
 * View the tenant health check results.
 *
 * Permissions for S2S authorization: monitoring.health-checks.index
 */
export const getTenantHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<GetTenantHealthCheckData, ThrowOnError>) => (options?.client ?? client).get<GetTenantHealthCheckResponses, GetTenantHealthCheckErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/tenant-healthcheck',
    ...options
});

/**
 * Import new Magento order or update existing order
 *
 * Permissions for S2S authorization: orders.store
 */
export const importMagentoOrder = <ThrowOnError extends boolean = false>(options?: Options<ImportMagentoOrderData, ThrowOnError>) => (options?.client ?? client).post<ImportMagentoOrderResponses, ImportMagentoOrderErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Export list of orders
 *
 * Permissions for S2S authorization: orders.export
 */
export const getOrders = <ThrowOnError extends boolean = false>(options?: Options<GetOrdersData, ThrowOnError>) => (options?.client ?? client).get<GetOrdersResponses, GetOrdersErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders',
    ...options
});

/**
 * Store new offline order
 *
 * Permissions for S2S authorization: orders.store
 */
export const storeOfflineOrder = <ThrowOnError extends boolean = false>(options?: Options<StoreOfflineOrderData, ThrowOnError>) => (options?.client ?? client).post<StoreOfflineOrderResponses, StoreOfflineOrderErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get consumer invoice
 *
 * Get the invoice of a consumer that belongs to the specified order. The returned link is valid for one day (24h).
 *
 * Permissions for S2S authorization: orders.export
 */
export const getInvoice = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceData, ThrowOnError>) => (options.client ?? client).get<GetInvoiceResponses, GetInvoiceErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/users/{uuid}/orders/{orderId}/invoice',
    ...options
});

/**
 * Create new order in Magento
 *
 * Permissions for S2S authorization: orders
 */
export const createOrder = <ThrowOnError extends boolean = false>(options?: Options<CreateOrderData, ThrowOnError>) => (options?.client ?? client).post<CreateOrderResponses, CreateOrderErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create new order cancellation request
 */
export const createCancellationRequest = <ThrowOnError extends boolean = false>(options?: Options<CreateCancellationRequestData, ThrowOnError>) => (options?.client ?? client).post<CreateCancellationRequestResponses, CreateCancellationRequestErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/request-cancellation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List order withdraws
 *
 * Permissions for S2S authorization: orders.export
 */
export const listWithdraws = <ThrowOnError extends boolean = false>(options?: Options<ListWithdrawsData, ThrowOnError>) => (options?.client ?? client).get<ListWithdrawsResponses, ListWithdrawsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/withdraws',
    ...options
});

/**
 * Request order withdraw
 */
export const createWithdraw = <ThrowOnError extends boolean = false>(options?: Options<CreateWithdrawData, ThrowOnError>) => (options?.client ?? client).post<CreateWithdrawResponses, CreateWithdrawErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/withdraws',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete order withdraw
 *
 * Permissions for S2S authorization: orders.update
 */
export const deleteWithdraw = <ThrowOnError extends boolean = false>(options: Options<DeleteWithdrawData, ThrowOnError>) => (options.client ?? client).delete<DeleteWithdrawResponses, DeleteWithdrawErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/withdraws/{order_id}',
    ...options
});

/**
 * Get a single order withdrawal
 *
 * Permissions for S2S authorization: orders.export
 */
export const getWithdraw = <ThrowOnError extends boolean = false>(options: Options<GetWithdrawData, ThrowOnError>) => (options.client ?? client).get<GetWithdrawResponses, GetWithdrawErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/withdraws/{order_id}',
    ...options
});

/**
 * List the authenticated consumer orders that are eligible for withdrawal
 */
export const getWithdrawCandidates = <ThrowOnError extends boolean = false>(options?: Options<GetWithdrawCandidatesData, ThrowOnError>) => (options?.client ?? client).get<GetWithdrawCandidatesResponses, GetWithdrawCandidatesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/withdraws/candidates',
    ...options
});

/**
 * Check if withdrawal is available for an order
 *
 * Permissions for S2S authorization: orders.update
 */
export const isWithdrawEligible = <ThrowOnError extends boolean = false>(options: Options<IsWithdrawEligibleData, ThrowOnError>) => (options.client ?? client).get<IsWithdrawEligibleResponses, IsWithdrawEligibleErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/withdraws/{order_id}/is-eligible',
    ...options
});

/**
 * Get single order
 *
 * Permissions for S2S authorization: orders.export
 */
export const getOrder = <ThrowOnError extends boolean = false>(options: Options<GetOrderData, ThrowOnError>) => (options.client ?? client).get<GetOrderResponses, GetOrderErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/{order_id}',
    ...options
});

/**
 * Update order shipping information
 *
 * Permissions for S2S authorization: orders.update
 */
export const updateShipping = <ThrowOnError extends boolean = false>(options: Options<UpdateShippingData, ThrowOnError>) => (options.client ?? client).post<UpdateShippingResponses, UpdateShippingErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/{order_id}/shipping-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update order status
 *
 * Permissions for S2S authorization: orders.update
 */
export const updateOrderStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderStatusData, ThrowOnError>) => (options.client ?? client).post<UpdateOrderStatusResponses, UpdateOrderStatusErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/{order_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update order invoice
 *
 * Permissions for S2S authorization: orders.update
 */
export const updateOrderInvoice = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderInvoiceData, ThrowOnError>) => (options.client ?? client).post<UpdateOrderInvoiceResponses, UpdateOrderInvoiceErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/{order_id}/invoice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject order
 *
 * Permissions for S2S authorization: orders.update
 */
export const rejectOrder = <ThrowOnError extends boolean = false>(options: Options<RejectOrderData, ThrowOnError>) => (options.client ?? client).post<RejectOrderResponses, RejectOrderErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/{order_id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hold order
 *
 * Permissions for S2S authorization: orders.update
 */
export const holdOrder = <ThrowOnError extends boolean = false>(options: Options<HoldOrderData, ThrowOnError>) => (options.client ?? client).post<HoldOrderResponses, HoldOrderErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/{order_id}/hold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unhold order
 *
 * Permissions for S2S authorization: orders.update
 */
export const unholdOrder = <ThrowOnError extends boolean = false>(options: Options<UnholdOrderData, ThrowOnError>) => (options.client ?? client).post<UnholdOrderResponses, UnholdOrderErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/{order_id}/unhold',
    ...options
});

/**
 * Cancel order
 *
 * Permissions for S2S authorization: orders.update
 */
export const cancelOrder = <ThrowOnError extends boolean = false>(options: Options<CancelOrderData, ThrowOnError>) => (options.client ?? client).post<CancelOrderResponses, CancelOrderErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/orders/{order_id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user's subscription
 */
export const getUserSubscription = <ThrowOnError extends boolean = false>(options?: Options<GetUserSubscriptionData, ThrowOnError>) => (options?.client ?? client).get<GetUserSubscriptionResponses, GetUserSubscriptionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/user',
    ...options
});

/**
 * Subscription configurations
 */
export const getSubscriptionConfiguration = <ThrowOnError extends boolean = false>(options?: Options<GetSubscriptionConfigurationData, ThrowOnError>) => (options?.client ?? client).get<GetSubscriptionConfigurationResponses, GetSubscriptionConfigurationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/configurations',
    ...options
});

/**
 * Create new subscription
 *
 * Permissions for S2S authorization: subscriptions
 */
export const createSubscription = <ThrowOnError extends boolean = false>(options?: Options<CreateSubscriptionData, ThrowOnError>) => (options?.client ?? client).post<CreateSubscriptionResponses, CreateSubscriptionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Check if consumer is eligible for subscription
 *
 * Permissions for S2S authorization: subscriptions
 */
export const isConsumerEligibleForSubscriptions = <ThrowOnError extends boolean = false>(options: Options<IsConsumerEligibleForSubscriptionsData, ThrowOnError>) => (options.client ?? client).get<IsConsumerEligibleForSubscriptionsResponses, IsConsumerEligibleForSubscriptionsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/is-eligible/consumer/{consumer_id}',
    ...options
});

/**
 * Check if shipping address is eligible for removal
 *
 * Permissions for S2S authorization: subscriptions
 */
export const isShippingAddressEligibleForRemoval = <ThrowOnError extends boolean = false>(options: Options<IsShippingAddressEligibleForRemovalData, ThrowOnError>) => (options.client ?? client).get<IsShippingAddressEligibleForRemovalResponses, IsShippingAddressEligibleForRemovalErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/is-eligible/shipping-address/{address_id}',
    ...options
});

/**
 * Update subscription charge
 *
 * Permissions for S2S authorization: subscriptions
 */
export const updateSubscriptionCharge = <ThrowOnError extends boolean = false>(options: Options<UpdateSubscriptionChargeData, ThrowOnError>) => (options.client ?? client).put<UpdateSubscriptionChargeResponses, UpdateSubscriptionChargeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/{uuid}/charge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get subscription events
 *
 * Permissions for S2S authorization: subscriptions
 */
export const getSubscriptionEvents = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionEventsData, ThrowOnError>) => (options.client ?? client).get<GetSubscriptionEventsResponses, GetSubscriptionEventsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/{uuid}/events',
    ...options
});

/**
 * Update subscription status
 *
 * Permissions for S2S authorization: subscriptions
 */
export const updateSubscriptionStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateSubscriptionStatusData, ThrowOnError>) => (options.client ?? client).put<UpdateSubscriptionStatusResponses, UpdateSubscriptionStatusErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/{uuid}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List consumer subscriptions
 *
 * Permissions for S2S authorization: subscriptions
 */
export const listConsumerSubscriptions = <ThrowOnError extends boolean = false>(options: Options<ListConsumerSubscriptionsData, ThrowOnError>) => (options.client ?? client).get<ListConsumerSubscriptionsResponses, ListConsumerSubscriptionsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/consumer/{consumer_id}',
    ...options
});

/**
 * Get consumer subscription
 *
 * Permissions for S2S authorization: subscriptions
 */
export const getConsumerSubscription = <ThrowOnError extends boolean = false>(options: Options<GetConsumerSubscriptionData, ThrowOnError>) => (options.client ?? client).get<GetConsumerSubscriptionResponses, GetConsumerSubscriptionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/{uuid}',
    ...options
});

/**
 * Update subscription
 *
 * Permissions for S2S authorization: subscriptions
 */
export const updateSubscription = <ThrowOnError extends boolean = false>(options: Options<UpdateSubscriptionData, ThrowOnError>) => (options.client ?? client).put<UpdateSubscriptionResponses, UpdateSubscriptionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel subscription
 *
 * Permissions for S2S authorization: subscriptions
 */
export const cancelSubscription = <ThrowOnError extends boolean = false>(options: Options<CancelSubscriptionData, ThrowOnError>) => (options.client ?? client).put<CancelSubscriptionResponses, CancelSubscriptionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/{uuid}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pause subscription
 *
 * Permissions for S2S authorization: subscriptions
 */
export const updateSubscriptionToPause = <ThrowOnError extends boolean = false>(options: Options<UpdateSubscriptionToPauseData, ThrowOnError>) => (options.client ?? client).put<UpdateSubscriptionToPauseResponses, UpdateSubscriptionToPauseErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/{uuid}/pause',
    ...options
});

/**
 * Resume subscription
 *
 * Permissions for S2S authorization: subscriptions
 */
export const updateSubscriptionToResume = <ThrowOnError extends boolean = false>(options: Options<UpdateSubscriptionToResumeData, ThrowOnError>) => (options.client ?? client).put<UpdateSubscriptionToResumeResponses, UpdateSubscriptionToResumeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/subscriptions/{uuid}/resume',
    ...options
});

/**
 * Checks if customer is eligible for trial program
 *
 * Permissions for S2S authorization: trials
 */
export const isEligibleForTrial = <ThrowOnError extends boolean = false>(options: Options<IsEligibleForTrialData, ThrowOnError>) => (options.client ?? client).get<IsEligibleForTrialResponses, IsEligibleForTrialErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/trials/is-eligible/{program}/{consumer}',
    ...options
});

/**
 * List trials
 *
 * Permissions for S2S authorization: trials
 */
export const listTrials = <ThrowOnError extends boolean = false>(options?: Options<ListTrialsData, ThrowOnError>) => (options?.client ?? client).get<ListTrialsResponses, ListTrialsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/trials',
    ...options
});

/**
 * Update trial
 *
 * Permissions for S2S authorization: trials
 */
export const updateTrial = <ThrowOnError extends boolean = false>(options: Options<UpdateTrialData, ThrowOnError>) => (options.client ?? client).put<UpdateTrialResponses, UpdateTrialErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/trials/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of actions
 *
 * Permissions for S2S authorization: leads
 */
export const listActions = <ThrowOnError extends boolean = false>(options?: Options<ListActionsData, ThrowOnError>) => (options?.client ?? client).get<ListActionsResponses, ListActionsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions',
    ...options
});

/**
 * Store new action
 *
 * Permissions for S2S authorization: leads
 */
export const createAction = <ThrowOnError extends boolean = false>(options?: Options<CreateActionData, ThrowOnError>) => (options?.client ?? client).post<CreateActionResponses, CreateActionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create new device registration action
 *
 * Permissions for S2S authorization: leads
 */
export const createDeviceRegistrationAction = <ThrowOnError extends boolean = false>(options?: Options<CreateDeviceRegistrationActionData, ThrowOnError>) => (options?.client ?? client).post<CreateDeviceRegistrationActionResponses, CreateDeviceRegistrationActionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/devices/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create new order action
 *
 * Permissions for S2S authorization: leads
 */
export const createOrderAction = <ThrowOnError extends boolean = false>(options?: Options<CreateOrderActionData, ThrowOnError>) => (options?.client ?? client).post<CreateOrderActionResponses, CreateOrderActionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Cancel lending
 *
 * Permissions for S2S authorization: trials
 */
export const cancelLending = <ThrowOnError extends boolean = false>(options?: Options<CancelLendingData, ThrowOnError>) => (options?.client ?? client).delete<CancelLendingResponses, CancelLendingErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/lending',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Store new lending
 *
 * Permissions for S2S authorization: trials
 */
export const storeLending = <ThrowOnError extends boolean = false>(options?: Options<StoreLendingData, ThrowOnError>) => (options?.client ?? client).post<StoreLendingResponses, StoreLendingErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/lending',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get list of lendings for export
 *
 * Permissions for S2S authorization: trials
 */
export const exportLendings = <ThrowOnError extends boolean = false>(options?: Options<ExportLendingsData, ThrowOnError>) => (options?.client ?? client).get<ExportLendingsResponses, ExportLendingsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/lending/export',
    ...options
});

/**
 * Show single lending
 *
 * Permissions for S2S authorization: trials
 */
export const showLending = <ThrowOnError extends boolean = false>(options: Options<ShowLendingData, ThrowOnError>) => (options.client ?? client).get<ShowLendingResponses, ShowLendingErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/lending/{uuid}',
    ...options
});

/**
 * Update lending
 *
 * Permissions for S2S authorization: trials
 */
export const updateLending = <ThrowOnError extends boolean = false>(options: Options<UpdateLendingData, ThrowOnError>) => (options.client ?? client).put<UpdateLendingResponses, UpdateLendingErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/lending/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get single action
 *
 * Permissions for S2S authorization: leads
 */
export const getAction = <ThrowOnError extends boolean = false>(options: Options<GetActionData, ThrowOnError>) => (options.client ?? client).get<GetActionResponses, GetActionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/{uuid}',
    ...options
});

/**
 * Update single action
 *
 * Permissions for S2S authorization: leads
 */
export const updateAction = <ThrowOnError extends boolean = false>(options: Options<UpdateActionData, ThrowOnError>) => (options.client ?? client).put<UpdateActionResponses, UpdateActionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Store guided trial
 *
 * Permissions for S2S authorization: leads
 */
export const storeGuidedTrial = <ThrowOnError extends boolean = false>(options?: Options<StoreGuidedTrialData, ThrowOnError>) => (options?.client ?? client).post<StoreGuidedTrialResponses, StoreGuidedTrialErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/actions/guided_trial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List of leads
 *
 * Permissions for S2S authorization: leads
 */
export const listLeads = <ThrowOnError extends boolean = false>(options?: Options<ListLeadsData, ThrowOnError>) => (options?.client ?? client).get<ListLeadsResponses, ListLeadsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads',
    ...options
});

/**
 * Create new lead
 *
 * Permissions for S2S authorization: leads
 */
export const createLead = <ThrowOnError extends boolean = false>(options?: Options<CreateLeadData, ThrowOnError>) => (options?.client ?? client).post<CreateLeadResponses, CreateLeadErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Trigger double opt-in
 *
 * Permissions for S2S authorization: leads
 */
export const triggerDoi = <ThrowOnError extends boolean = false>(options: Options<TriggerDoiData, ThrowOnError>) => (options.client ?? client).post<TriggerDoiResponses, TriggerDoiErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/{identifier}/retrigger-doi',
    ...options
});

/**
 * Cancel a lead by provided Lead UUID or email or phone
 *
 * Permissions for S2S authorization: leads
 *
 * @deprecated
 */
export const cancelLead = <ThrowOnError extends boolean = false>(options: Options<CancelLeadData, ThrowOnError>) => (options.client ?? client).delete<CancelLeadResponses, CancelLeadErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/{identifier}',
    ...options
});

/**
 * Get single lead
 *
 * Permissions for S2S authorization: leads
 */
export const getLead = <ThrowOnError extends boolean = false>(options: Options<GetLeadData, ThrowOnError>) => (options.client ?? client).get<GetLeadResponses, GetLeadErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/{identifier}',
    ...options
});

/**
 * Update single lead
 *
 * Permissions for S2S authorization: leads
 */
export const updateLead = <ThrowOnError extends boolean = false>(options: Options<UpdateLeadData, ThrowOnError>) => (options.client ?? client).patch<UpdateLeadResponses, UpdateLeadErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/{identifier}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Store source of business record for lead
 *
 * Permissions for S2S authorization: leads
 */
export const storeSourceOfBusiness = <ThrowOnError extends boolean = false>(options: Options<StoreSourceOfBusinessData, ThrowOnError>) => (options.client ?? client).post<StoreSourceOfBusinessResponses, StoreSourceOfBusinessErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/{identifier}/source_of_business',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify a double opt-in consent
 *
 * Validate and record a double opt-in consent identified by the hash provided in the URL
 */
export const verifyConsent = <ThrowOnError extends boolean = false>(options: Options<VerifyConsentData, ThrowOnError>) => (options.client ?? client).post<VerifyConsentResponses, VerifyConsentErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/consents/validate/{hash}',
    ...options
});

/**
 * List purchase actions
 *
 * List purchase actions for authenticated consumer (lead)
 */
export const listPurchases = <ThrowOnError extends boolean = false>(options: Options<ListPurchasesData, ThrowOnError>) => (options.client ?? client).get<ListPurchasesResponses, ListPurchasesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/{uuid}/actions/purchase',
    ...options
});

/**
 * Get purchase action
 *
 * Get purchase action for authenticated consumer (lead) by action uuid
 */
export const getPurchase = <ThrowOnError extends boolean = false>(options: Options<GetPurchaseData, ThrowOnError>) => (options.client ?? client).get<GetPurchaseResponses, GetPurchaseErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/leads/{uuid}/actions/purchase/{actionUuid}',
    ...options
});

/**
 * Deactivates consumer in loyalty
 *
 * Permissions for S2S authorization: loyalty-consumers.write
 */
export const deactivateConsumerInLoyalty = <ThrowOnError extends boolean = false>(options: Options<DeactivateConsumerInLoyaltyData, ThrowOnError>) => (options.client ?? client).delete<DeactivateConsumerInLoyaltyResponses, DeactivateConsumerInLoyaltyErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}',
    ...options
});

/**
 * Get consumer loyalty profile via s2s
 *
 * Permissions for S2S authorization: loyalty-consumers.read
 */
export const getConsumerLoyaltyProfileS2S = <ThrowOnError extends boolean = false>(options: Options<GetConsumerLoyaltyProfileS2sData, ThrowOnError>) => (options.client ?? client).get<GetConsumerLoyaltyProfileS2sResponses, GetConsumerLoyaltyProfileS2sErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}',
    ...options
});

/**
 * Activates consumer in loyalty
 *
 * Permissions for S2S authorization: loyalty-consumers.write
 */
export const activateConsumerInLoyalty = <ThrowOnError extends boolean = false>(options: Options<ActivateConsumerInLoyaltyData, ThrowOnError>) => (options.client ?? client).post<ActivateConsumerInLoyaltyResponses, ActivateConsumerInLoyaltyErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}',
    ...options
});

/**
 * Get consumer network points
 *
 * Permissions for S2S authorization: loyalty-points.read
 */
export const getConsumerNetworkPoints = <ThrowOnError extends boolean = false>(options: Options<GetConsumerNetworkPointsData, ThrowOnError>) => (options.client ?? client).get<GetConsumerNetworkPointsResponses, GetConsumerNetworkPointsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}/points',
    ...options
});

/**
 * Initialize adding points to consumer
 *
 * Permissions for S2S authorization: loyalty-points.write
 */
export const initializeAddingConsumerPointsByType = <ThrowOnError extends boolean = false>(options: Options<InitializeAddingConsumerPointsByTypeData, ThrowOnError>) => (options.client ?? client).post<InitializeAddingConsumerPointsByTypeResponses, InitializeAddingConsumerPointsByTypeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}/points',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Increase consumer points
 *
 * Permissions for S2S authorization: loyalty-points.write
 */
export const increaseConsumerPoints = <ThrowOnError extends boolean = false>(options: Options<IncreaseConsumerPointsData, ThrowOnError>) => (options.client ?? client).post<IncreaseConsumerPointsResponses, IncreaseConsumerPointsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}/points/increase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decrease consumer points
 *
 * Permissions for S2S authorization: loyalty-points.write
 */
export const decreaseConsumerPoints = <ThrowOnError extends boolean = false>(options: Options<DecreaseConsumerPointsData, ThrowOnError>) => (options.client ?? client).post<DecreaseConsumerPointsResponses, DecreaseConsumerPointsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}/points/decrease',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger events for many consumers
 *
 * Permissions for S2S authorization: loyalty-points.write
 */
export const initializeBulkEvents = <ThrowOnError extends boolean = false>(options?: Options<InitializeBulkEventsData, ThrowOnError>) => (options?.client ?? client).post<InitializeBulkEventsResponses, InitializeBulkEventsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/points',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get list of consumer rewards
 *
 * Permissions for S2S authorization: loyalty-rewards.read
 */
export const getConsumerRewards = <ThrowOnError extends boolean = false>(options: Options<GetConsumerRewardsData, ThrowOnError>) => (options.client ?? client).get<GetConsumerRewardsResponses, GetConsumerRewardsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}/rewards',
    ...options
});

/**
 * Get list of consumer eligible rewards
 *
 * Permissions for S2S authorization: loyalty-rewards.read
 */
export const getConsumerEligibleRewardsForService = <ThrowOnError extends boolean = false>(options: Options<GetConsumerEligibleRewardsForServiceData, ThrowOnError>) => (options.client ?? client).post<GetConsumerEligibleRewardsForServiceResponses, GetConsumerEligibleRewardsForServiceErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}/rewards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check the reward is eligible for consumer
 *
 * Permissions for S2S authorization: loyalty-rewards.read
 */
export const checkRewardEligibilityController = <ThrowOnError extends boolean = false>(options: Options<CheckRewardEligibilityControllerData, ThrowOnError>) => (options.client ?? client).post<CheckRewardEligibilityControllerResponses, CheckRewardEligibilityControllerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}/reward/{reward_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Redeem reward
 *
 * Permissions for S2S authorization: loyalty-rewards.write
 */
export const getRedeemReward = <ThrowOnError extends boolean = false>(options: Options<GetRedeemRewardData, ThrowOnError>) => (options.client ?? client).post<GetRedeemRewardResponses, GetRedeemRewardErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}/reward',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get consumer tier level via s2s
 *
 * Permissions for S2S authorization: loyalty-consumers.read
 */
export const getConsumerTierS2S = <ThrowOnError extends boolean = false>(options: Options<GetConsumerTierS2sData, ThrowOnError>) => (options.client ?? client).get<GetConsumerTierS2sResponses, GetConsumerTierS2sErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/consumers/{uuid}/tier',
    ...options
});

/**
 * Get list of tiers
 *
 * Permissions for S2S authorization: loyalty-tiers.read
 */
export const getTiersService = <ThrowOnError extends boolean = false>(options?: Options<GetTiersServiceData, ThrowOnError>) => (options?.client ?? client).get<GetTiersServiceResponses, GetTiersServiceErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/tiers',
    ...options
});

/**
 * Increase coupons to the reward
 *
 * Permissions for S2S authorization: loyalty-rewards.write
 */
export const increaseCouponsToReward = <ThrowOnError extends boolean = false>(options: Options<IncreaseCouponsToRewardData, ThrowOnError>) => (options.client ?? client).put<IncreaseCouponsToRewardResponses, IncreaseCouponsToRewardErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/reward/{reward_uuid}/coupons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List of reward consumers
 *
 * Permissions for S2S authorization: loyalty-rewards.read
 */
export const listRewardConsumers = <ThrowOnError extends boolean = false>(options: Options<ListRewardConsumersData, ThrowOnError>) => (options.client ?? client).get<ListRewardConsumersResponses, ListRewardConsumersErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/reward/{reward_uuid}/consumers',
    ...options
});

/**
 * Update reward redemption status for many redemptions
 *
 * Permissions for S2S authorization: loyalty-rewards.write
 */
export const updateRewardRedemptionsStatus = <ThrowOnError extends boolean = false>(options?: Options<UpdateRewardRedemptionsStatusData, ThrowOnError>) => (options?.client ?? client).post<UpdateRewardRedemptionsStatusResponses, UpdateRewardRedemptionsStatusErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/redemptions/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Sync rewards from OpenLoyalty into the local rewards storage.
 *
 * Permissions for S2S authorization: loyalty-rewards.write
 */
export const syncOpenLoyaltyRewards = <ThrowOnError extends boolean = false>(options?: Options<SyncOpenLoyaltyRewardsData, ThrowOnError>) => (options?.client ?? client).post<SyncOpenLoyaltyRewardsResponses, SyncOpenLoyaltyRewardsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/rewards/sync',
    ...options
});

/**
 * Invalidate translation cache on LOY side (translations used for messaging purposes).
 *
 * Permissions for S2S authorization: loyalty-consumers.write
 */
export const invalidateTranslationsCache = <ThrowOnError extends boolean = false>(options?: Options<InvalidateTranslationsCacheData, ThrowOnError>) => (options?.client ?? client).delete<InvalidateTranslationsCacheResponses, InvalidateTranslationsCacheErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/services/cache/translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets loyalty public domain configuration
 */
export const getLoyaltyPublicDomainConfiguration = <ThrowOnError extends boolean = false>(options?: Options<GetLoyaltyPublicDomainConfigurationData, ThrowOnError>) => (options?.client ?? client).get<GetLoyaltyPublicDomainConfigurationResponses, GetLoyaltyPublicDomainConfigurationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/configuration',
    ...options
});

/**
 * Get list of tiers
 */
export const getTiers = <ThrowOnError extends boolean = false>(options?: Options<GetTiersData, ThrowOnError>) => (options?.client ?? client).get<GetTiersResponses, GetTiersErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/tiers',
    ...options
});

/**
 * Get consumer points history
 *
 * Permissions for S2S authorization: loyalty-points.read
 */
export const getConsumerPointsHistory = <ThrowOnError extends boolean = false>(options: Options<GetConsumerPointsHistoryData, ThrowOnError>) => (options.client ?? client).get<GetConsumerPointsHistoryResponses, GetConsumerPointsHistoryErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/points',
    ...options
});

/**
 * Get consumer redeem reward
 */
export const getConsumerReward = <ThrowOnError extends boolean = false>(options: Options<GetConsumerRewardData, ThrowOnError>) => (options.client ?? client).get<GetConsumerRewardResponses, GetConsumerRewardErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/reward/{reward_uuid}',
    ...options
});

/**
 * Get consumer loyalty profile
 */
export const getConsumerLoyaltyProfile = <ThrowOnError extends boolean = false>(options: Options<GetConsumerLoyaltyProfileData, ThrowOnError>) => (options.client ?? client).get<GetConsumerLoyaltyProfileResponses, GetConsumerLoyaltyProfileErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}',
    ...options
});

/**
 * List consumer earnings - articles, products
 */
export const getEarningsForConsumer = <ThrowOnError extends boolean = false>(options: Options<GetEarningsForConsumerData, ThrowOnError>) => (options.client ?? client).get<GetEarningsForConsumerResponses, GetEarningsForConsumerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/earnings',
    ...options
});

/**
 * Get QR Code details
 */
export const getQrCodeDetails = <ThrowOnError extends boolean = false>(options: Options<GetQrCodeDetailsData, ThrowOnError>) => (options.client ?? client).get<GetQrCodeDetailsResponses, GetQrCodeDetailsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/earnings/qr-code/{id}',
    ...options
});

/**
 * Get consumer order
 */
export const getConsumerOrder = <ThrowOnError extends boolean = false>(options: Options<GetConsumerOrderData, ThrowOnError>) => (options.client ?? client).get<GetConsumerOrderResponses, GetConsumerOrderErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/orders/{order_id}',
    ...options
});

/**
 * Get available surveys for specific consumer (surveys which are configured, valid and the consumer hasn't started them yet)
 */
export const getAvailableSurveysForConsumer = <ThrowOnError extends boolean = false>(options: Options<GetAvailableSurveysForConsumerData, ThrowOnError>) => (options.client ?? client).get<GetAvailableSurveysForConsumerResponses, GetAvailableSurveysForConsumerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/surveys',
    ...options
});

/**
 * Get consumer survey status
 */
export const getConsumerSurveyStatus = <ThrowOnError extends boolean = false>(options: Options<GetConsumerSurveyStatusData, ThrowOnError>) => (options.client ?? client).get<GetConsumerSurveyStatusResponses, GetConsumerSurveyStatusErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/survey/{survey_id}/status',
    ...options
});

/**
 * Get consumer tier level
 */
export const getConsumerTier = <ThrowOnError extends boolean = false>(options: Options<GetConsumerTierData, ThrowOnError>) => (options.client ?? client).get<GetConsumerTierResponses, GetConsumerTierErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/tier',
    ...options
});

/**
 * Get reward detail.
 */
export const getReward = <ThrowOnError extends boolean = false>(options: Options<GetRewardData, ThrowOnError>) => (options.client ?? client).get<GetRewardResponses, GetRewardErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/reward/{reward_uuid}',
    ...options
});

/**
 * List rewards - campaigns and prizes
 */
export const listRewards = <ThrowOnError extends boolean = false>(options?: Options<ListRewardsData, ThrowOnError>) => (options?.client ?? client).get<ListRewardsResponses, ListRewardsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/rewards',
    ...options
});

/**
 * Get available reward filters - categories, points range and tiers
 */
export const listRewardFilters = <ThrowOnError extends boolean = false>(options?: Options<ListRewardFiltersData, ThrowOnError>) => (options?.client ?? client).get<ListRewardFiltersResponses, ListRewardFiltersErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/rewards/filters',
    ...options
});

/**
 * List earnings - articles or product
 */
export const listEarnings = <ThrowOnError extends boolean = false>(options?: Options<ListEarningsData, ThrowOnError>) => (options?.client ?? client).get<ListEarningsResponses, ListEarningsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/earnings',
    ...options
});

/**
 * Trigger article read
 */
export const updateArticleRead = <ThrowOnError extends boolean = false>(options: Options<UpdateArticleReadData, ThrowOnError>) => (options.client ?? client).post<UpdateArticleReadResponses, UpdateArticleReadErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/earnings/article',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger video has been watched to earn some points
 */
export const updateVideoWatched = <ThrowOnError extends boolean = false>(options: Options<UpdateVideoWatchedData, ThrowOnError>) => (options.client ?? client).post<UpdateVideoWatchedResponses, UpdateVideoWatchedErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/earnings/video',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger quiz has been completed to earn some points
 */
export const updateQuizCompleted = <ThrowOnError extends boolean = false>(options: Options<UpdateQuizCompletedData, ThrowOnError>) => (options.client ?? client).post<UpdateQuizCompletedResponses, UpdateQuizCompletedErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/earnings/quiz',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger QR code read
 */
export const getQrCodeRead = <ThrowOnError extends boolean = false>(options: Options<GetQrCodeReadData, ThrowOnError>) => (options.client ?? client).post<GetQrCodeReadResponses, GetQrCodeReadErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/earnings/qr-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Buy prize for consumer
 */
export const getBuyPrize = <ThrowOnError extends boolean = false>(options: Options<GetBuyPrizeData, ThrowOnError>) => (options.client ?? client).post<GetBuyPrizeResponses, GetBuyPrizeErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/reward',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of consumer rewards (campaigns or prizes)
 */
export const getConsumerRewardsCampaignsOrPrizes = <ThrowOnError extends boolean = false>(options: Options<GetConsumerRewardsCampaignsOrPrizesData, ThrowOnError>) => (options.client ?? client).get<GetConsumerRewardsCampaignsOrPrizesResponses, GetConsumerRewardsCampaignsOrPrizesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/rewards',
    ...options
});

/**
 * Get list of consumer eligible rewards
 */
export const getConsumerEligibleRewards = <ThrowOnError extends boolean = false>(options: Options<GetConsumerEligibleRewardsData, ThrowOnError>) => (options.client ?? client).post<GetConsumerEligibleRewardsResponses, GetConsumerEligibleRewardsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/rewards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get consumer achievements
 */
export const getAchievements = <ThrowOnError extends boolean = false>(options: Options<GetAchievementsData, ThrowOnError>) => (options.client ?? client).get<GetAchievementsResponses, GetAchievementsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/achievements',
    ...options
});

/**
 * Consumer survey started
 */
export const initializeConsumerSurveyStartedController = <ThrowOnError extends boolean = false>(options: Options<InitializeConsumerSurveyStartedControllerData, ThrowOnError>) => (options.client ?? client).post<InitializeConsumerSurveyStartedControllerResponses, InitializeConsumerSurveyStartedControllerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/survey/{survey_id}/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pre-check validation if specific consumer can start the survey with valid device code
 */
export const validateConsumerCanStartSurveyController = <ThrowOnError extends boolean = false>(options: Options<ValidateConsumerCanStartSurveyControllerData, ThrowOnError>) => (options.client ?? client).post<ValidateConsumerCanStartSurveyControllerResponses, ValidateConsumerCanStartSurveyControllerErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/survey/{survey_id}/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create contest
 */
export const createContest = <ThrowOnError extends boolean = false>(options: Options<CreateContestData, ThrowOnError>) => (options.client ?? client).post<CreateContestResponses, CreateContestErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/contests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get contest status
 */
export const getContestStatus = <ThrowOnError extends boolean = false>(options: Options<GetContestStatusData, ThrowOnError>) => (options.client ?? client).get<GetContestStatusResponses, GetContestStatusErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/contests/status',
    ...options
});

/**
 * List rewards - campaigns and prizes under specific consumer context with additional consumer data like redeemed_times
 */
export const listRewardsExtended = <ThrowOnError extends boolean = false>(options: Options<ListRewardsExtendedData, ThrowOnError>) => (options.client ?? client).get<ListRewardsExtendedResponses, ListRewardsExtendedErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/rewards-extended',
    ...options
});

/**
 * Get reward detail under specific consumer context with additional consumer data like redeemed_times.
 */
export const getRewardExtended = <ThrowOnError extends boolean = false>(options: Options<GetRewardExtendedData, ThrowOnError>) => (options.client ?? client).get<GetRewardExtendedResponses, GetRewardExtendedErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/rewards-extended/{reward_uuid}',
    ...options
});

/**
 * Get earning rule by event name
 *
 * Permissions for S2S authorization: loyalty-earnings.read
 */
export const getEarningRuleByName = <ThrowOnError extends boolean = false>(options: Options<GetEarningRuleByNameData, ThrowOnError>) => (options.client ?? client).get<GetEarningRuleByNameResponses, GetEarningRuleByNameErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-RECAPTCHA-TOKEN', type: 'apiKey' },
        { name: 'X-SKIP-RECAPTCHA', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/loyalty/consumers/{uuid}/earning-rule/{event_name}',
    ...options
});

/**
 * Handles Open Loyalty incoming webhook event when consumer level changed
 */
export const updateLevelChangedWebhook = <ThrowOnError extends boolean = false>(options?: Options<UpdateLevelChangedWebhookData, ThrowOnError>) => (options?.client ?? client).post<UpdateLevelChangedWebhookResponses, UpdateLevelChangedWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-OPEN-LOYALTY-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/level-changed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handles Open Loyalty incoming webhook event when consumer available points amount has changed
 */
export const updatePointsChangedWebhook = <ThrowOnError extends boolean = false>(options?: Options<UpdatePointsChangedWebhookData, ThrowOnError>) => (options?.client ?? client).post<UpdatePointsChangedWebhookResponses, UpdatePointsChangedWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-OPEN-LOYALTY-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/points-changed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handles Open Loyalty incoming webhook event when consumer unit transfer has been added
 */
export const createTransferWebhook = <ThrowOnError extends boolean = false>(options?: Options<CreateTransferWebhookData, ThrowOnError>) => (options?.client ?? client).post<CreateTransferWebhookResponses, CreateTransferWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-OPEN-LOYALTY-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/transfer-created',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handles Open Loyalty incoming webhook event when consumer redeemed reward
 */
export const createRewardRedeemedWebhook = <ThrowOnError extends boolean = false>(options?: Options<CreateRewardRedeemedWebhookData, ThrowOnError>) => (options?.client ?? client).post<CreateRewardRedeemedWebhookResponses, CreateRewardRedeemedWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-OPEN-LOYALTY-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/reward-redeemed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handles Open Loyalty incoming webhook event when reward redemption status has changed
 */
export const updateRewardRedemptionStatusChangedWebhook = <ThrowOnError extends boolean = false>(options?: Options<UpdateRewardRedemptionStatusChangedWebhookData, ThrowOnError>) => (options?.client ?? client).post<UpdateRewardRedemptionStatusChangedWebhookResponses, UpdateRewardRedemptionStatusChangedWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-OPEN-LOYALTY-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/reward-redemption-status-changed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handles Open Loyalty incoming webhook event when reward is created
 */
export const createRewardWebhook = <ThrowOnError extends boolean = false>(options?: Options<CreateRewardWebhookData, ThrowOnError>) => (options?.client ?? client).post<CreateRewardWebhookResponses, CreateRewardWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-OPEN-LOYALTY-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/reward-created',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handles Open Loyalty incoming webhook event when reward is updated
 */
export const updateRewardWebhook = <ThrowOnError extends boolean = false>(options?: Options<UpdateRewardWebhookData, ThrowOnError>) => (options?.client ?? client).post<UpdateRewardWebhookResponses, UpdateRewardWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-OPEN-LOYALTY-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/reward-updated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handles Open Loyalty incoming webhook event when reward is deleted
 */
export const deleteRewardWebhook = <ThrowOnError extends boolean = false>(options?: Options<DeleteRewardWebhookData, ThrowOnError>) => (options?.client ?? client).post<DeleteRewardWebhookResponses, DeleteRewardWebhookErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-OPEN-LOYALTY-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/webhooks/reward-deleted',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get list of Offline Campaign
 *
 * Permissions for S2S authorization: offline-campaigns.read
 */
export const listOfflineCampaigns = <ThrowOnError extends boolean = false>(options?: Options<ListOfflineCampaignsData, ThrowOnError>) => (options?.client ?? client).get<ListOfflineCampaignsResponses, ListOfflineCampaignsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/campaigns',
    ...options
});

/**
 * Create Offline Campaign
 *
 * Permissions for S2S authorization: offline-campaigns.write
 */
export const createOfflineCampaign = <ThrowOnError extends boolean = false>(options?: Options<CreateOfflineCampaignData, ThrowOnError>) => (options?.client ?? client).post<CreateOfflineCampaignResponses, CreateOfflineCampaignErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/campaigns',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete Offline Campaign
 *
 * Permissions for S2S authorization: offline-campaigns.write
 */
export const deleteOfflineCampaign = <ThrowOnError extends boolean = false>(options: Options<DeleteOfflineCampaignData, ThrowOnError>) => (options.client ?? client).delete<DeleteOfflineCampaignResponses, DeleteOfflineCampaignErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/campaigns/{uuid}',
    ...options
});

/**
 * Get Offline Campaign
 *
 * Permissions for S2S authorization: offline-campaigns.read
 */
export const getOfflineCampaign = <ThrowOnError extends boolean = false>(options: Options<GetOfflineCampaignData, ThrowOnError>) => (options.client ?? client).get<GetOfflineCampaignResponses, GetOfflineCampaignErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/campaigns/{uuid}',
    ...options
});

/**
 * Update Offline Campaign
 *
 * Permissions for S2S authorization: offline-campaigns.write
 */
export const updateOfflineCampaign = <ThrowOnError extends boolean = false>(options: Options<UpdateOfflineCampaignData, ThrowOnError>) => (options.client ?? client).put<UpdateOfflineCampaignResponses, UpdateOfflineCampaignErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/campaigns/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of Offline Campaign Cupons
 *
 * Permissions for S2S authorization: offline-campaigns.read
 */
export const listOfflineCampaignCupons = <ThrowOnError extends boolean = false>(options?: Options<ListOfflineCampaignCuponsData, ThrowOnError>) => (options?.client ?? client).get<ListOfflineCampaignCuponsResponses, ListOfflineCampaignCuponsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/coupons',
    ...options
});

/**
 * Create Offline Campaign Coupon
 *
 * Permissions for S2S authorization: offline-campaigns.write
 */
export const createOfflineCampaignCoupon = <ThrowOnError extends boolean = false>(options?: Options<CreateOfflineCampaignCouponData, ThrowOnError>) => (options?.client ?? client).post<CreateOfflineCampaignCouponResponses, CreateOfflineCampaignCouponErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/coupons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete Offline Campaign Coupon
 *
 * Permissions for S2S authorization: offline-campaigns.write
 */
export const deleteOfflineCampaignCoupon = <ThrowOnError extends boolean = false>(options: Options<DeleteOfflineCampaignCouponData, ThrowOnError>) => (options.client ?? client).delete<DeleteOfflineCampaignCouponResponses, DeleteOfflineCampaignCouponErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/coupons/{uuid}',
    ...options
});

/**
 * Get Offline Campaign Coupon
 *
 * Permissions for S2S authorization: offline-campaigns.read
 */
export const getOfflineCampaignCoupon = <ThrowOnError extends boolean = false>(options: Options<GetOfflineCampaignCouponData, ThrowOnError>) => (options.client ?? client).get<GetOfflineCampaignCouponResponses, GetOfflineCampaignCouponErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/coupons/{uuid}',
    ...options
});

/**
 * Update Offline Campaign Coupon
 *
 * Permissions for S2S authorization: offline-campaigns.write
 */
export const updateOfflineCampaignCoupon = <ThrowOnError extends boolean = false>(options: Options<UpdateOfflineCampaignCouponData, ThrowOnError>) => (options.client ?? client).put<UpdateOfflineCampaignCouponResponses, UpdateOfflineCampaignCouponErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/coupons/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import Offline Campaign Coupons
 *
 * Permissions for S2S authorization: offline-campaigns.write
 */
export const importOfflineCampaignCoupons = <ThrowOnError extends boolean = false>(options: Options<ImportOfflineCampaignCouponsData, ThrowOnError>) => (options.client ?? client).post<ImportOfflineCampaignCouponsResponses, ImportOfflineCampaignCouponsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/offline-campaigns/campaigns/{uuid}/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webhook to burn a coupon based on an event and source.
 */
export const updateBurnOfflineCampaignCouponWebhook = <ThrowOnError extends boolean = false>(options?: Options<UpdateBurnOfflineCampaignCouponWebhookData, ThrowOnError>) => (options?.client ?? client).post<UpdateBurnOfflineCampaignCouponWebhookResponses, UpdateBurnOfflineCampaignCouponWebhookErrors, ThrowOnError>({
    security: [{ name: 'X-DES-SIGNATURE', type: 'apiKey' }],
    url: '/webhooks/burn-offline-campaign-coupon',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Webhook to burn a coupon when a user registered in CAS.
 *
 * @deprecated
 */
export const registerCasConsumerWebhook = <ThrowOnError extends boolean = false>(options?: Options<RegisterCasConsumerWebhookData, ThrowOnError>) => (options?.client ?? client).post<RegisterCasConsumerWebhookResponses, RegisterCasConsumerWebhookErrors, ThrowOnError>({
    security: [{ name: 'X-DES-SIGNATURE', type: 'apiKey' }],
    url: '/webhooks/cas-register-consumer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get user submissions
 */
export const getQuizzesUserSubmissions = <ThrowOnError extends boolean = false>(options: Options<GetQuizzesUserSubmissionsData, ThrowOnError>) => (options.client ?? client).get<GetQuizzesUserSubmissionsResponses, GetQuizzesUserSubmissionsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/quizzes/by-user/{userUuid}',
    ...options
});

/**
 * Create user submission
 */
export const createQuizzesUserSubmission = <ThrowOnError extends boolean = false>(options: Options<CreateQuizzesUserSubmissionData, ThrowOnError>) => (options.client ?? client).post<CreateQuizzesUserSubmissionResponses, CreateQuizzesUserSubmissionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/quizzes/by-user/{userUuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all workgroup-tenant mappings for the current tenant.
 *
 * Permissions for S2S authorization: survey-monkey
 */
export const surveyMonkeyGetTenantWorkgroups = <ThrowOnError extends boolean = false>(options?: Options<SurveyMonkeyGetTenantWorkgroupsData, ThrowOnError>) => (options?.client ?? client).get<SurveyMonkeyGetTenantWorkgroupsResponses, SurveyMonkeyGetTenantWorkgroupsErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/survey-monkey/tenant-workgroups',
    ...options
});

/**
 * Assign a workgroup to the current tenant.
 *
 * Permissions for S2S authorization: survey-monkey
 */
export const surveyMonkeyAssignWorkgroupToTenant = <ThrowOnError extends boolean = false>(options?: Options<SurveyMonkeyAssignWorkgroupToTenantData, ThrowOnError>) => (options?.client ?? client).post<SurveyMonkeyAssignWorkgroupToTenantResponses, SurveyMonkeyAssignWorkgroupToTenantErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/survey-monkey/tenant-workgroups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Remove a workgroup-tenant mapping.
 *
 * Permissions for S2S authorization: survey-monkey
 */
export const surveyMonkeyRemoveWorkgroupFromTenant = <ThrowOnError extends boolean = false>(options: Options<SurveyMonkeyRemoveWorkgroupFromTenantData, ThrowOnError>) => (options.client ?? client).delete<SurveyMonkeyRemoveWorkgroupFromTenantResponses, SurveyMonkeyRemoveWorkgroupFromTenantErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/survey-monkey/tenant-workgroups/{id}',
    ...options
});

/**
 * Trigger backfill of survey responses by Survey ID.
 *
 * Queues an async job to fetch responses from SurveyMonkey API and save to CDP.
 * Supports optional filtering by date range and/or specific response IDs.
 *
 * Permissions for S2S authorization: survey-monkey
 */
export const surveyMonkeyBackfillSurveyResponses = <ThrowOnError extends boolean = false>(options?: Options<SurveyMonkeyBackfillSurveyResponsesData, ThrowOnError>) => (options?.client ?? client).post<SurveyMonkeyBackfillSurveyResponsesResponses, SurveyMonkeyBackfillSurveyResponsesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/survey-monkey/responses/backfill',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Manually fetch survey responses by Survey ID over an explicit from–to period.
 *
 * Runs synchronously (blocking): dispatches the FetchSurveyResponsesJob on the
 * current request and waits for it to complete before returning. This is the
 * manual last-resort fetch for an explicit date range, intended for admin use.
 *
 * Permissions for S2S authorization: survey-monkey
 */
export const surveyMonkeyFetchSurveyResponses = <ThrowOnError extends boolean = false>(options?: Options<SurveyMonkeyFetchSurveyResponsesData, ThrowOnError>) => (options?.client ?? client).post<SurveyMonkeyFetchSurveyResponsesResponses, SurveyMonkeyFetchSurveyResponsesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/survey-monkey/responses/fetch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handle SurveyMonkey response_completed webhook.
 *
 * Receives notification when a survey response is completed.
 * HEAD requests are used by SurveyMonkey for webhook URL verification.
 */
export const surveyMonkeyResponseCompletedWebhook = <ThrowOnError extends boolean = false>(options: Options<SurveyMonkeyResponseCompletedWebhookData, ThrowOnError>) => (options.client ?? client).post<SurveyMonkeyResponseCompletedWebhookResponses, SurveyMonkeyResponseCompletedWebhookErrors, ThrowOnError>({
    url: '/webhooks/survey-monkey/{tenantCode}/response-completed/{surveyId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle SurveyMonkey collector_created webhook.
 *
 * Receives notification when a new collector is created for a survey.
 * HEAD requests are used by SurveyMonkey for webhook URL verification.
 */
export const surveyMonkeyCollectorCreatedWebhook = <ThrowOnError extends boolean = false>(options: Options<SurveyMonkeyCollectorCreatedWebhookData, ThrowOnError>) => (options.client ?? client).post<SurveyMonkeyCollectorCreatedWebhookResponses, SurveyMonkeyCollectorCreatedWebhookErrors, ThrowOnError>({
    url: '/webhooks/survey-monkey/{tenantCode}/collector-created/{surveyId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle SurveyMonkey collector_updated webhook.
 *
 * Receives notification when a collector is updated for a survey.
 * HEAD requests are used by SurveyMonkey for webhook URL verification.
 */
export const surveyMonkeyCollectorUpdatedWebhook = <ThrowOnError extends boolean = false>(options: Options<SurveyMonkeyCollectorUpdatedWebhookData, ThrowOnError>) => (options.client ?? client).post<SurveyMonkeyCollectorUpdatedWebhookResponses, SurveyMonkeyCollectorUpdatedWebhookErrors, ThrowOnError>({
    url: '/webhooks/survey-monkey/{tenantCode}/collector-updated/{surveyId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle SurveyMonkey survey_updated webhook.
 *
 * Receives notification when survey details are updated.
 * HEAD requests are used by SurveyMonkey for webhook URL verification.
 */
export const surveyMonkeySurveyUpdatedWebhook = <ThrowOnError extends boolean = false>(options: Options<SurveyMonkeySurveyUpdatedWebhookData, ThrowOnError>) => (options.client ?? client).post<SurveyMonkeySurveyUpdatedWebhookResponses, SurveyMonkeySurveyUpdatedWebhookErrors, ThrowOnError>({
    url: '/webhooks/survey-monkey/{tenantCode}/survey-updated/{surveyId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle SurveyMonkey survey_deleted webhook.
 *
 * Receives notification when a survey is deleted; tombstones our row so it stops syncing.
 * HEAD requests are used by SurveyMonkey for webhook URL verification.
 */
export const surveyMonkeySurveyDeletedWebhook = <ThrowOnError extends boolean = false>(options: Options<SurveyMonkeySurveyDeletedWebhookData, ThrowOnError>) => (options.client ?? client).post<SurveyMonkeySurveyDeletedWebhookResponses, SurveyMonkeySurveyDeletedWebhookErrors, ThrowOnError>({
    url: '/webhooks/survey-monkey/{tenantCode}/survey-deleted/{surveyId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle SurveyMonkey collector_deleted webhook.
 *
 * Receives notification when a collector is deleted; tombstones our row so it stops syncing.
 * HEAD requests are used by SurveyMonkey for webhook URL verification.
 */
export const surveyMonkeyCollectorDeletedWebhook = <ThrowOnError extends boolean = false>(options: Options<SurveyMonkeyCollectorDeletedWebhookData, ThrowOnError>) => (options.client ?? client).post<SurveyMonkeyCollectorDeletedWebhookResponses, SurveyMonkeyCollectorDeletedWebhookErrors, ThrowOnError>({
    url: '/webhooks/survey-monkey/{tenantCode}/collector-deleted/{surveyId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get trade in public configurations
 */
export const getTradeInPublicDomainConfiguration = <ThrowOnError extends boolean = false>(options?: Options<GetTradeInPublicDomainConfigurationData, ThrowOnError>) => (options?.client ?? client).get<GetTradeInPublicDomainConfigurationResponses, GetTradeInPublicDomainConfigurationErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/trade-in/configuration',
    ...options
});

/**
 * Create new trade-in
 *
 * Permissions for S2S authorization: trade-in.store
 */
export const createTradeIn = <ThrowOnError extends boolean = false>(options?: Options<CreateTradeInData, ThrowOnError>) => (options?.client ?? client).post<CreateTradeInResponses, CreateTradeInErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/trade-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Check if consumer is eligible for trade in
 *
 * Permissions for S2S authorization: trade_in, trade-in
 */
export const isConsumerEligibleForTradeIn = <ThrowOnError extends boolean = false>(options: Options<IsConsumerEligibleForTradeInData, ThrowOnError>) => (options.client ?? client).get<IsConsumerEligibleForTradeInResponses, IsConsumerEligibleForTradeInErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/trade-in/is-eligible/{uuid}',
    ...options
});

/**
 * LIst and filter all trade ins
 *
 * Permissions for S2S authorization: trade-in
 */
export const listAllTradeIns = <ThrowOnError extends boolean = false>(options?: Options<ListAllTradeInsData, ThrowOnError>) => (options?.client ?? client).get<ListAllTradeInsResponses, ListAllTradeInsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/trade-in/list',
    ...options
});

/**
 * Get eligible devices for trade-in
 */
export const getEligibleDevices = <ThrowOnError extends boolean = false>(options?: Options<GetEligibleDevicesData, ThrowOnError>) => (options?.client ?? client).get<GetEligibleDevicesResponses, GetEligibleDevicesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-USER-TOKEN', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/trade-in/devices',
    ...options
});

/**
 * Deletes a Promotion by UUID
 *
 * Permissions for S2S authorization: promotions
 */
export const deletePromotion = <ThrowOnError extends boolean = false>(options: Options<DeletePromotionData, ThrowOnError>) => (options.client ?? client).delete<DeletePromotionResponses, DeletePromotionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/promotions/{uuid}',
    ...options
});

/**
 * Gets a Promotion by UUID
 *
 * Permissions for S2S authorization: promotions
 */
export const getPromotion = <ThrowOnError extends boolean = false>(options: Options<GetPromotionData, ThrowOnError>) => (options.client ?? client).get<GetPromotionResponses, GetPromotionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/promotions/{uuid}',
    ...options
});

/**
 * Updates a Promotion by UUID
 *
 * Permissions for S2S authorization: promotions
 */
export const updatePromotion = <ThrowOnError extends boolean = false>(options: Options<UpdatePromotionData, ThrowOnError>) => (options.client ?? client).put<UpdatePromotionResponses, UpdatePromotionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/promotions/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the list of promotions
 *
 * Permissions for S2S authorization: promotions
 */
export const listPromotions = <ThrowOnError extends boolean = false>(options?: Options<ListPromotionsData, ThrowOnError>) => (options?.client ?? client).get<ListPromotionsResponses, ListPromotionsErrors, ThrowOnError>({
    querySerializer: { parameters: { filter: { object: { style: 'form' } } } },
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/promotions',
    ...options
});

/**
 * Stores a new Promotion
 *
 * Permissions for S2S authorization: promotions
 */
export const storePromotion = <ThrowOnError extends boolean = false>(options?: Options<StorePromotionData, ThrowOnError>) => (options?.client ?? client).post<StorePromotionResponses, StorePromotionErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/promotions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets Promotion attributes
 *
 * Permissions for S2S authorization: promotions
 */
export const listsPromotionAttributes = <ThrowOnError extends boolean = false>(options?: Options<ListsPromotionAttributesData, ThrowOnError>) => (options?.client ?? client).get<ListsPromotionAttributesResponses, ListsPromotionAttributesErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/promotions/configurations/attributes',
    ...options
});

/**
 * Update promotion sync status from an external source system
 *
 * Permissions for S2S authorization: promotions
 */
export const updatePromotionSyncStatus = <ThrowOnError extends boolean = false>(options: Options<UpdatePromotionSyncStatusData, ThrowOnError>) => (options.client ?? client).post<UpdatePromotionSyncStatusResponses, UpdatePromotionSyncStatusErrors, ThrowOnError>({
    security: [
        { name: 'X-DES-TENANT', type: 'apiKey' },
        { name: 'X-DES-ADAPTER-AK', type: 'apiKey' },
        { name: 'X-DES-ADAPTER', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        { name: 'X-DES-SERVICE-AUTHENTICATION', type: 'apiKey' },
        { name: 'X-DES-ORG-BRAND', type: 'apiKey' },
        {
            in: 'query',
            name: 'tenant_code',
            type: 'apiKey'
        }
    ],
    url: '/api/promotions/{uuid}/sync-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
